import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Accordion,
  Box,
  Flex,
  Grid,
  Group,
  Loader,
  MultiSelect,
  Popover,
  Radio,
  Select,
  Text,
  TextInput,
  Textarea,
  Tooltip,
  rem,
  Drawer,
  ActionIcon,
  Checkbox,
  Button,
} from "@mantine/core";
import { DateInput, TimeInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { TbPlus, TbTrash } from "react-icons/tb";
import { useMediaQuery } from "@mantine/hooks";
import { IconInfoCircle, IconPencil, IconTrash, IconUsers } from "@tabler/icons-react";
import { useDispatch, useSelector } from "react-redux";
import { createNote, editNote, generateAiNote, generateBothAiNotes, saveNoteDraft, getNoteDraft, deleteNoteDraft, getAllDrafts, logAiSuggestionEvent } from "../../services/note";
import { generateQuickNoteAi } from "../../services/quickNoteAi";
import { normalizeAction, trackAiSuggestionShown, trackAiSuggestionResolved, trackAiNoteFinalized } from "../../utils/pendo";
import { getAllPatientsModal } from "../../services/patient";
import {
  decrypt,
  formatDate,
  getNameFromAbbreviation,
  getOptions,
  noteType_Client,
  noteType_Client_Options,
} from "../../utils";
import useStyles from "./styles";
import { DropDownArrowSvg } from "../Svgs/DropDownArrowSvg";
import { IconChevronDown } from "@tabler/icons-react";
import { getAllFacilities, getAllFacilitiesModal } from "../../services";
import { planTypeLabels } from "../MAR/ClientSupportPlans";
import EssentialViewInfo from "./EssentialViewInfo";
import {
  Billing_Services_Note,
  Essential_Support_Note,
  Intervention_Progress_Note,
  Group_Note,
  PROGRESS_Note,
} from "../../http";
import ButtonComp from "../ButtonComponent/ButtonComp";
import { RiDeleteBin7Line } from "react-icons/ri";
import GroupedButtons from "../GroupedButtons/GroupedButtons";
import CustomModal from "../CustomModal/CustomModal";
import pendingModalIcon from "../../images/pendingModalIcon.png";
import NoteTypeComp from "../NoteTypeComp/NoteTypeComp";
import DateSvg from "../Svgs/DateSvg";
import { AiOutlineDelete } from "react-icons/ai";
import NotePendingSvg from "../Svgs/NotePendingSvg";
import ViewInfo from "./ViewInfo";
import { useSpeechToText } from "./useSpeechToText";
import RecordingControls from "./RecordingControls";
import swal from "sweetalert";
import { getSkaiTokenUsage } from "../../services/skaiTokens";
import moment from "moment";
import AiActionButtons from "./AiActionButtons";
import QuickNotesPicker from "../QuickNotesPicker";
import ComparePanel from "./ComparePanel";
import { getActivityLibrary } from "../../services/activityLibrary";
import { getDefaultPrompting } from "../../services/defaultPrompting";

const NoteDrawer = ({
  opened,
  close,
  title,
  view,
  setView,
  userId,
  noteType: NOTETYPE,
  autoRestoreDraft,
  isClientView = false,
  setOpenModal,
  setBillingServices,
  setProgressNoteState,
  progressNoteState,
  resetPatientTrigger,
  clientDetails,
  initialFacilityId,
  initialShift,
  autoGenerateActivities,
  ...data
}) => {
  // Get the current time in HH:mm:ss format
  const { sortField, sortOrder, currentPage, dateRange, activeFilters } = data;
  const { classes } = useStyles();
  const ref = useRef();
  const edit = data.data ? true : false;
  const noteT = data?.data?.noteId;
  let getEssentialSupport = data?.data?.essentialSupport;
  let getGoalsData = data?.data?.goals;
  const dispatch = useDispatch();
  const { allNotesTypes } = useSelector((state) => state?.note);
  const { allPlans } = useSelector((state) => state?.supportPlan);
  const { profile } = useSelector((state) => state.profile);
  const { allPatients } = useSelector((state) => state?.patient);
  const { facilities } = useSelector((state) => state.facility);
  const [messages, setMessages] = useState([]);

  const [errors, setErrors] = useState({});
  const [outcomeNotes, setOutcomeNotes] = useState([]);
  const [essentialNotes, setEssentialNotes] = useState([]);
  const [essentialSupportCount, setEssentialSupportCount] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [facilityDetials, setFacilityDetials] = useState(null);
  const [medicationOptions, setMedicationOptions] = useState([]);
  const [supportOptions, setSupportOptions] = useState([]);
  const [outComeTitle, setOutComeTitle] = useState([]);
  const [outcomeNumbers, setOutComeNumbers] = useState([]);
  const [essentialSupportType, setEssentialSupportType] = useState([]);
  const [essentialSupportNumber, setEssentialSupportNumber] = useState([]);
  const [noteType, setNoteType] = useState(
    noteT
      ? allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id)
      : allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE)
  );
  const [aiActionsOpen, setAiActionsOpen] = useState(false);
  // { key, getValue, setValue } — generalized so Quick Notes can insert into a
  // plain form field (main Description) or an array-item field (per-outcome/
  // per-goal descriptions), whichever textarea it was opened from.
  const [quickNotesTarget, setQuickNotesTarget] = useState(null);
  const COMPARE_PANEL_RESET = {
    open: false, action: null, context: null,
    option1: null, option2: null, loading1: false, loading2: false,
    option1Model: null, option2Model: null,
    option1WordCount: null, option2WordCount: null,
    option1LatencyMs: null, option2LatencyMs: null,
    regenerationCount: 0,
    // Actual display-slot order set by ComparePanel's onArrange callback after flip is settled
    slot1Model: null, slot2Model: null,
    ollamaAvailable: true,
  };
  const [comparePanel, setComparePanel] = useState(COMPARE_PANEL_RESET);
  // Tracks AI suggestions accepted into the note, keyed by field context, for final-save tracking
  const aiTouchedFieldsRef = useRef({});
  const [pendingModal, setPendingModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [currentNote, setCurrentNote] = useState("");
  const isMobileScreen = useMediaQuery("(max-width: 600px)");
  const [supportPlan, setSupportPlan] = useState("no");
  const [openedAccordion, setOpenedAccordion] = useState("0");
  const [essentialAccordion, setEssentialAccordion] = useState("0");
  const [essentialSupportToggle, setEssentialSupportToggle] = useState("no");
  const [interventionPlanToggle, setInterventionPlanToggle] = useState("no");

  const [serviceNumber, setServiceNumber] = useState(null);
  const icon = (
    <DropDownArrowSvg color={true} style={{ width: rem(1), height: rem(1) }} />
  );
  const [isListening, setIsListening] = useState(false);
  const [micLabel, setMicLabel] = useState(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const [recordingType, setRecordingType] = useState(null);
  const [essentialSupportErrors, setEssentialSupportErrors] = useState([]);

  const timerRef = useRef(null);

  // ── Auto-save draft ──
  const [draftStatus, setDraftStatus] = useState("idle");
  const [pendingDraft, setPendingDraft] = useState(null);
  const [draftFetching, setDraftFetching] = useState(false);
  const draftRestoredRef = useRef(false);
  const lastSavedSnapshotRef = useRef("");

  const [aiAssistantCardOpened, setAiAssistantCardOpened] = useState(false);
  const isEssentialSupport = noteType?.id === Essential_Support_Note;
  const isBilling_Services = noteType?.id === Billing_Services_Note;
  const isIntervention_Progress_Note = noteType?.id === Intervention_Progress_Note;
  const isGroupNote = noteType?.id === Group_Note;
  // Edit mode mein group note single client ki tarah behave karta hai
  const isGroupNoteCreating = isGroupNote && !edit;
  const [selectedGroupClients, setSelectedGroupClients] = useState([]);
  const initialDescription = {
    outcomeTitle: "",
    outcomeNumber: "",
    outComeCategory: "",
    description: "",
    details: null,
    error: "",
    planId: "1",
  };

  const initialEssentialSupport = {
    id: Date.now(),
    essentialSupportType: "",
    essentialActivityNumber: "",
    description: "",
  };

  const initialGoals = {
    id: Date.now(),
    goalNumber: "",
    goalNote: "",
    startTimeGoal: "",
    endTimeGoal: "",
    goalActivities: [
      { id: Date.now(), objectives: "", Intervention_Instruction: "" },
    ],
    behaviorDescription: "",
    responseDescription: "",
    planDescription: "",
  };
  const [selectedFacility, setSelectedFacility] = useState();
  const today = new Date();

  const [descriptions, setDescriptions] = useState([
    { id: 1, ...initialDescription },
  ]);

  const [essentialSupport, setEssentialSupport] = useState([
    { id: 1, ...initialEssentialSupport },
  ]);

  // Care Plan Activities should surface whenever the matching radio ("Use
  // Support Plan" / "Use Essential Support" / "Use Intervention plan") is Yes
  // AND that plan type is actually attached to the patient — not just because
  // the radio was toggled on with no real plan behind it.
  const hasActiveSupportPlan = useMemo(
    () =>
      !!allPlans?.some(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.isActive &&
          v?.planType?.name?.includes("Support Plan")
      ),
    [allPlans, selectedPatient, selectedFacility]
  );

  const hasActiveEssentialSupportPlan = useMemo(
    () =>
      !!allPlans?.some(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.isActive &&
          v?.planType?.name?.includes("Essential Supports")
      ),
    [allPlans, selectedPatient, selectedFacility]
  );

  const hasActiveInterventionPlan = useMemo(
    () =>
      !!allPlans?.some(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.isActive &&
          v?.planType?.name?.includes("Intervention")
      ),
    [allPlans, selectedPatient, selectedFacility]
  );

  const hasCarePlan =
    (supportPlan === "yes" && hasActiveSupportPlan) ||
    (essentialSupportToggle === "yes" && hasActiveEssentialSupportPlan) ||
    (interventionPlanToggle === "yes" && hasActiveInterventionPlan);

  const [goals, setGoals] = useState([{ id: 1, ...initialGoals }]);

  const { staff } = useSelector((state) => state.staff);
  const { allSignature } = useSelector((state) => state?.signature);
  const [staffDetials, setStaffDetials] = useState();
  const draftRestoringRef = useRef(false);
  React.useEffect(() => {
    // Skip reset if we're restoring a draft (otherwise this wipes the restored goals/descriptions)
    if (draftRestoringRef.current) { draftRestoringRef.current = false; return; }
    setDescriptions([{ id: 1, ...initialDescription }]);
    setEssentialSupport([{ id: 1, ...initialEssentialSupport }]);
    setGoals([{ id: 1, ...initialGoals }]);
  }, [selectedFacility]);

  useEffect(() => {
    setRecordingType(null);
  }, []);


  // Reset patient when user clicks "Add Later" in the AddEssentialNote/Billing modal
  useEffect(() => {
    if (resetPatientTrigger) {
      setSelectedPatient(null);
      setBillingServices("");
    }
  }, [resetPatientTrigger]);

  const usageData = useSelector((state) => state.skai.usageHistory);
  const [showWarning, setShowWarning] = useState(false);
  const [messageValue, setMessageValue] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [selectedSupportType, setSelectedSupportType] = useState(null);
  const [activities, setActivities] = useState([]);
  const [frequencyOptions, setFrequencyOptions] = useState([]);
  const [essentialNumber, setEssentialNumber] = useState(null);
  const [behaviorCardOpened, setBehaviorCardOpened] = useState(false);
  const [responseCardOpened, setResponseCardOpened] = useState(false);
  const [planCardOpened, setPlanCardOpened] = useState(false);
  const [behaviorLoading, setBehaviorLoading] = useState(false);
  const [responseLoading, setResponseLoading] = useState(false);
  const [planLoading, setPlanLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const selectedStateAbbr = getNameFromAbbreviation(
    selectedPatient?.form1?.state
  );

  const usageArray = Array.isArray(usageData) ? usageData : [];
  const existingRecord = usageArray.find(
    (item) =>
      item?.admin === profile?.user?.admin || item?.admin === profile?.user?.id
  );

  const checkTokenUsageWarning = (existingRecord, values) => {
    if (existingRecord?.active === false && existingRecord?.paid === false) {
      swal({
        title: "AI Note Assistant Credits Not Found",
        text: "You have not purchased any AI credits yet. Please visit the Settings page and navigate to the AI credits section to buy credits.",
        icon: "info",
        dangerMode: false,
      });

      return;
    }
    if (existingRecord?.planType === "onetime-purchase") {
      const tokensUsage = existingRecord?.adminTotalTokens;

      const totalTokens = Number(tokensUsage?.adminTotalTokens);
      const usedTokens = Number(tokensUsage?.adminUsedTokens);

      const originalTotal = totalTokens + usedTokens;

      const percentageUsed =
        originalTotal > 0 ? Math.round((usedTokens / originalTotal) * 100) : 0;

      if (percentageUsed >= 100) {
        setShowWarning(true);
        swal({
          title: "AI Note Assistant Quota Reached",
          text: "You’ve reached your monthly AI Note Assistant quota. Please contact your admin if you need additional access.",
          icon: "error",
          dangerMode: true,
        });
        return; // Do NOT allow AI usage
      }

      if (percentageUsed >= 90) {
        setShowWarning(true);
        swal({
          title: "AI Note Assistant Quota Exceeded",
          text: "You’ve used 90% of your AI Note Assistant quota for this month. Continued use may require admin approval.",
          icon: "warning",
          dangerMode: true,
        });
      }
    }
    sendMessageToOpenAI(values);
    if (values === "behavior") {
      setBehaviorCardOpened(true);
    } else if (values === "response") {
      setResponseCardOpened(true);
    } else if (values === "plan") {
      setPlanCardOpened(true);
    } else {
      setAiAssistantCardOpened(true);
    }

    setShowWarning(false);
  };

  useEffect(() => {
    getSkaiTokenUsage(profile?.user?.admin || profile?.user?.id);
  }, [profile]);

  useEffect(() => {
    getAllFacilities(1);
    // getAllSignatures();
  }, []);

  const [essentialSupportTypeState, setEssentialSupportTypeState] = useState(
    []
  );
  const [goalsAccordion, setGoalsAccordion] = useState("0");
  const [goalOptions, setGoalOptions] = useState([]);
  const [goalNumber, setGoalNumbers] = useState([]);
  const [objectivesByGoal, setObjectivesByGoal] = useState([]);
  const [interventionsByGoal, setInterventionsByGoal] = useState([]);
  const [goalItems, setGoalItems] = useState([
    [{ id: Date.now(), objectives: "", Intervention_Instruction: "" }],
  ]);

  const isAddDisabled =
    goalItems[goalItems.length - 1].length >=
    Math.min(objectivesByGoal.length, interventionsByGoal.length);

  // Add row
  const handleAddGoalItem = (index) => {
    let tempGoalItems = [...goalItems];

    tempGoalItems[index].push({
      id: Date.now(),
      objectives: "",
      Intervention_Instruction: "",
    });

    setGoalItems(tempGoalItems);
    // setGoalItems((prev) => [
    //   ...prev,
    //   { id: Date.now(), objectives: "", Intervention_Instruction: "" },
    // ]);
  };

  // Remove row
  const handleRemoveGoalItem = (id, goalIndex) => {
    const updatedGoalItems = goalItems[goalIndex].filter(
      (item) => item.id !== id
    );
    let finalGoalItems = [...goalItems];
    finalGoalItems[goalIndex] = updatedGoalItems;
    setGoalItems(finalGoalItems);
    // setGoalItems(updatedGoalItems);
    setGoals((prevGoals) =>
      prevGoals.map((goal, index) =>
        index === goalIndex
          ? { ...goal, goalActivities: updatedGoalItems }
          : goal
      )
    );
  };

  useEffect(() => {
    let outcomeTitle = [];
    let outcomeNumberArray = [];
    let essentialSupportArray = [];
    let essentialSupportNumber = [];
    let planIdToSave = null;
    let goalTitleOptions = [];
    let goalNumberOptions = [];

    if (noteType?.name === "Intervention Progress Note") {
      const filteredGoals = selectedPatient
        ? allPlans
            ?.filter(
              (v) =>
                v?.client?._id === selectedPatient?.id &&
                v?.facility?._id === selectedFacility
            )
            ?.map((v) => {
              v?.goals?.map((goal) => {
                if (edit) {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    goalTitleOptions.push({
                      value: goal?.Identified_Relevant_Attainable_Goals,
                      label: goal?.Identified_Relevant_Attainable_Goals,
                    });

                    goalNumberOptions.push({
                      value: goal?.goalNumber,
                      label: goal?.goalNumber,
                    });
                  }
                } else {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    goalTitleOptions.push({
                      value: goal?.Identified_Relevant_Attainable_Goals,
                      label: goal?.Identified_Relevant_Attainable_Goals,
                      disabled: goal.hasOwnProperty("isActive")
                        ? !goal?.isActive
                        : false,
                    });

                    goalNumberOptions.push({
                      value: goal?.goalNumber,
                      label: goal?.goalNumber,
                      disabled: goal.hasOwnProperty("isActive")
                        ? !goal?.isActive
                        : false,
                    });
                  }
                }
              });
              return v;
            })
        : [];
    } else {
      const filtered = selectedPatient
        ? allPlans
            ?.filter(
              (v) =>
                v?.client?._id === selectedPatient?.id &&
                v?.facility?._id === selectedFacility
            )
            ?.map((v) => {
              v?.outcomes?.map((vv) => {
                // If block is for edit and else block is for add
                if (edit) {
                  // Check if care plan is acive or discontinued
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    // if care plan is active then push all the outcomes
                    outcomeTitle.push({
                      value: vv?.id,
                      label: vv?.outcomeTitle,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    outcomeNumberArray.push({
                      value: vv?.id,
                      label: vv?.outcomeNumber,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });

                    if (v?.planType?.planId) {
                      planIdToSave = v?.planType?.planId;
                    }
                    // essential support details
                    if (v?.essentialSupport) {
                      if (v?.essentialSupport?.length > 0) {
                        setEssentialSupportCount(
                          v?.essentialSupport?.flatMap((_es) => _es?.activities)
                        );
                        // setEssentialSupportCount(v?.essentialSupport);
                      }
                    }
                  } else if (
                    v?.status === "discontinued" &&
                    v?.isActive === false
                  ) {
                    // if care plan is discontinued then check if one of its outcome is used while creating progress note
                    let filteredDesc = data?.data?.descriptions?.filter(
                      (_d) => _d?.outcomeNumber === vv?.id
                    );

                    if (filteredDesc?.length > 0) {
                      // if outcome is used then push the outcome
                      outcomeTitle.push({
                        value: vv?.id,
                        label: `${vv?.outcomeTitle} (D)`,
                        disabled: true,
                      });
                      outcomeNumberArray.push({
                        value: vv?.id,
                        label: `${vv?.outcomeNumber} (D)`,
                        disabled: true,
                      });
                    }
                  }
                } else {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    outcomeTitle.push({
                      value: vv?.id,
                      label: vv?.outcomeTitle,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    outcomeNumberArray.push({
                      value: vv?.id,
                      label: vv?.outcomeNumber,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    // If planType is present then save the planId to state for labels
                    if (v?.planType?.planId) {
                      planIdToSave = v?.planType?.planId;
                    }
                    // essential support details
                    if (v?.essentialSupport) {
                      if (v?.essentialSupport?.length > 0) {
                        setEssentialSupportCount(
                          v?.essentialSupport?.flatMap((_es) => _es?.activities)
                        );
                        // setEssentialSupportCount(v?.essentialSupport);
                      }
                    }

                    return v;
                  }
                }
              });

              if (
                v?.status === "active" &&
                v?.isActive === true &&
                v?.deleted !== true
              ) {
                v?.essentialSupport?.map((vv) => {
                  essentialSupportArray.push({
                    value: vv?.id,
                    label: vv?.essentialSupportType,
                  });

                  vv?.activities?.map((_a) => {
                    essentialSupportNumber.push({
                      value: _a?.id,
                      label: _a?.supportStatement,
                    });
                  });
                });
                // Get essential support types
                const getEssentialSupportTypes = Array.from(
                  new Set(
                    v?.essentialSupport?.map(
                      (item) => item.essentialSupportType
                    )
                  )
                ).filter(Boolean);

                const formatted = getEssentialSupportTypes.map((type) => ({
                  label: type,
                  value: type,
                }));
                setEssentialSupportTypeState(formatted);

                // Filter activities based on the selected support type
                const filteredData = v?.essentialSupport?.filter(
                  (item) => item.essentialSupportType === selectedSupportType
                );
                const allActivities = filteredData?.map(
                  (item) => item.activities
                );
                // setActivities(allActivities);
              }
            })
        : [];
    }
    // setObjectivesByGoal(objectivesMap);
    // setInterventionsByGoal(interventionsMap);

    setGoalOptions(goalTitleOptions);
    setGoalNumbers(goalNumberOptions);
    // setGoalActivities(goalActivitiesOptions);

    // Set the planId to the state
    if (planIdToSave) {
      // setSavePlanId(planIdToSave);
    }
    setEssentialSupportNumber(essentialSupportNumber);
    setEssentialSupportType(essentialSupportArray);
    setOutComeTitle(outcomeTitle || []);
    setOutComeNumbers(outcomeNumberArray || []);
    if (selectedPatient) {
      let serviceNumber = selectedPatient?.form1?.services?.filter(
        (i) => i?.servicenumber == data?.data?.fields["Service Type"]
      )?.[0];
      setServiceNumber(serviceNumber);
    }
  }, [selectedPatient, allPlans, selectedFacility, selectedSupportType, noteType]);

  // useEffect(() => {
  //   // essential support details
  //   allPlans
  //     ?.filter(
  //       (v) =>
  //         v?.client?._id === selectedPatient?.id &&
  //         v?.facility?._id === selectedFacility
  //     )
  //     ?.map((v) => {
  //       setOutcomesLength(v?.outcomes?.length);
  //     });
  // }, []);

  const handleSupportPlanChange = () => {
    setSupportPlan(supportPlan === "yes" ? "no" : "yes");
    setAiAssistantCardOpened(false);
    setMessages([]);
    setAiActionsOpen(false);
    setComparePanel(COMPARE_PANEL_RESET);
    form.setFieldValue("Description", "");
    descriptions[descriptions?.length - 1].description = "";
  };

  // Add New Outcome Handler
  const addDescription = (e) => {
    setAiAssistantCardOpened(false);
    handleRecordingConfirm();
    // setMessages([]);
    if (descriptions) {
      setDescriptions([
        ...descriptions,
        { id: Date.now(), ...initialDescription },
      ]);
      setOpenedAccordion(`${descriptions?.length}`);
    }
  };

  // // Add New Essential Support Handler
  const addEssentialSupport = () => {
    setAiAssistantCardOpened(false);

    handleRecordingConfirm();
    if (essentialSupport?.length < essentialSupportCount?.length) {
      setEssentialSupport([
        ...essentialSupport,
        {
          id: Date.now(),
          ...initialEssentialSupport,
        },
      ]);
      setEssentialAccordion(`${essentialSupport?.length}`);
    }
  };

  // // Add New Goal handler
  const addNewGoal = () => {
    // setAiAssistantCardOpened(false);

    // handleRecordingConfirm();
    if (goals?.length < goalOptions?.length) {
      setGoals([
        ...goals,
        {
          id: Date.now(),
          ...initialGoals,
          goalActivities: [
            { id: Date.now(), objectives: "", Intervention_Instruction: "" },
          ],
        },
      ]);
      setGoalsAccordion(`${goals?.length}`);
      setGoalItems([
        ...goalItems,
        [{ id: Date.now(), objectives: "", Intervention_Instruction: "" }],
      ]);
      setBehaviorCardOpened(false);
      setResponseCardOpened(false);
      setPlanCardOpened(false);
    }
  };

  // Remove Outcome Handler
  const removeMedication = (medicationId) => {
    setDescriptions(descriptions?.filter((med) => med.id !== medicationId));
  };

  // Remove Essential Support Handler
  const removeEssentialSupport = (medicationId) => {
    const filtered = essentialSupport?.filter((med) => {
      return med.id !== medicationId;
    });
    setEssentialSupport(filtered);
  };

  // Remove goal Handler
  const removeGoal = (Id) => {
    const filtered = goals?.filter((item) => {
      return item.id !== Id;
    });
    setGoals(filtered);
  };

  // Edit Outcome Inputs Handler
  const handleMedicationChange = (medicationId, field, value, indexx) => {
    let filteredObj = null;
    if (field === "outcomeTitle") {
      filteredObj = outComeTitle?.filter((item) => item?.value === value)?.[0];
    } else if (field === "outcomeNumber") {
      filteredObj = outcomeNumbers?.filter(
        (item) => item?.value === value
      )?.[0];
    }

    let previous = descriptions?.find(
      (v) => v?.outcomeTitle === value || v?.outcomeNumber === value
    );
    let rest = {};
    let choosenPlan = null;
    if (field === "outcomeTitle" || field === "outcomeNumber") {
      let { id, ...others } = allPlans
        ?.filter(
          (v) =>
            v?.client?._id === selectedPatient?.id &&
            v?.facility?._id === selectedFacility
        )
        ?.filter((_fp) => _fp?.outcomes?.find((_oc) => _oc?.id === value))?.[0]
        ?.outcomes?.find((v) => v?.id === value);
      rest = others;

      allPlans
        ?.filter(
          (v) =>
            v?.client?._id === selectedPatient?.id &&
            v?.facility?._id === selectedFacility
        )
        ?.map((_fp) => {
          if (_fp?.outcomes?.find((_oc) => _oc?.id === value)) {
            choosenPlan = _fp;
          }
        });
    }

    setDescriptions((prevMedications) =>
      prevMedications.map((med, index) => {
        if (index === indexx) {
          if (field !== "metGoal" && field !== "description") {
            return med?.id === medicationId
              ? {
                  ...med,
                  ...(outcomeNotes[index]?.length > 0 && {
                    description: outcomeNotes[index],
                  }),
                  [field]: value,
                  [field == "outcomeTitle" ? "outcomeNumber" : "outcomeTitle"]:
                    filteredObj?.value,
                  outComeCategory:
                    field === "outcomeTitle" || field === "outcomeNumber"
                      ? allPlans
                          ?.filter(
                            (v) =>
                              v?.client?._id === selectedPatient?.id &&
                              v?.facility?._id === selectedFacility
                          )
                          ?.filter((_fp) =>
                            _fp?.outcomes?.find((_oc) => _oc?.id === value)
                          )?.[0]
                          ?.outcomes?.find((v) => v?.id === value)
                          ?.outcomeCategory
                      : med?.outComeCategory,
                  details:
                    field === "outcomeTitle" || field === "outcomeNumber"
                      ? filterNonNullFields(rest)
                      : med?.details,
                  error: previous ? "Already Selected" : null,
                  planId: choosenPlan ? choosenPlan?.planType?.planId : "1",
                }
              : med;
          } else {
          }
          let obj = {
            ...med,
            [field]: value,
            outComeCategory:
              field === "outcomeTitle" || field === "outcomeNumber"
                ? allPlans
                    ?.filter(
                      (v) =>
                        v?.client?._id === selectedPatient?.id &&
                        v?.facility?._id === selectedFacility
                    )
                    ?.filter((_fp) =>
                      _fp?.outcomes?.find((_oc) => _oc?.id === value)
                    )?.[0]
                    ?.outcomes?.find((v) => v?.id === value)?.outcomeCategory
                : med?.outComeCategory,
            details:
              field === "outcomeTitle" || field === "outcomeNumber"
                ? filterNonNullFields(rest)
                : med?.details,
            error: previous ? "Already Selected" : null,
          };
          if (field === "outcomeTitle" || field === "outcomeNumber") {
            obj.planId = choosenPlan ? choosenPlan?.planType?.planId : "1";
          }
          return med.id === medicationId ? obj : med;
        } else {
          return med;
        }
      })
    );
    setErrors("");
  };

  const handleEssentialTypeChange = (supportId, field, value, indexx) => {
    if (field === "identifiedGoal") {
      // setGoalItems([
      //   { id: Date.now(), objectives: "", Intervention_Instruction: "" },
      // ]);
      setGoals((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId
              ? {
                  ...item,
                  [field]: value,
                  goalNumber: "",
                }
              : item;
          } else {
            return item;
          }
        })
      );
      const matchingGoal = allPlans
        ?.filter(
          (v) =>
            v?.client?._id === selectedPatient?.id &&
            v?.facility?._id === selectedFacility &&
            v?.status === "active" &&
            v?.isActive === true &&
            v?.deleted !== true
        )
        ?.flatMap((v) => v?.goals || [])
        ?.filter((_g) => _g?.Identified_Relevant_Attainable_Goals === value);

      const formattedObjectives = matchingGoal?.flatMap(
        (goal) =>
          goal?.goalActivities?.map((_ga) => ({
            label: _ga.objectives,
            value: _ga.objectives,
          })) || []
      );
      setObjectivesByGoal(
        formattedObjectives.length > 0 ? formattedObjectives : []
      );

      const formattedInterventions = matchingGoal?.flatMap(
        (goal) =>
          goal?.goalActivities?.map((_ga) => ({
            label: _ga.Intervention_Instruction,
            value: _ga.Intervention_Instruction,
          })) || []
      );
      setInterventionsByGoal(
        formattedInterventions.length > 0 ? formattedInterventions : []
      );

      let newGoalItems = [...goalItems];
      newGoalItems[indexx] = [
        {
          id: Date.now(),
          objectives: "",
          Intervention_Instruction: "",
        },
      ];
      setGoalItems(newGoalItems);
      const formattedGoalNumber = Array.from(
        new Set(matchingGoal.map((item) => item?.goalNumber).filter(Boolean))
      ).map((freq) => ({
        label: freq,
        value: freq,
      }));
      setGoals((prev) =>
        prev?.map((item, index) => {
          if (index === indexx && item.id === supportId) {
            return {
              ...item,
              goalNumber: formattedGoalNumber?.map((goal) => goal.value)[0],
            };
          }
          return item;
        })
      );
    } else {
      setEssentialSupport((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId
              ? {
                  ...item,
                  [field]: value,
                  essentialSupportType: value,
                  howOftenEssentialSupport: "", // reset on type change
                  essentialNumber: "", // reset on type change
                  essentialActivityNumber: "", // reset on type change
                }
              : item;
          } else {
            return item;
          }
        })
      );
      setSelectedSupportType(value);

      const matchingSupport = allPlans
        ?.filter(
          (v) =>
            v?.client?._id === selectedPatient?.id &&
            v?.facility?._id === selectedFacility &&
            v?.status === "active" &&
            v?.isActive === true &&
            v?.deleted !== true
        )
        ?.flatMap((v) => v?.essentialSupport || [])
        ?.filter((_es) => _es?.essentialSupportType === value);

      // ✅ Handle both old and new data structures
      // const allFrequencies =
      //   matchingSupport?.flatMap((support) => {
      //     // case 1: old structure (top-level howOftenEssentialSupport)
      //     if (support?.howOftenEssentialSupport) {
      //       return support?.howOftenEssentialSupport;
      //     }

      //     // case 2: new structure (inside activities)
      //     if (Array.isArray(support?.activities)) {
      //       return support?.activities
      //         ?.map((activity) => activity?.howOftenEssentialSupport)
      //         ?.filter(Boolean);
      //     }
      //     return [];
      //   }) || [];

      const allFrequencies =
        matchingSupport?.flatMap((support) => {
          // 1️⃣ First check inside activities
          const activityFrequencies =
            support?.activities
              ?.map((activity) => activity?.howOftenEssentialSupport)
              ?.filter(Boolean) || [];

          // 2️⃣ If found inside activities, use them
          if (activityFrequencies.length > 0) {
            return activityFrequencies;
          }

          // 3️⃣ Otherwise, fall back to top-level
          if (support?.howOftenEssentialSupport) {
            return [support?.howOftenEssentialSupport];
          }

          // 4️⃣ Default: return empty array
          return [];
        }) || [];

      const uniqueFrequencies = [...new Set(allFrequencies)];

      const formattedFrequency = uniqueFrequencies.map((freq) => ({
        label: freq,
        value: freq,
      }));

      setFrequencyOptions(
        formattedFrequency.length > 0 ? formattedFrequency : []
      );

      // ✅ Frequency is optional on the care plan — for supports of this type
      // that have no frequency set at all, surface their outcome number right
      // away instead of waiting on a frequency selection that will never come.
      const supportsWithoutFrequency = matchingSupport?.filter((support) => {
        const hasActivityFrequency = support?.activities?.some(
          (activity) => activity?.howOftenEssentialSupport
        );
        return !hasActivityFrequency && !support?.howOftenEssentialSupport;
      });

      const formattedEssentialNumbers = Array.from(
        new Set(
          supportsWithoutFrequency
            ?.map((item) => item?.essentialNumber)
            ?.filter(Boolean)
        )
      ).map((num) => ({ label: num, value: num }));
      setEssentialNumber(formattedEssentialNumbers);

      // ✅ Extract all activities from matching supports
      const allActivities =
        matchingSupport?.flatMap((support) => support?.activities || []) || [];

      // ✅ Format activities for the dropdown
      const formattedActivities = allActivities.map((activity) => ({
        supportStatement: activity?.supportStatement,
        id: activity?.id,
      }));
      setActivities(formattedActivities);
    }
  };

  const handleEssentialTypeChangeForNoteView = (value, frequency) => {
    const matchingSupport = allPlans
      ?.filter(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true
      )
      ?.flatMap((v) => v?.essentialSupport || [])
      ?.filter((_es) => _es?.essentialSupportType === value);

    if (!matchingSupport?.length) return;

    let allFrequencies = [];
    matchingSupport?.forEach((item) => {
      const foundActs = item?.activities?.filter(
        (act) =>
          act?.howOftenEssentialSupport && item?.essentialSupportType === value
      );
      if (foundActs?.length) {
        foundActs.forEach((act) =>
          allFrequencies.push(act?.howOftenEssentialSupport)
        );
      } else if (item?.howOftenEssentialSupport) {
        allFrequencies.push(item?.howOftenEssentialSupport);
      }
    });

    const formattedFrequency = Array.from(new Set(allFrequencies)).map(
      (freq) => ({ label: freq, value: freq })
    );
    setFrequencyOptions(formattedFrequency);

    const matchingFrequencySupports = matchingSupport?.filter((_es) => {
      const hasActivityMatch = _es?.activities?.some(
        (act) =>
          act?.howOftenEssentialSupport === frequency &&
          _es?.essentialSupportType === value
      );
      // Frequency is optional — supports of the same type with no frequency
      // at all should still contribute their outcome number.
      const hasNoFrequency =
        !_es?.howOftenEssentialSupport &&
        !_es?.activities?.some((act) => act?.howOftenEssentialSupport);
      return (
        hasActivityMatch ||
        _es?.howOftenEssentialSupport === frequency ||
        hasNoFrequency
      );
    });

    const formattedEssentialNumber = Array.from(
      new Set(
        matchingFrequencySupports
          ?.map((item) => item?.essentialNumber)
          ?.filter(Boolean)
      )
    ).map((num) => ({ label: num, value: num }));
    setEssentialNumber(formattedEssentialNumber);

    let relatedActivities = [];
    matchingSupport?.forEach((item) => {
      const hasNoFrequency =
        !item?.howOftenEssentialSupport &&
        !item?.activities?.some((act) => act?.howOftenEssentialSupport);

      if (hasNoFrequency && item?.essentialSupportType === value) {
        if (item?.activities?.length) {
          relatedActivities.push(...item.activities);
        } else {
          relatedActivities.push({
            ...item,
            id: item.activities?.[0]?.id || item.id,
            supportStatement:
              item.activities?.[0]?.supportStatement || item.supportStatement,
          });
        }
        return;
      }

      const foundActs = item?.activities?.filter(
        (act) =>
          act?.howOftenEssentialSupport === frequency &&
          item?.essentialSupportType === value
      );
      if (foundActs?.length) {
        relatedActivities.push(...foundActs);
      } else if (
        item?.howOftenEssentialSupport === frequency &&
        item?.essentialSupportType === value
      ) {
        relatedActivities.push({
          ...item,
          id: item.activities?.[0]?.id || item.id, // prefer activity id if available
          supportStatement:
            item.activities?.[0]?.supportStatement || item.supportStatement,
        });
      }
    });

    relatedActivities = relatedActivities.filter(
      (act, idx, self) => idx === self.findIndex((a) => a?.id === act?.id)
    );

    setActivities(relatedActivities);
  };

  const handleEssentialFrequencyChange = (supportId, field, value, indexx) => {
    setEssentialSupport((prev) =>
      prev?.map((item, index) => {
        if (index === indexx) {
          return item.id === supportId
            ? {
                ...item,
                [field]: value,
                howOftenEssentialSupport: value,
                //essentialNumber: "",
                essentialNumber: item?.essentialNumber,
                essentialActivityNumber: "",
              }
            : item;
        } else return item;
      })
    );

    const allEssentialSupports = allPlans
      ?.filter(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true
      )
      ?.flatMap((v) => v?.essentialSupport || []);

    const filteredSupports = allEssentialSupports?.filter((_es) => {
      const hasActivityMatch = _es?.activities?.some(
        (act) =>
          act?.howOftenEssentialSupport === value &&
          _es?.essentialSupportType === selectedSupportType
      );
      // Frequency is optional — supports of the same type with no frequency
      // at all should still contribute their outcome number.
      const hasNoFrequency =
        _es?.essentialSupportType === selectedSupportType &&
        !_es?.howOftenEssentialSupport &&
        !_es?.activities?.some((act) => act?.howOftenEssentialSupport);
      return (
        hasActivityMatch ||
        _es?.howOftenEssentialSupport === value ||
        hasNoFrequency
      );
    });

    const formattedEssentialNumbers = Array.from(
      new Set(
        filteredSupports?.map((item) => item?.essentialNumber).filter(Boolean)
      )
    ).map((num) => ({ label: num, value: num }));
    setEssentialNumber(formattedEssentialNumbers);

    let relatedActivities = [];
    filteredSupports?.forEach((item) => {
      const hasNoFrequency =
        !item?.howOftenEssentialSupport &&
        !item?.activities?.some((act) => act?.howOftenEssentialSupport);

      if (hasNoFrequency && item?.essentialSupportType === selectedSupportType) {
        if (item?.activities?.length) {
          relatedActivities.push(...item.activities);
        } else {
          relatedActivities.push({
            ...item,
            id: item.activities?.[0]?.id || item.id,
            supportStatement:
              item.activities?.[0]?.supportStatement || item.supportStatement,
          });
        }
        return;
      }

      const foundActs = item?.activities?.filter(
        (act) =>
          act?.howOftenEssentialSupport === value &&
          item?.essentialSupportType === selectedSupportType
      );
      if (foundActs?.length) {
        relatedActivities.push(...foundActs);
      } else if (
        item?.howOftenEssentialSupport === value &&
        item?.essentialSupportType === selectedSupportType
      ) {
        relatedActivities.push({
          ...item,
          id: item.activities?.[0]?.id || item.id, // prefer activity id if available
          supportStatement:
            item.activities?.[0]?.supportStatement || item.supportStatement,
        });
      }
    });

    relatedActivities = relatedActivities.filter(
      (act, idx, self) => idx === self.findIndex((a) => a?.id === act?.id)
    );

    setActivities(relatedActivities);
  };

  const handleEssentialNumberChange = (supportId, field, value, indexx) => {
    if (field === "goalNumber") {
      setGoals((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId
              ? {
                  ...item,
                  [field]: value,
                  goalNumber: value,
                  // essentialActivityNumber: "", // reset on type change
                }
              : item;
          } else {
            return item;
          }
        })
      );
    } else {
      setEssentialSupport((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId
              ? {
                  ...item,
                  [field]: value,
                  essentialNumber: value,
                  essentialActivityNumber: "", // reset on type change
                }
              : item;
          } else {
            return item;
          }
        })
      );
    }
  };
  const handleEssentialChange = (supportId, field, value, indexx) => {
    let filtered_plan_1 = allPlans?.filter(
      (v) =>
        v?.client?._id === selectedPatient?.id &&
        v?.facility?._id === selectedFacility &&
        v?.status === "active" &&
        v?.isActive === true &&
        v?.deleted !== true
    );

    // Find the essential support that includes this activity
    const selectedSupport = filtered_plan_1
      ?.flatMap((plan) => plan.essentialSupport || [])
      ?.find((es) => es.activities?.some((a) => a.id === value));

    const selectedActivity = selectedSupport.activities?.find(
      (a) => a.id === value
    );

    const allFrequencies = (() => {
      if (!selectedSupport) return [];

      // Case 1: Activities have their own howOftenEssentialSupport
      if (
        Array.isArray(selectedSupport?.activities) &&
        selectedSupport.activities.length > 0
      ) {
        const activityFrequencies = selectedSupport.activities
          .map((activity) => activity?.howOftenEssentialSupport)
          .filter(Boolean);

        if (activityFrequencies.length > 0) {
          return activityFrequencies;
        }
      }

      // Case 2: Top-level howOftenEssentialSupport (old structure)
      if (selectedSupport?.howOftenEssentialSupport) {
        return [selectedSupport.howOftenEssentialSupport];
      }

      return [];
    })();

    const uniqueFrequencies = [...new Set(allFrequencies)];

    const formattedFrequency = uniqueFrequencies.map((freq) => ({
      label: freq,
      value: freq,
    }));

    setFrequencyOptions(
      formattedFrequency.length > 0 ? formattedFrequency : []
    );

    // // Find the essential support that includes this activity
    // const selectedSupport = filtered_plan_1
    //   ?.flatMap((plan) => plan.essentialSupport || [])
    //   ?.find((es) => es.activities?.some((a) => a.id === value));

    // const matchingSupport = filtered_plan_1?.flatMap((v) => v?.essentialSupport || [])
    //   ?.filter((_es) => _es?.essentialSupportType === selectedSupport?.essentialSupportType);

    // const selectedActivity = selectedSupport.activities?.find(
    //   (a) => a.id === value
    // );

    // let allFrequencies = [];
    // matchingSupport?.forEach((item) => {
    //   const foundActs = item?.activities?.filter(
    //     (act) =>
    //       act?.howOftenEssentialSupport && item?.essentialSupportType === selectedSupport?.essentialSupportType
    //   );
    //   if (foundActs?.length) {
    //     foundActs.forEach((act) =>
    //       allFrequencies.push(act?.howOftenEssentialSupport)
    //     );
    //   } else if (item?.howOftenEssentialSupport) {
    //     allFrequencies.push(item?.howOftenEssentialSupport);
    //   }
    // });

    // const formattedFrequency = Array.from(new Set(allFrequencies)).map(
    //   (freq) => ({ label: freq, value: freq })
    // );
    // setFrequencyOptions(formattedFrequency);

    const finalHowOften =
      selectedActivity?.howOftenEssentialSupport ||
      selectedSupport?.howOftenEssentialSupport ||
      "";

    const formattedEssentialNumber = Array.from(
      new Set(
        filtered_plan_1
          ?.flatMap((v) => v?.essentialSupport || [])
          ?.map((item) => item?.essentialNumber)
          ?.filter(Boolean)
      )
    ).map((num) => ({ label: num, value: num }));
    setEssentialNumber(formattedEssentialNumber);

    let selectedEsType = [];

    filtered_plan_1?.forEach((_fp) => {
      _fp?.essentialSupport?.forEach((_es) => {
        if (_es?.activities?.find((_a) => _a?.id == value)) {
          selectedEsType.push(_es);
        }
      });
    });

    setEssentialSupport((prev) =>
      prev?.map((item, index) => {
        if (index === indexx && item.id === supportId) {
          const selectedSupport = selectedEsType?.[0];

          // const selectedActivity = selectedSupport?.activities?.find(
          //   (act) => act?.id === value
          // );

          return {
            ...item,
            ...selectedSupport,
            essentialActivityNumber: value,
            howOftenEssentialSupport: finalHowOften,
            essentialNumber: selectedSupport?.essentialNumber,
          };
        }
        return item;
      })
    );
  };

  // add note of respective essential plan
  const handleEssentialSupportDesc = (supportId, field, value, indexx) => {
    if (isIntervention_Progress_Note) {
      setGoals((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId ? { ...item, [field]: value } : item;
          } else {
            return item;
          }
        })
      );
    } else {
      setEssentialSupport((prev) =>
        prev?.map((item, index) => {
          if (index === indexx) {
            return item.id === supportId ? { ...item, [field]: value } : item;
          } else {
            return item;
          }
        })
      );
    }
  };

  const handleGoalActivityChange = (id, field, value, index, goalIndex) => {
    const matchingActivities = allPlans
      ?.filter(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true
      )
      ?.flatMap((v) => v?.goals || [])
      ?.flatMap((g) => g?.goalActivities || []);

    const updatedGoalItems = goalItems[goalIndex].map((item) => {
      if (item.id !== id) return item;

      if (field === "objectives") {
        const selectedActivity = matchingActivities?.find(
          (ga) => ga?.objectives === value
        );
        return {
          ...item,
          objectives: value,
          Intervention_Instruction:
            selectedActivity?.Intervention_Instruction || "",
        };
      }

      if (field === "Intervention_Instruction") {
        const selectedActivity = matchingActivities?.find(
          (ga) => ga?.Intervention_Instruction === value
        );
        return {
          ...item,
          Intervention_Instruction: value,
          objectives: selectedActivity?.objectives || "",
        };
      }

      return { ...item, [field]: value };
    });

    let finalGoalItems = [...goalItems];

    finalGoalItems[goalIndex] = updatedGoalItems;

    setGoalItems(finalGoalItems);
    // setGoalItems(updatedGoalItems);
    setGoals((prevGoals) =>
      prevGoals.map((goal, i) =>
        i === goalIndex ? { ...goal, goalActivities: updatedGoalItems } : goal
      )
    );
  };

  useEffect(() => {
    if (getGoalsData && getGoalsData.length > 0) {
      // Extract goal activities from all goals
      const allActivities = getGoalsData.flatMap(
        (goal) => goal.goalActivities || []
      );

      let finalGoalItems = [];

      getGoalsData?.map((_g, index) => {
        finalGoalItems.push(_g.goalActivities);
      });

      setGoalItems(finalGoalItems);

      // Set goal items for display
      // setGoalItems(allActivities);

      const formattedObjectives = allActivities?.map((_ga) => ({
        label: _ga.objectives,
        value: _ga.objectives,
      }));

      setObjectivesByGoal(
        formattedObjectives.length > 0 ? formattedObjectives : []
      );

      const formattedInterventions = allActivities?.map((_ga) => ({
        label: _ga.Intervention_Instruction,
        value: _ga.Intervention_Instruction,
      }));

      setInterventionsByGoal(
        formattedInterventions.length > 0 ? formattedInterventions : []
      );
    }
  }, [getGoalsData]);

  // Reset Form
  const resetForm = (preservePatient = false) => {
    setErrors("");
    form.reset();
    setEssentialSupportErrors([]);
    aiTouchedFieldsRef.current = {};

    setOutcomeNotes([]);
    setAiAssistantCardOpened(false);
    setBehaviorCardOpened(false);
    setResponseCardOpened(false);
    setPlanCardOpened(false);

    setEssentialNotes([]);
    setSupportPlan("no");
    setMessages([]);
    setEssentialSupportToggle("no");
    setInterventionPlanToggle("no");
    setEssentialSupport([{ id: 1, ...initialEssentialSupport }]);
    setGoals([{ id: 1, ...initialGoals }]);
    setGoalItems([
      [{ id: Date.now(), objectives: "", Intervention_Instruction: "" }],
    ]);
    setAiActionsOpen(false);
    setComparePanel(COMPARE_PANEL_RESET);
    setServiceNumber(null);
    handleRecordingCancel();
    setEssentialAccordion("0");
    setGoalsAccordion("0");

    setEssentialSupportTypeState([]);
    setEssentialSupportNumber([]);
    setSelectedSupportType(null);
    setEssentialNumber(null);
    setFrequencyOptions([]);
    setActivities([]);

    if (!preservePatient) {
      setBillingServices("");
      setSelectedPatient(null);
    }
    if (NOTETYPE === Billing_Services_Note) {
      setBillingServices("");
      setSelectedPatient(null);
    }
    setSelectedGroupClients([]);
    close();
    // setPatientsId(null);
  };

  const cancelForm = () => {
    setErrors("");
    form.reset();
    setNoteType(null);
    setOutcomeNotes([]);
    setAiAssistantCardOpened(false);
    setBehaviorCardOpened(false);
    setResponseCardOpened(false);
    setPlanCardOpened(false);

    setEssentialNotes([]);
    setSupportPlan("no");
    setMessages([]);
    setEssentialSupportToggle("no");
    setInterventionPlanToggle("no");
    setEssentialSupport([{ id: 1, ...initialEssentialSupport }]);
    setGoals([{ id: 1, ...initialGoals }]);
    setGoalItems([
      [{ id: Date.now(), objectives: "", Intervention_Instruction: "" }],
    ]);
    setAiActionsOpen(false);
    setComparePanel(COMPARE_PANEL_RESET);
    setServiceNumber(null);
    handleRecordingCancel();
    setEssentialAccordion("0");
    setGoalsAccordion("0");

    setEssentialSupportTypeState([]);
    setEssentialSupportNumber([]);
    setSelectedSupportType(null);
    setEssentialNumber(null);
    setFrequencyOptions([]);
    setActivities([]);

    setBillingServices("");
    setSelectedPatient(null);
    if (NOTETYPE === Billing_Services_Note) {
      setBillingServices("");
      setSelectedPatient(null);
    }
    close();
    // setPatientsId(null);
  };

  const handleNoteTypeChange = (newNoteType) => {
    form.reset();
    setErrors({});
    setEssentialSupportErrors([]);
    setInterventionPlanToggle("no");
    setSupportPlan("no");
    setEssentialSupportToggle("no");
    setDescriptions([{ id: 1, ...initialDescription }]);
    setEssentialSupport([{ id: 1, ...initialEssentialSupport }]);
    setGoals([{ id: 1, ...initialGoals }]);
    setGoalItems([[{ id: Date.now(), objectives: "", Intervention_Instruction: "" }]]);
    setOpenedAccordion("0");
    setEssentialAccordion("0");
    setGoalsAccordion("0");
    setMessages([]);
    setOutcomeNotes([]);
    setEssentialNotes([]);
    setAiAssistantCardOpened(false);
    setBehaviorCardOpened(false);
    setResponseCardOpened(false);
    setPlanCardOpened(false);
    setAiActionsOpen(false);
    setComparePanel(COMPARE_PANEL_RESET);
    setServiceNumber(null);
    setEssentialSupportTypeState([]);
    setEssentialSupportNumber([]);
    setSelectedSupportType(null);
    setEssentialNumber(null);
    setFrequencyOptions([]);
    setActivities([]);
    setSelectedGroupClients([]);
    handleRecordingCancel();
    setNoteType(newNoteType);
    if (selectedPatient?.id) form.setFieldValue("Client Name", selectedPatient.id);
    if (selectedFacility) form.setFieldValue("Facility Name", selectedFacility);
  };

  // Builds the aiMetadata block for the note payload from fields the user accepted an AI
  // suggestion into, and returns a snapshot of those fields. Captured up front because the
  // create/edit callbacks (which call resetForm, clearing aiTouchedFieldsRef) can run
  // before the save promise resolves — reading the live ref afterward would see it empty.
  const attachAiMetadata = (obj) => {
    const touched = aiTouchedFieldsRef.current;
    const contexts = Object.keys(touched);
    if (!contexts.length) return { payload: obj, aiFieldsSnapshot: null };

    const aiFields = contexts.map((context) => ({ context, ...touched[context] }));
    return { payload: { ...obj, aiMetadata: { fields: aiFields } }, aiFieldsSnapshot: aiFields };
  };

  // Fires the "final note saved" Pendo/analytics events for a previously captured snapshot,
  // tagged with the saved note's real id so the data can be associated back to that note.
  const trackAiNoteFinalization = (aiFieldsSnapshot, noteId) => {
    if (!aiFieldsSnapshot?.length) return;

    aiFieldsSnapshot.forEach(({ context, action, chosen_model, final_text }) => {
      trackAiNoteFinalized({
        note_id: noteId ?? null,
        note_type: noteType?.name || "",
        action,
        chosen_model,
        field_context: context,
      });
      logAiSuggestionEvent({
        note_id: noteId ?? null,
        note_type: noteType?.name || "",
        action,
        chosen_model,
        field_context: context,
        final_note_content: final_text,
        event: "note_finalized",
      });
    });
  };

  // Save Note
  const onSave = async (values) => {
    const NOTETYPE = noteType?.id;
    let obj = {
      noteId: NOTETYPE,
      fields: { ...values, noteId: NOTETYPE },
      supportPlan,
      userId,
    };
    if (NOTETYPE === Billing_Services_Note) {
      obj.fields["Facility Name"] = selectedPatient?.facilityId?.[0]?.id;
    }
    if (isGroupNote) {
      obj.fields.clientIds = selectedGroupClients;
    }
    const isEssentialNote = noteType?.id === Essential_Support_Note;

    const isValid = validateEssentialSupport();
    if (!isValid && isEssentialNote && essentialSupportToggle === "yes") return;

    if (isEssentialNote) {
      if (essentialSupport !== undefined) {
        obj.essentialSupport = essentialSupport;
      }
      if (essentialSupportToggle !== undefined) {
        obj.essentialSupportToggle = essentialSupportToggle;
      }
    } else if (isIntervention_Progress_Note) {
      if (goals !== undefined) {
        obj.goals = goals;
      }
      if (interventionPlanToggle !== undefined) {
        obj.interventionPlanToggle = interventionPlanToggle;
      }
    }
    const isProgressNote = noteType?.name === "Progress Note";
    if (
      isProgressNote ||
      noteType?.custom?.find((_c) => _c?.field === "Support Plan")
    )
      obj["descriptions"] = descriptions;

    // if (isProgressNote) obj["descriptions"] = descriptions;

    // if (isProgressNote && supportPlan === "yes")
    //   obj.fields["Description"] = descriptions
    //     ?.map((rest) => rest?.details?.outcomeTitle)
    //     ?.join(", ");

    if (edit) {
      let fields = { ...values };
      delete fields["noteId"];
      delete fields["noteType"];
      const obj = {
        ...values,
        id: data?.data?.id,
        fields,
        supportPlan,
        userId,
        essentialSupport,
        essentialSupportToggle,
        goals,
        interventionPlanToggle,
        noteDate: values.Date,
      };
      if (isGroupNote) obj.fields.clientIds = selectedGroupClients;
      if (
        isProgressNote ||
        noteType?.custom?.find((_c) => _c?.field === "Support Plan")
      )
        obj["descriptions"] = descriptions;
      // if (isProgressNote) obj["descriptions"] = descriptions;

      if (isProgressNote && supportPlan === "yes")
        obj.fields["Description"] = descriptions
          ?.map((rest) => rest?.details?.outcomeTitle)
          ?.join(", ");
      const validations = validateFields();
      if (validations !== true && supportPlan === "yes") {
        validateFields();
      } else {
        const editNoteId = obj.id;
        const { payload: editPayload, aiFieldsSnapshot: editAiFields } = attachAiMetadata(obj);
        editNote(editPayload, false, resetForm, sortField, sortOrder, setEditModal, currentPage, dateRange, activeFilters);
        trackAiNoteFinalization(editAiFields, editNoteId);
        resetForm();
        setErrors("");
      }
    } else {
      const validations = validateFields();
      let isBillingService = profile?.admin?.billingAgree;
      if (validations !== true && supportPlan === "yes") {
        validateFields();
      } else {
        // Determine before saving whether selectedPatient should be preserved
        // (when another note in the flow — Essential or Billing Services — will follow)
        let ifEssential = false;
        if (NOTETYPE === PROGRESS_Note) {
          ifEssential = allPlans?.some((item) => {
            return (
              item?.isActive &&
              item?.planType?.name?.includes("Essential Supports") &&
              item?.essentialSupport?.length
            );
          });
        }
        const willOpenBilling =
          (NOTETYPE === PROGRESS_Note && !ifEssential && isBillingService) ||
          (NOTETYPE === Essential_Support_Note && progressNoteState && isBillingService);
        const preservePatient = ifEssential || willOpenBilling;

        const refreshUserId = (isClientView && !isGroupNote) ? (selectedPatient?.id || userId) : null;
        const { payload: createPayload, aiFieldsSnapshot: createAiFields } = attachAiMetadata(obj);
        const createResult = await createNote(createPayload, () => resetForm(preservePatient), refreshUserId, currentPage, dateRange, sortField, sortOrder, activeFilters);
        if (createResult !== false) {
          trackAiNoteFinalization(createAiFields, createResult?.id ?? createResult?._id);
        }
        resetForm(preservePatient);
        setPendingModal(true);
        if (createResult !== false) {
          const cId = isGroupNote ? null : (selectedPatient?.id || userId);
          if (NOTETYPE && cId) {
            deleteNoteDraft(NOTETYPE, cId);
            getAllDrafts(dispatch, isClientView ? cId : null);
          }
        }
        if (NOTETYPE === PROGRESS_Note) {
          if (ifEssential) {
            setOpenModal(true);
            setProgressNoteState("progress");
          } else if (isBillingService) {
            setOpenModal(true);
            setBillingServices("billing");
          } else {
            setOpenModal(false);
          }
        } else if (NOTETYPE === Essential_Support_Note) {
          if (progressNoteState && isBillingService) {
            // setOpenModal(true);
            setBillingServices("billing");
          } else {
            setOpenModal(false);
          }
        } else {
          setOpenModal(false);
        }
        setErrors("");
      }
    }
  };

  function objectToString(obj) {
    let result = Object.entries(obj)
      .map(
        ([key, value]) =>
          `${key.charAt(0).toUpperCase() + key.slice(1)}: ${`"${
            value || "-"
          }"`}`
      )
      .join("\n");

    return result;
  }

  const arrayToString = (array) => {
    if (array?.length === 0 || array === undefined) return "";
    return array
      ?.filter((v) => v)
      ?.map((v, i) => `${i + 1}) ${v}`)
      .join("\n \n");
  };

  function filterNonNullFields(obj) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value !== null && value !== undefined && value !== "") {
        result[key] = value;
      }
    }
    return result;
  }

  useEffect(() => {
    if (selectedPatient && isBilling_Services) {
      form.setFieldValue("Provider", selectedPatient?.providerId[0]?.id);
    }
  }, [selectedPatient]);

  useEffect(() => {
    if (essentialSupport) {
      let data = getEssentialSupport?.[0];

      if (view === true || edit === true) {
        handleEssentialTypeChangeForNoteView(
          data?.essentialSupportType,
          data?.howOftenEssentialSupport
        );
      }
    }
  }, [view, edit, essentialSupportToggle]);

  // useEffect(() => {
  // if(essentialSupport?.length > 0 && view === true) {
  //   let data = getEssentialSupport?.[0]
  //   handleEssentialTypeChangeForNoteView(data?.essentialSupportType, data?.howOftenEssentialSupport)
  // }
  // }, [view]);

  // useEffect(() => {
  // if(essentialSupport?.length > 0 && edit === true){
  //   let data = getEssentialSupport?.[0]
  //   handleEssentialTypeChangeForNoteView(data?.essentialSupportType, data?.howOftenEssentialSupport)
  // }
  // }, [edit]);

  // Handle Client Change
  const handlePatientChange = (patientId, name) => {
    if (name === "Service Type") {
      let selectedService = selectedPatient?.form1?.services?.filter(
        (val) => val?.servicenumber === patientId
      )?.[0];
      setServiceNumber(selectedService);
    }
    !edit && !view && !draftRestoredRef.current && setDescriptions([{ id: 1, ...initialDescription }]);
    setAiActionsOpen(false);
    setComparePanel(COMPARE_PANEL_RESET);

    form.setFieldValue(name, patientId);
    let facilityExists = noteType?.custom?.find(
      (value) => value?.fieldType?.name?.toLowerCase() === "facilities"
    );
    let patient = allPatients?.find((value) => value?.id === patientId);

    let pcpInfo = {
      "PCP Name": patient?.form2?.["pcpName"],
      "PCP Email": patient?.form2?.["pcpEmail"],
      "PCP Phone Number": patient?.form2?.["pcpPhoneNumber"],
      "PCP Fax Number": patient?.form2?.["pcpFaxNumber"],
    };

    let insuranceDetails = {
      "Insurance Company Name": patient?.form2?.["insuranceCompanyName"],
      "Member Name": patient?.form2?.["memberName"],
      "Member Number": patient?.form2?.["memberNumber"],
      "Prescription Group": patient?.form2?.["prescriptionGroup"],
      "Group Number": patient?.form2?.["groupNumber"],
      "Effective Date": formatDate(patient?.form2?.["effectiveDate"]),
    };
    (edit || view) &&
      form.setFieldValue(
        facilityExists?.field,
        data?.data?.fields?.["Facility Name"]
      );

    form.setFieldValue("All PCP Info", objectToString(pcpInfo));
    form.setFieldValue(
      "Known Allergies",
      arrayToString(patient?.form1?.knownAllergies)
    );
    form.setFieldValue(
      "Dietary Restrictions",
      arrayToString(patient?.form1?.dietaries)
    );

    form.setFieldValue(
      "Known Illnes",
      arrayToString(
        patient?.form1?.knownIllness
          ? patient?.form1?.knownIllness?.map(
              (v) =>
                `${v?.illness || ""} - Contagious: "${v?.contagious || ""}"`
            )
          : []
      ) || "-"
    );
    form.setFieldValue("Insurance Details", objectToString(insuranceDetails));
    form.setFieldValue("Known Wounds", patient?.form1?.woundsInformation);

    form.setFieldValue("Medication Records", "");
    form.setFieldValue("Support Plan", "");
    setMedicationOptions(
      Array.isArray(patient?.form3)
        ? patient?.form3?.map((value) => {
            let { isPrescribed, id, ...rest } = value;
            return {
              label: value?.medicationName,
              value: objectToString({
                ...filterNonNullFields(rest),
                Prescribed: isPrescribed ? "Yes" : "No",
              }),
            };
          })
        : []
    );

    setSupportOptions(
      allPlans
        ?.find((v) => v?.client?.id === patient?.id)
        ?.outcomes?.map(({ id, ...rest }) => ({
          value: objectToString({
            ...filterNonNullFields(rest),
          }),
          label: rest.outcomeTitle,
        })) || []
    );
    if (patient) setSelectedPatient(patient);

    // Clear any draft banner from the previous client immediately.
    // The combined useEffect below will fetch the draft for the new client.
    if (!edit && !view) setPendingDraft(null);
  };

  // Handle Facility Change
  const handleFacilityChange = (value, name) => {
    form.setFieldValue(name, value);
    setSelectedFacility(value);
    if (isGroupNoteCreating) {
      const facilityClients = allPatients
        ?.filter(
          (_p) =>
            _p?.active === true &&
            _p?.deleted === false &&
            _p?.facilityId?.some((f) => f?.id === value)
        )
        ?.map((p) => p?.id) || [];
      setSelectedGroupClients(facilityClients);
    }
    setAiActionsOpen(false);
    setComparePanel(COMPARE_PANEL_RESET);
    let facilityDetails = facilities?.facilities?.find(
      (fac) => String(fac?.id) === value
    );
    setFacilityDetials(facilityDetails);
  };

  useEffect(() => {
    if (!opened) {
      setMedicationOptions([]);
      setSupportOptions([]);
      setDescriptions([{ id: 1, ...initialDescription }]);
      setSupportPlan("no");
      setEssentialSupportToggle("no");
      setInterventionPlanToggle("no");
      setAiActionsOpen(false);
      setComparePanel(COMPARE_PANEL_RESET);
      setSelectedGroupClients([]);
      getAllFacilitiesModal("all");

      form.reset();
    }
    if (noteT && edit) {
      getAllFacilitiesModal("all");
      form?.setFieldValue(
        "noteType",
        allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id)?.name
      );

      let _noteType = {
        ...allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id),
      };

      let customs = Array.isArray(_noteType?.custom)
        ? [..._noteType.custom]
        : [];

      let indexOfPatient = customs.findIndex(
        (v) => v?.field === noteType_Client
      );
      let patientClone = customs[indexOfPatient];
      if (indexOfPatient !== -1) {
        customs.splice(indexOfPatient, 1);
        customs.unshift(patientClone);
        _noteType.custom = customs;
      }
      setNoteType(_noteType);
      setSelectedFacility(data?.data?.fields?.["Facility Name"]);
      if (noteT?.id === Group_Note && !edit && data?.data?.fields?.clientIds?.length) {
        setSelectedGroupClients(data?.data?.fields?.clientIds);
      }
    }
    if (opened) {
      getAllPatientsModal("all");
      getAllFacilitiesModal("active");
    }
  }, [noteT, opened]);

  // Quick Notes data — fetched once per drawer open here (not inside
  // QuickNotesPicker itself, which is mounted up to 7x in this form; fetching
  // there would fire the same request once per mounted instance).
  useEffect(() => {
    if (opened) {
      getActivityLibrary();
      getDefaultPrompting();
    }
  }, [opened]);

  useEffect(() => {
    if (edit) {
      setAiAssistantCardOpened(false);
      console.log('data?.data?.fields',data?.data?.fields);
      
      setFacilityDetials(data?.data?.fields?.["Facility Name"]);
      if (data?.data?.fields)
        Object.entries(data?.data?.fields)?.map((value) => {
          if (
            `${value[1]}`.split(":")?.length === 3 &&
            `${value[1]}`.split("-")?.length === 3
          ) {
            let date = new Date(value[1]);
            form?.setFieldValue(value[0], date);
          } else {
            form?.setFieldValue(value[0], value[1]);
          }
        });
    }

    if (NOTETYPE && opened) {
      form?.setFieldValue(
        "noteType",
        allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE)?.name
      );

      let _noteType = {
        ...allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE),
      };
      // let customs = _noteType ? [..._noteType?.custom] : [];
      let customs = Array.isArray(_noteType?.custom)
        ? [..._noteType.custom]
        : [];

      let indexOfPatient = customs?.findIndex(
        (v) => v?.field === noteType_Client
      );
      let patientClone = customs[indexOfPatient];
      if (indexOfPatient !== -1) {
        customs.splice(indexOfPatient, 1);
        customs.unshift(patientClone);
        _noteType.custom = customs;
      }
      setNoteType(_noteType);
    }
  }, [NOTETYPE, edit, opened]);

  useEffect(() => {
    if (opened) {
      if (profile?.user?.type === "staff" && !view && !edit) {
        form.setFieldValue("Staff Name", profile?.user?.id);
      } else if (profile?.user?.type !== "staff" && !view && !edit) {
        form.setFieldValue("Staff Name", profile?.user?.id);
      } else {
        form.setFieldValue("Staff Name", data?.data?.fields["Staff Name"]);
      }
      if (selectedPatient) {
        form.setFieldValue("Client Name", selectedPatient?.id);
      } else if (data?.data?.fields["Client Name"]) {
        form.setFieldValue("Client Name", data?.data?.fields["Client Name"]);
      } else if (data?.data?.fields["Patient Name"]) {
        form.setFieldValue("Client Name", data?.data?.fields["Patient Name"]);
      }
      if (selectedPatient && isBilling_Services) {
        form.setFieldValue("Provider", selectedPatient?.providerId[0]?.id);
      }
      if (selectedPatient && isBilling_Services) {
        form.setFieldValue(
          "Facility Name",
          selectedPatient?.facilityId?.map((item) => item?.id)
        );
      }
      let patientType = noteType?.custom?.find(
        (v) => v?.fieldType?.name === noteType_Client_Options
      );
      let patient = allPatients?.find((value) =>
        data?.data?.fields?.["Patient Name"] &&
        !data?.data?.fields?.["Client Name"]
          ? value?.id === data?.data?.fields["Patient Name"]
          : data?.data?.fields?.["Patient Name"] &&
            data?.data?.fields?.["Client Name"]
          ? value?.id === data?.data?.fields["Client Name"]
          : value?.id === data?.data?.fields[patientType?.field]
      );
      if (patient) {
        form.setFieldValue(noteType_Client, patient.id);
        setMedicationOptions(
          Array.isArray(patient?.form3) &&
            patient?.form3?.map((value) => {
              let { isPrescribed, id, ...rest } = value;
              return {
                label: value?.medicationName,
                value: objectToString({
                  ...filterNonNullFields(rest),
                  Prescribed: isPrescribed ? "Yes" : "No",
                }),
              };
            })
        );

        setSupportOptions(
          allPlans
            ?.find((v) => v?.client?.id === patient?.id)
            ?.outcomes?.map(({ id, ...rest }) => ({
              value: objectToString({
                ...filterNonNullFields(rest),
              }),
              label: rest.outcomeTitle,
            })) || []
        );
        setSelectedPatient(patient);
        setDescriptions(data?.data?.descriptions);

        setOutcomeNotes(data?.data?.descriptions?.map((_d) => _d?.description));
        setEssentialNotes(
          data?.data?.essentialSupport?.map((_e) => _e?.description)
        );
        setSupportPlan(data?.data?.supportPlan || "no");
        setEssentialSupportToggle(data?.data?.essentialSupportToggle || "no");
        setInterventionPlanToggle(data?.data?.interventionPlanToggle || "no");
        if (data?.data?.essentialSupport?.length) {
          setEssentialSupport(data?.data?.essentialSupport);
        }
        if (data?.data?.goals?.length) {
          setGoals(data?.data?.goals);
        }
      }
    }
    if (!view)
      noteType?.custom?.forEach((field) => {
        if (field?.fieldType?.name === "date" && !edit) {
          form?.setFieldValue(field.field, new Date());
        }
        if (field?.fieldType?.name === "time" && !edit) {
          const currentTime = new Date().toLocaleTimeString("en-US", {
            hour12: false,
          });
          const isSafari = /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
          );
          if (isSafari) {
            let hours = new Date().getHours(),
              minutes = new Date().getMinutes();
            form?.setFieldValue(field.field, `${hours}:${minutes}`);
          } else {
            form?.setFieldValue(field.field, currentTime);
          }
        }
      });
  }, [noteType?.custom, opened]);

  useEffect(() => {
    if (userId) {
      handlePatientChange(userId, "Client Name");
    }
  }, [userId, allPatients]);

  // ── Generate Note (Task module → ADL activities) prefill/auto-generate ──
  // Resolve the requested noteType once note types load, regardless of whether
  // they were already in Redux by the time this component mounted.
  const autoNoteTypeSetRef = useRef(false);
  useEffect(() => {
    if (!opened) {
      autoNoteTypeSetRef.current = false;
      return;
    }
    if (!autoGenerateActivities?.length || autoNoteTypeSetRef.current || noteType) return;
    const nt = allNotesTypes?.ntypes?.find((v) => v?.id === NOTETYPE);
    if (nt) {
      setNoteType(nt);
      autoNoteTypeSetRef.current = true;
    }
  }, [opened, autoGenerateActivities, NOTETYPE, allNotesTypes, noteType]);

  // Preselect the facility passed in from the caller once facilities have loaded.
  useEffect(() => {
    if (opened && initialFacilityId && !selectedFacility && facilities?.facilities?.length) {
      const fac = facilities.facilities.find(
        (f) => String(f?.id) === String(initialFacilityId)
      );
      if (fac) handleFacilityChange(String(fac.id), "Facility Name");
    }
  }, [opened, initialFacilityId, facilities, selectedFacility]);

  useEffect(() => {
    setCurrentNote(noteType?.id);
    setAiActionsOpen(false);
    setComparePanel(COMPARE_PANEL_RESET);
  }, [noteType]);

  // Fetch draft whenever the client OR the note type changes.
  // Clears the previous draft first so a stale banner never lingers.
  useEffect(() => {
    if (edit || view || !noteType?.id) return;
    const patientId = selectedPatient?.id || userId;
    if (!patientId) return;
    const facId = selectedPatient?.facilityId?.id;
    setPendingDraft(null);
    if (autoRestoreDraft) setDraftFetching(true);
    getNoteDraft(noteType.id, patientId, facId).then((draft) => {
      if (draft?.formState?.fields && Object.keys(draft.formState.fields).length > 2) {
        setPendingDraft(draft.formState);
      } else {
        if (autoRestoreDraft) setDraftFetching(false);
      }
    }).catch(() => { if (autoRestoreDraft) setDraftFetching(false); });
  }, [noteType?.id, selectedPatient?.id]);

  // When opened from Drafts tab, auto-restore without requiring user to click "Continue editing"
  useEffect(() => {
    if (autoRestoreDraft && pendingDraft) {
      restoreDraft();
      draftRestoredRef.current = true;
      setDraftFetching(false);
    }
  }, [pendingDraft, autoRestoreDraft]);

  const initialValues = {};

  allNotesTypes?.ntypes?.custom?.map((value) => {
    initialValues[value?.field] = "";
  });

  const form = useForm({
    initialValues: (() => {
      const initialValues = { name: edit ? data?.data?.name : "" };
      noteType?.custom?.forEach((field) => {
        initialValues[field.field] = "";
      });

      return initialValues;
    })(),
  });

  // Seed the Shift field with the caller-provided value once the note type is ready.
  useEffect(() => {
    if (opened && noteType && initialShift && !form.values.Shift) {
      form.setFieldValue("Shift", initialShift);
    }
  }, [opened, initialShift, noteType]);

  // Once client and facility are in place, call the same quick-note AI endpoint
  // the Quick Notes picker uses (POST /note/ai-response/quick-note) with the
  // completed ADL activities, and drop the reply straight into Description.
  const autoGenerateFiredRef = useRef(false);
  useEffect(() => {
    if (!opened) {
      autoGenerateFiredRef.current = false;
      return;
    }
    if (!autoGenerateActivities?.length || autoGenerateFiredRef.current) return;
    if (!selectedPatient || !facilityDetials?.name) return;
    autoGenerateFiredRef.current = true;
    generateQuickNoteAi({
      activities: autoGenerateActivities,
      clientName: selectedPatient?.name || "",
      shift: initialShift || "",
    }).then((result) => {
      const text =
        result?.aiReply ||
        result?.data?.aiReply ||
        result?.data?.note ||
        result?.note ||
        (typeof result?.data === "string" ? result.data : "");
      if (text) form.setFieldValue("Description", text);
    });
  }, [opened, autoGenerateActivities, selectedPatient, facilityDetials, initialShift]);

  // ── Auto-save interval using refs to avoid stale closures ──
  const formRef = useRef(form);
  const stateRef = useRef({});
  formRef.current = form;
  stateRef.current = { edit, view, opened, NOTETYPE, noteTypeId: noteType?.id, clientId: isGroupNote ? null : (selectedPatient?.id || userId), facilityId: isGroupNote ? selectedFacility : selectedPatient?.facilityId?.id, descriptions, essentialSupport, essentialSupportCount, essentialSupportType, essentialSupportNumber, essentialNumber, activities, frequencyOptions, outComeTitle, outcomeNumbers, goals, goalItems, goalOptions, goalNumber, objectivesByGoal, interventionsByGoal, supportPlan, essentialSupportToggle, interventionPlanToggle };

  useEffect(() => {
    const id = setInterval(async () => {
      try {
        const s = stateRef.current; const f = formRef.current;
        if (s.edit || s.view || !s.opened || !f?.values) return;
        const ntId = s.NOTETYPE || s.noteTypeId; const clientId = s.clientId; const facilityId = s.facilityId || f.values?.["Facility Name"];
        if (!ntId || !clientId || !facilityId) return;
        const snap = JSON.stringify({ fields: f.values, descriptions: s.descriptions, essentialSupport: s.essentialSupport, essentialSupportCount: s.essentialSupportCount, essentialSupportType: s.essentialSupportType, essentialSupportNumber: s.essentialSupportNumber, essentialNumber: s.essentialNumber, activities: s.activities, frequencyOptions: s.frequencyOptions, outComeTitle: s.outComeTitle, outcomeNumbers: s.outcomeNumbers, goals: s.goals, goalItems: s.goalItems, goalOptions: s.goalOptions, goalNumber: s.goalNumber, objectivesByGoal: s.objectivesByGoal, interventionsByGoal: s.interventionsByGoal, supportPlan: s.supportPlan, essentialSupportToggle: s.essentialSupportToggle, interventionPlanToggle: s.interventionPlanToggle });
        if (snap === lastSavedSnapshotRef.current) return;
        setDraftStatus("saving");
        const ok = await saveNoteDraft({ noteTypeId: ntId, clientId, facilityId, formState: JSON.parse(snap) });
        if (ok) { lastSavedSnapshotRef.current = snap; setDraftStatus("saved"); setTimeout(() => setDraftStatus("idle"), 2500); }
        else setDraftStatus("idle");
      } catch { setDraftStatus("idle"); }
    }, 3000);
    return () => clearInterval(id);
  }, []);

  // Restore draft
  const restoreDraft = () => {
    if (!pendingDraft) return;
    const fs = { ...pendingDraft };
    setPendingDraft(null);

    const skip = new Set(["noteId", "noteid", "Staff Name", "name", "Client Name", "Patient Name"]);
    const dateFields = new Set();
    (noteType?.custom || []).forEach(f => { if (f?.fieldType?.name?.toLowerCase() === "date") dateFields.add(f.field); });
    const keys = new Set(Object.keys(form.values || {}));

    // 1. Set toggles + arrays synchronously
    if (fs.supportPlan) setSupportPlan(fs.supportPlan);
    if (fs.essentialSupportToggle) setEssentialSupportToggle(fs.essentialSupportToggle);
    if (fs.interventionPlanToggle) setInterventionPlanToggle(fs.interventionPlanToggle);
    if (fs.descriptions?.length > 0) setDescriptions(fs.descriptions);
    if (fs.essentialSupport?.length > 0) setEssentialSupport(fs.essentialSupport);
    if (fs.essentialSupportCount?.length > 0) setEssentialSupportCount(fs.essentialSupportCount);
    if (fs.essentialSupportType?.length > 0) setEssentialSupportType(fs.essentialSupportType);
    if (fs.essentialSupportNumber?.length > 0) setEssentialSupportNumber(fs.essentialSupportNumber);
    if (fs.activities?.length > 0) setActivities(fs.activities);
    if (fs.essentialNumber) setEssentialNumber(fs.essentialNumber);
    if (fs.frequencyOptions?.length > 0) setFrequencyOptions(fs.frequencyOptions);
    if (fs.outComeTitle?.length > 0) setOutComeTitle(fs.outComeTitle);
    if (fs.outcomeNumbers?.length > 0) setOutComeNumbers(fs.outcomeNumbers);
    if (fs.goals?.length > 0) setGoals(fs.goals);
    if (fs.goalItems?.length > 0) setGoalItems(fs.goalItems);
    if (fs.goalOptions?.length > 0) setGoalOptions(fs.goalOptions);
    if (fs.goalNumber?.length > 0) setGoalNumbers(fs.goalNumber);
    if (fs.objectivesByGoal?.length > 0) setObjectivesByGoal(fs.objectivesByGoal);
    if (fs.interventionsByGoal?.length > 0) setInterventionsByGoal(fs.interventionsByGoal);

    // Re-set after delay in case selectedFacility useEffect resets them
    const saved = { goals: fs.goals, goalItems: fs.goalItems, goalOptions: fs.goalOptions, goalNumber: fs.goalNumber, objectivesByGoal: fs.objectivesByGoal, interventionsByGoal: fs.interventionsByGoal, descriptions: fs.descriptions, essentialSupport: fs.essentialSupport, essentialSupportCount: fs.essentialSupportCount, essentialSupportType: fs.essentialSupportType, essentialSupportNumber: fs.essentialSupportNumber, essentialNumber: fs.essentialNumber, activities: fs.activities, frequencyOptions: fs.frequencyOptions, outComeTitle: fs.outComeTitle, outcomeNumbers: fs.outcomeNumbers };
    setTimeout(() => {
      draftRestoringRef.current = true;
      if (saved.goals?.length > 0) setGoals(saved.goals);
      if (saved.goalItems?.length > 0) setGoalItems(saved.goalItems);
      if (saved.goalOptions?.length > 0) setGoalOptions(saved.goalOptions);
      if (saved.goalNumber?.length > 0) setGoalNumbers(saved.goalNumber);
      if (saved.objectivesByGoal?.length > 0) setObjectivesByGoal(saved.objectivesByGoal);
      if (saved.interventionsByGoal?.length > 0) setInterventionsByGoal(saved.interventionsByGoal);
      if (saved.descriptions?.length > 0) setDescriptions(saved.descriptions);
      if (saved.essentialSupport?.length > 0) setEssentialSupport(saved.essentialSupport);
      if (saved.essentialSupportCount?.length > 0) setEssentialSupportCount(saved.essentialSupportCount);
      if (saved.essentialSupportType?.length > 0) setEssentialSupportType(saved.essentialSupportType);
      if (saved.essentialSupportNumber?.length > 0) setEssentialSupportNumber(saved.essentialSupportNumber);
      if (saved.activities?.length > 0) setActivities(saved.activities);
      if (saved.essentialNumber) setEssentialNumber(saved.essentialNumber);
      if (saved.frequencyOptions?.length > 0) setFrequencyOptions(saved.frequencyOptions);
      if (saved.outComeTitle?.length > 0) setOutComeTitle(saved.outComeTitle);
      if (saved.outcomeNumbers?.length > 0) setOutComeNumbers(saved.outcomeNumbers);
    }, 800);

    // 3. Set facility — guard prevents selectedFacility useEffect from resetting goals
    draftRestoringRef.current = true;
    if (fs.fields?.["Facility Name"]) {
      handleFacilityChange(fs.fields["Facility Name"], "Facility Name");
    }

    // 4. Set all form fields — don't check if key exists (form.setFieldValue can add new keys)
    if (fs.fields) {
      Object.entries(fs.fields).forEach(([k, v]) => {
        if (skip.has(k) || v == null) return;
        try {
          if (dateFields.has(k) && typeof v === "string") {
            const d = new Date(v); if (!isNaN(d.getTime())) form.setFieldValue(k, d);
          } else {
            form.setFieldValue(k, v);
          }
        } catch {}
      });
    }

    setDraftStatus("restored"); setTimeout(() => setDraftStatus("idle"), 3000);
  };

  // Save on close, reset refs; fire "abandoned" if compare panel was open when modal closed
  useEffect(() => {
    if (!opened) {
      setComparePanel((prev) => {
        if (prev.open) {
          trackAiSuggestionResolved({
            action: normalizeAction(prev.action),
            outcome: "abandoned",
            option_chosen: null,
            chosen_model: null,
            regeneration_count: prev.regenerationCount,
            note_type: noteType?.name || "",
          });
          logAiSuggestionEvent({
            note_type: noteType?.name || "",
            action: normalizeAction(prev.action),
            option_1_model: prev.slot1Model ?? prev.option1Model,
            option_2_model: prev.slot2Model ?? prev.option2Model,
            option_1_word_count: prev.option1WordCount,
            option_2_word_count: prev.option2WordCount,
            option_1_latency_ms: prev.option1LatencyMs,
            option_2_latency_ms: prev.option2LatencyMs,
            selected_option: null,
            regeneration_count: prev.regenerationCount,
          });
        }
        return prev;
      });
      draftRestoredRef.current = false;
      setDraftStatus("idle");
      lastSavedSnapshotRef.current = "CLOSED";
      setPendingDraft(null);
      setDraftFetching(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened]);

  useEffect(() => {
    const staffDetails = staff?.staffs?.find(
      (value) => String(value?.id) === String(form.values?.["Staff Name"])
    );
    setStaffDetials(staffDetails);
  }, [staff, form.values?.["Staff Name"]]);

  const validateFields = () => {
    const newErrors = {};
    descriptions?.forEach((medication, index) => {
      if (!medication?.outcomeNumber) {
        newErrors[index] = "Field is required";
      }
      if (!medication?.outcomeTitle) {
        newErrors[index] = "Field is required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateEssentialSupport = () => {
    const errors = essentialSupport.map((item) => {
      const activityEmpty = !item.essentialActivityNumber;
      const typeEmpty = !item.essentialSupportType;
      return activityEmpty || typeEmpty;
    });
    setEssentialSupportErrors(errors);

    // Optionally return whether the form is valid
    return !errors.includes(true);
  };

  const noteDetails = form.values;

  const sendMessageToOpenAI = async (value) => {
    setMessages({});
    if (value === "behavior") {
      setBehaviorLoading(true);
    } else if (value === "response") {
      setResponseLoading(true);
    } else if (value === "plan") {
      setPlanLoading(true);
    } else {
      setLoading(true); // only when no value comes / doesn't match any case
    }

    try {
      const finalPrompt = buildFinalPrompt(value);

      const aiReply = await generateAiNote(
        finalPrompt,
        profile?.user?.admin || profile?.user?.id,
        "ollama"
      );

      if (aiReply) {
        if (supportPlan === "yes") {
          setDescriptions((prev) => {
            const updated = [...prev];
            updated[openedAccordion] = {
              ...updated[openedAccordion],
              message: aiReply?.aiReply,
            };
            return updated;
          });
        } else if (essentialSupportToggle === "yes") {
          setEssentialSupport((prev) => {
            const updated = [...prev];
            updated[essentialAccordion] = {
              ...updated[essentialAccordion],
              message: aiReply?.aiReply,
            };
            return updated;
          });
        } else if (interventionPlanToggle === "yes") {
          setGoals((prev) => {
            const updated = [...prev];
            updated[goalsAccordion] = {
              ...updated[goalsAccordion],

              // message: aiReply,
              ...(value === "behavior"
                ? { behaviorAiReply: aiReply?.aiReply || "" }
                : value === "response"
                ? { responseAiReply: aiReply?.aiReply || "" }
                : value === "plan"
                ? { planAiReply: aiReply?.aiReply || "" }
                : { message: aiReply?.aiReply || "" }),
            };
            return updated;
          });
        } else {
          setMessages((prev) => {
            const updated = { ...prev, message: aiReply?.aiReply };
            return updated;
          });
        }
      }
    } catch (error) {
      if (value === "behavior") {
        setBehaviorLoading(false);
      } else if (value === "response") {
        setResponseLoading(false);
      } else if (value === "plan") {
        setPlanLoading(false);
      } else {
        setLoading(false); // only when no value comes / doesn't match any case
      }
    } finally {
      if (value === "behavior") {
        setBehaviorLoading(false);
      } else if (value === "response") {
        setResponseLoading(false);
      } else if (value === "plan") {
        setPlanLoading(false);
      } else {
        setLoading(false); // only when no value comes / doesn't match any case
      }
    }
  };

  // ── buildFinalPrompt: extracts prompt-building logic from sendMessageToOpenAI ──
  const buildFinalPrompt = (value) => {
    const noteDetails = form.values;

    // Essential support context
    let tempEssentialSupport = "";
    const selectedSupport = essentialSupport?.[essentialAccordion];
    if (essentialSupport) {
      const selectedActivity = selectedSupport?.activities?.find(
        (activity) => String(activity?.id) === String(selectedSupport?.essentialActivityNumber)
      );
      let howToSupportText = "";
      const howToSupport = selectedActivity?.howToSupport;
      if (Array.isArray(howToSupport)) {
        howToSupportText = howToSupport.map((item) => (typeof item === "string" ? item : item?.text)).filter(Boolean).join(", ");
      } else if (typeof howToSupport === "string") {
        howToSupportText = howToSupport;
      }
      const supportStatement = selectedActivity?.supportStatement || "";
      tempEssentialSupport = `${supportStatement}\n${howToSupportText}`.trim();
    }

    // Support activities context
    let filteredDescriptions = descriptions?.filter((item) => item?.details !== null);
    let supportActivitiesSection = "";
    const selectedItem = descriptions?.[openedAccordion];
    if (filteredDescriptions?.length > 0 && selectedItem?.details) {
      const { outcomeCategory, activities } = selectedItem.details;
      const activityNames = activities?.map((activity) => activity?.supportActivity).filter(Boolean).join(", ") || "";
      const supportInstructionsText = activities?.map((activity) => {
        const instr = activity?.supportInstructions;
        if (Array.isArray(instr)) return instr.map((i) => (typeof i === "string" ? i : i?.text)).filter(Boolean).join(", ");
        else if (typeof instr === "string") return instr;
        return "";
      }).filter(Boolean).join(", ") || "";
      supportActivitiesSection = `${outcomeCategory || ""}\n${activityNames}\n${supportInstructionsText}`.trim();
    }

    // Intervention plan context
    let tempInterventionPlan = "";
    const selectedIntervention = goals?.[goalsAccordion];
    if (selectedIntervention?.goalActivities?.length) {
      tempInterventionPlan = selectedIntervention.goalActivities.map(
        (activity) => ` - Objectives : ${activity?.objectives || ""}\n - Instructions : ${activity?.Intervention_Instruction || ""}`
      ).join("\n\n");
    }

    const staffNoteValue =
      (noteDetails?.noteid?.name === "Progress Note" && supportPlan === "yes") ||
      (noteDetails?.noteid?.name === "Essential Support Note" && essentialSupportToggle === "yes")
        ? selectedItem?.description?.trim() || selectedSupport?.description?.trim() || ""
        : noteDetails?.Description?.trim() || "";

    let promptCommon = `
    Generate a {Note Type} for a {Facility Type} in {State} for the individual {Individual Name} using the {Staff Note} and {Support Activities}.
The note must:
Be written entirely from the perspective of the staff as expressed in the {Staff Note}, using the same tone, phrasing, sentence structure, and level of formality. If the staff's note is casual, reflective the generated note should preserve that voice while making it complete and appropriate for documentation.
Use the {Staff Note} as the base and expand on it using information from the {Support Activities}. Do not polish or rephrase the original tone to make it sound formal if not already formal.
Be formatted to comply with the documentation standards of the state of {State} for a {Facility Type}, including necessary elements such as:
the activities presented to the individual and the choice they made
Staff involvement, support provided, and any interventions
Observations of the individual's behavior, engagement, emotional state, and any incidents
Do not add anything outside of the general scope of {Support Activities}.
Do not add activities outside of the parameters of {Staff Note}.
Do not rephrase or reframe the staff's voice to sound more clinical, unless the original {Staff Note} was clinical to begin with.
Do not include headers, signatures, staff names, dates, or shift info in the note body.
Do not remove phrases like "Staff" or "DSP". Keep them in the note if a user has them there. Do not replace them with a Staff name.
Do not include hyphens.
Do not use phrases from here "{Support Activities}" verbatim.
Do not summarize the outcome in the generated note. Do not use words and phrases like "Overall, in summary, at the end of the day".
Do not make each response overly verbose. Make the word count less than or equal to 100 words.
Do not mention things like the "Care Plan", "Support Plan", "Outcome" in the generated response.
Remember you are generating a note on behalf of a staff member. Do make things seem like the staff is trying to meet a list of expected activities (Do not over embellish). Make the language natural and come from the perspective that staffs only document the actions they took with that of their clients and corresponding responses.
Make sure the note is clear, free from grammatical or spelling errors, and sounds like it was written naturally by the staff who wrote the original input "{Staff Note}".

Use values defined below for the variables denoted in curly brackets

- State: ${selectedStateAbbr || ""}
- Date of Service: ${moment(noteDetails?.Date).format("MM/DD/YYYY") || ""}
- Session Type: ${isGroupNote ? "Group Session (multiple participants — the note must reflect observations and documentation for ALL participants listed below)" : "Individual Session"}
- Individual's Name or Identifier: ${isGroupNote ? selectedGroupClients.map(id => allPatients?.find(p => p?.id === id)?.name).filter(Boolean).join(', ') : selectedPatient?.name || ""}
- Support Activities : ${supportActivitiesSection || ""} ${tempEssentialSupport || ""}
- Staff Note = ${staffNoteValue}
- Staff Name and Title (Optional): ${staffDetials?.name || ""}
- Shift (Optional): ${noteDetails?.Shift || ""}
- Note Type (Required): ${noteDetails?.noteid?.name || ""}
- Facility Type (Required): ${facilityDetials?.name || ""}
    `;

    let polishNotePrompt = `
<<<<<<< HEAD
=======

>>>>>>> origin/production-secure
ROLE
You are an experienced Direct Support Professional (DSP) responsible for documenting services provided in a {Facility Type} located in {State}.
Your responsibility is to polish existing documentation while preserving the staff member's original meaning, writing style, perspective, and level of detail.
You are editing the writing, not the documentation itself.
Never invent activities, behaviors, interventions, observations, responses, or events.

MISSION
Generate a polished {Note Type} for {Individual Name}.
The purpose of this task is to improve grammar, spelling, readability, sentence flow, and clarity while preserving the original documentation.
The Staff Note is the only authoritative source.
The Support Activities are provided only for context. Do not use them to introduce new documentation or expand the Staff Note.
The finished note should read as though the same staff member simply wrote a cleaner version of their original note.

SOURCE PRIORITY
Always follow this order:
Priority 1: Staff Note
The Staff Note represents exactly what the staff member documented.
It is the authoritative source.
Priority 2: Support Activities
Use only as context to better understand the Staff Note.
Do not use Support Activities to introduce additional activities, observations, interventions, or behaviors.
If there is any conflict, always follow the Staff Note.

INPUTS
Staff Note
{Staff Note}
Support Activities
{Support Activities}

PHASE 1 — UNDERSTAND THE STAFF MEMBER
Before editing, determine the staff member's:
tone
vocabulary
sentence structure
writing style
level of detail
Preserve these characteristics.
Do not rewrite the staff member's personality.
Do not make the writing more clinical unless it was already clinical.
If the Staff Note is brief, keep it brief.
If it is conversational, keep it conversational.

PHASE 2 — IDENTIFY IMPROVEMENTS
Before rewriting, identify:
spelling mistakes
grammar issues
punctuation errors
awkward wording
incomplete sentences
repetitive wording
unnecessary filler
Correct these issues only.
Do not change the documented events.

PHASE 3 — POLISH
Rewrite the Staff Note into one natural paragraph.
Improve:
grammar
spelling
readability
sentence flow
punctuation
Preserve:
original meaning
original sequence of events
original tone
original perspective
original level of detail
Do not expand the documentation.
Do not add new details.
Do not infer missing information.
Do not embellish the documentation.
The finished note should sound like authentic DSP documentation that has simply been cleaned up.

WRITING RULES
The polished note must:
remain under 100 words
preserve the staff member's voice
improve grammar and spelling
improve readability
improve sentence flow
remain concise
avoid repetitive wording
avoid unnecessary adjectives
use active voice whenever possible
sound natural from beginning to end
Only improve the writing quality.
Do not improve the documentation by adding information.

NON NEGOTIABLE RULES
Never:
mention Care Plan
mention Support Plan
mention Outcome
include headings
include titles
include signatures
include dates
include times
include shift information
include staff names
replace "Staff" or "DSP" with a person's name
use hyphens
use markdown formatting
return explanations
return comments
Do not copy wording directly from the Support Activities.
Do not introduce information that was not already documented in the Staff Note.

FORBIDDEN PHRASES
Never use phrases such as:
Overall
In summary
At the end of the day
Ultimately
In conclusion
It is important to note
Additionally
Furthermore
Moreover
As mentioned above
Avoid AI sounding transitions whenever possible.

QUALITY REVIEW
Before returning the final note, silently verify:
✓ The original meaning has been preserved.
✓ No new information has been introduced.
✓ The writing still sounds like the original staff member.
✓ Grammar and spelling have improved.
✓ Readability has improved.
✓ The level of detail has not changed.
✓ No ideas were added.
✓ No unnecessary repetition remains.
✓ The note reads naturally.
✓ The note is under 100 words.
✓ None of the forbidden words or phrases appear.
If any requirement fails, revise the note before returning the final response.

OUTPUT
Return only the polished documentation note.
Do not explain your reasoning.
Do not provide analysis.
Do not include markdown.
Do not include labels.
Do not include comments.
Do not include quotation marks.
Return only the final polished documentation note.
<<<<<<< HEAD

=======
>>>>>>> origin/production-secure

Use values defined below for the variables denoted in curly brackets

- State: ${selectedStateAbbr || ""}
- Date of Service: ${moment(noteDetails?.Date).format("MM/DD/YYYY") || ""}
- Session Type: ${isGroupNote ? "Group Session (multiple participants — the note must reflect observations and documentation for ALL participants listed below)" : "Individual Session"}
- Individual's Name or Identifier: ${isGroupNote ? selectedGroupClients.map(id => allPatients?.find(p => p?.id === id)?.name).filter(Boolean).join(', ') : selectedPatient?.name || ""}
- Support Activities : ${supportActivitiesSection || ""} ${tempEssentialSupport || ""}
- Staff Note = ${staffNoteValue}
- Staff Name and Title (Optional): ${staffDetials?.name || ""}
- Shift (Optional): ${noteDetails?.Shift || ""}
- Note Type (Required): ${noteDetails?.noteid?.name || ""}
- Facility Type (Required): ${facilityDetials?.name || ""}
    `;

    let rewriteNotePrompt = `
<<<<<<< HEAD
=======

>>>>>>> origin/production-secure
ROLE
You are an experienced Direct Support Professional (DSP) responsible for documenting services provided in a {Facility Type} located in {State}.
Your responsibility is to improve existing documentation while preserving the staff member's original meaning, writing style, and perspective.
You are editing documentation, not creating new events.
Never invent activities, behaviors, interventions, observations, or responses that are not supported by the provided information.

MISSION
Generate a revised {Note Type} for {Individual Name}.
The purpose of this task is to improve readability, clarity, grammar, organization, and documentation quality while preserving the original documentation.
The Staff Note is the primary source of truth.
The Support Activities exist only to clarify or lightly expand the Staff Note where appropriate.
Do not rewrite the note into a different style or personality.
The finished note should feel like the same staff member simply wrote a cleaner version of their original documentation.

SOURCE PRIORITY
Always resolve information using this order:
Priority 1: Staff Note
The Staff Note represents what the staff member directly documented and is the authoritative source.
Priority 2: Support Activities
Use Support Activities only to clarify or slightly expand the Staff Note.
Never allow Support Activities to replace, contradict, or overshadow the Staff Note.
If there is any conflict, always follow the Staff Note.

INPUTS
Staff Note
{Staff Note}
Support Activities
{Support Activities}

PHASE 1 — UNDERSTAND THE STAFF MEMBER
Before writing, determine the staff member's:
tone
vocabulary
sentence structure
writing style
level of detail
Preserve these characteristics throughout the rewritten note.
Do not rewrite the staff member's personality.
Do not make the writing more clinical unless the original Staff Note is already clinical.
If the Staff Note is casual, keep it casual.
If the Staff Note is brief, keep it brief.

PHASE 2 — REVIEW THE NOTE
Before rewriting, identify:
grammar issues
spelling mistakes
awkward wording
incomplete sentences
unnecessary repetition
missing transitions
opportunities to improve clarity
Correct these issues without changing the meaning of the documentation.
Do not introduce unrelated details.

PHASE 3 — REWRITE
Rewrite the Staff Note into one natural paragraph.
Improve readability while preserving:
original meaning
original sequence of events
original tone
original perspective
Use Support Activities only when they naturally clarify or complete an existing idea already present in the Staff Note.
Do not introduce new activities outside the scope of the Staff Note.
Do not make the documentation sound artificial or overly polished.
The final note should sound like authentic DSP documentation.

WRITING RULES
The rewritten note must:
remain under 100 words
preserve the staff member's voice
improve grammar and spelling
improve readability
improve sentence flow
remain concise
avoid repetitive wording
avoid unnecessary adjectives
use active voice whenever possible
sound natural from beginning to end
Rewrite only what needs improvement.
Do not over embellish the documentation.

NON NEGOTIABLE RULES
Never:
mention Care Plan
mention Support Plan
mention Outcome
include headings
include titles
include signatures
include dates
include times
include shift information
include staff names
replace "Staff" or "DSP" with a person's name
use hyphens
use markdown formatting
return explanations
return comments
Do not copy wording directly from the Support Activities.
Do not add information outside the scope of the Staff Note and Support Activities.

FORBIDDEN PHRASES
Never use phrases such as:
Overall
In summary
At the end of the day
Ultimately
In conclusion
It is important to note
Additionally
Furthermore
Moreover
As mentioned above
Avoid AI sounding transitions whenever possible.

QUALITY REVIEW
Before returning the rewritten note, silently verify:
✓ The original meaning has been preserved.
✓ The Staff Note remains the foundation of the response.
✓ The writing still sounds like the original staff member.
✓ Grammar and spelling have improved.
✓ No information was invented.
✓ Support Activities were used only to clarify existing ideas.
✓ No wording was copied directly from the Support Activities.
✓ No unnecessary repetition remains.
✓ The note reads naturally.
✓ The note is under 100 words.
✓ None of the forbidden words or phrases appear.
If any requirement fails, revise the note before returning the final response.

OUTPUT
Return only the rewritten documentation note.
Do not explain your reasoning.
Do not provide analysis.
Do not include markdown.
Do not include labels.
Do not include comments.
Do not include quotation marks.
Return only the final rewritten documentation note.


 Use values defined below for the variables denoted in curly brackets

 - State: ${selectedStateAbbr || ""}
- Date of Service: ${moment(noteDetails?.Date).format("MM/DD/YYYY") || ""}
- Session Type: ${isGroupNote ? "Group Session (multiple participants — the note must reflect observations and documentation for ALL participants listed below)" : "Individual Session"}
- Individual's Name or Identifier: ${isGroupNote ? selectedGroupClients.map(id => allPatients?.find(p => p?.id === id)?.name).filter(Boolean).join(', ') : selectedPatient?.name || ""}
- Support Activities : ${supportActivitiesSection || ""} ${tempEssentialSupport || ""}
- Staff Note = ${staffNoteValue}
- Staff Name and Title (Optional): ${staffDetials?.name || ""}
- Shift (Optional): ${noteDetails?.Shift || ""}
- Note Type (Required): ${noteDetails?.noteid?.name || ""}
- Facility Type (Required): ${facilityDetials?.name || ""}
    `;

    let elaborateNotePrompt = `
<<<<<<< HEAD
=======

>>>>>>> origin/production-secure
ROLE
You are an experienced Direct Support Professional (DSP) documenting services for a {Facility Type} in {State}.
Your responsibility is to expand the staff's original documentation into a complete, compliant progress note while preserving the staff member's authentic writing style.
Do not invent events outside the information provided.

WRITING OBJECTIVE
Generate a single {Note Type} for {Individual Name} using:
Staff Note
Support Activities
The Staff Note is the primary source of truth.
Support Activities exist only to expand and clarify the Staff Note.

INPUTS
Staff Note
{Staff Note}
Support Activities
{Support Activities}

PHASE 1 — UNDERSTAND THE STAFF NOTE
Before writing, determine:
the staff member's writing style
sentence length
vocabulary
level of detail
tone
point of view
The finished note must sound like it was written by the same staff member.
Do not rewrite their personality.
Do not make the writing more clinical unless the original note is already clinical.

PHASE 2 — PLAN THE NOTE
Before writing, identify:
activities offered
choices made by the individual
staff support provided
observations
behaviors
engagement
emotional presentation
interventions (if applicable)
Only use information that can reasonably be inferred from the Support Activities.
Never introduce unrelated events.

PHASE 3 — WRITE
Write one continuous paragraph.
The note should naturally include:
• activities presented
• choices made by the individual
• staff assistance
• observations
• responses to support
• any significant behaviors or incidents
Do not force every category into the note if it was not relevant.

WRITING RULES
The note must:
remain under 150 words
sound natural
preserve the original voice
read as though written immediately after the shift
be grammatically correct
flow naturally
avoid repetitive wording
avoid obvious AI phrasing

FORBIDDEN
Never:
mention Care Plan
mention Support Plan
mention Outcome
include headings
include signatures
include dates
include shift information
include staff names
replace "Staff" or "DSP" with a person's name
use hyphens
copy phrases from Support Activities verbatim
summarize the note
use phrases such as:
Overall
In summary
At the end of the day
Ultimately
In conclusion

QUALITY CHECK
Before returning the note, silently verify:
✓ Sounds like the original staff member
✓ Uses Staff Note as the foundation
✓ Support Activities are incorporated naturally
✓ No forbidden words appear
✓ Less than 150 words
✓ No repeated ideas
✓ No copied sentences from Support Activities
✓ Reads like authentic DSP documentation
If any check fails, revise before producing the final note.

OUTPUT
Return only the completed documentation note.
Do not explain your reasoning.
Do not include markdown.
Do not include comments.


Use values defined below for the variables denoted in curly brackets

 - State: ${selectedStateAbbr || ""}
- Date of Service: ${moment(noteDetails?.Date).format("MM/DD/YYYY") || ""}
- Session Type: ${isGroupNote ? "Group Session (multiple participants — the note must reflect observations and documentation for ALL participants listed below)" : "Individual Session"}
- Individual's Name or Identifier: ${isGroupNote ? selectedGroupClients.map(id => allPatients?.find(p => p?.id === id)?.name).filter(Boolean).join(', ') : selectedPatient?.name || ""}
- Support Activities : ${supportActivitiesSection || ""} ${tempEssentialSupport || ""}
- Staff Note = ${staffNoteValue}
- Staff Name and Title (Optional): ${staffDetials?.name || ""}
- Shift (Optional): ${noteDetails?.Shift || ""}
- Note Type (Required): ${noteDetails?.noteid?.name || ""}
- Facility Type (Required): ${facilityDetials?.name || ""}
    `;

    let behaviorPrompt = `
    SOURCE PRIORITY
Always follow this order when generating any output:
Staff input (Behavior / Response / Plan text)
Intervention / Objective / Goal context (if provided)
Standard-Terms / Mood-Words JSON (only when appropriate)
If there is any conflict or ambiguity:
→ Always prioritize the Staff input.
Never override staff documentation with inferred or external information.

VOICE PRESERVATION
The generated note must sound like the same staff member who wrote the original input.
Preserve:
tone
vocabulary
sentence structure
level of detail
formality level
If the Staff input is casual, keep it casual.
If it is clinical, keep it clinical.
If it is brief, keep it brief.
Do not rewrite the staff member’s personality.
Only improve clarity where necessary.

NON-NEGOTIABLE RULES (ALL SECTIONS)
Never include:
headers in final output
signatures
staff names
dates or timestamps
shift information
hyphens
markdown formatting
explanations or reasoning
Never mention:
Care Plan
Support Plan
Outcome
Intervention (in final text)
Objectives
Goals
Never invent:
behaviors
emotions
interventions
activities
responses
Only use what is supported by input.

OUTPUT RULE
Return ONLY the final generated note.
No commentary.
No explanation.
No formatting.


STANDARD-TERMS (REFERENCE ONLY)
General Disposition:
attentive, alert, calm, cheerful, well-groomed, coordinated, animated, spontaneous, consistent, goal-directed, orderly, deliberate, persistent, inquisitive, adaptable, transitions well, shows effort, helpful
Communication:
makes appropriate eye contact, understandable speech, fluent, engaging, articulate, cooperative, asks for help
Learning & Cognition:
stays on task, learns from doing, recognizes errors, actively involved in learning, applies him or herself
Following Directions:
follows one-step directions, follows multi-step directions, requires repetition, transitions with support
Support Needs:
accepts mistakes, needs visual cues, requires auditory cues, needs transition support

MOOD-WORDS (REFERENCE ONLY)
Positive:
calm, happy, content, cheerful, relaxed, pleased, grateful, optimistic, energetic, peaceful
Negative:
sad, angry, anxious, frustrated, irritated, depressed, confused, overwhelmed, tired
Neutral:
tired, sleepy, indifferent, surprised, quiet, restless
High Energy:
excited, hyper, energetic, animated
Low Energy:
drained, exhausted, lethargic, sleepy


INPUTS
Behavior: {Behavior}
Identified Goals: {Identified goals}
Objective: {Objective}
Intervention: {Intervention}

ROLE
You are a Direct Support Professional documenting observed client behavior.

MISSION
Generate a behavior observation note based only on the provided Behavior input.
Use Mood-Words only when they accurately match observed behavior.

MOOD WORD USAGE RULES
Mood-Words are optional reference vocabulary.
Use only if strongly supported by Behavior input
Never exaggerate emotional state
Never assign mood without evidence
Do not force inclusion of mood terms

STANDARD-TERMS USAGE RULES
Standard-Terms are optional descriptive vocabulary.
Use naturally when relevant
Do not overuse or force terms
Only include if directly supported by Behavior input

WRITE
Create a concise behavioral observation that:
reflects staff observation only
describes what was seen or reported
stays within provided scope
avoids clinical expansion unless already present in input

LENGTH LIMIT
Maximum 100 words.

QUALITY CHECK
Before output, verify:
no invented behavior
no added context
matches Staff tone
stays under 100 words


Use values defined below for the variables denoted in curly brackets
 ${tempInterventionPlan || ""}

  - Behavior = ${
    noteDetails?.noteid?.name === "Intervention Progress Note" && interventionPlanToggle === "yes"
      ? selectedIntervention?.behaviorDescription?.trim() || ""
      : noteDetails?.Description?.trim() || ""
  }

 - Identified goals : ${selectedIntervention?.identifiedGoal || ""}
 - State : ${selectedStateAbbr || ""}
 - Facility Type : ${facilityDetials?.name || ""}
     `;

    let responsePrompt = `
    SOURCE PRIORITY
Always follow this order when generating any output:
Staff input (Behavior / Response / Plan text)
Intervention / Objective / Goal context (if provided)
Standard-Terms / Mood-Words JSON (only when appropriate)
If there is any conflict or ambiguity:
→ Always prioritize the Staff input.
Never override staff documentation with inferred or external information.

VOICE PRESERVATION
The generated note must sound like the same staff member who wrote the original input.
Preserve:
tone
vocabulary
sentence structure
level of detail
formality level
If the Staff input is casual, keep it casual.
If it is clinical, keep it clinical.
If it is brief, keep it brief.
Do not rewrite the staff member’s personality.
Only improve clarity where necessary.

NON-NEGOTIABLE RULES (ALL SECTIONS)
Never include:
headers in final output
signatures
staff names
dates or timestamps
shift information
hyphens
markdown formatting
explanations or reasoning
Never mention:
Care Plan
Support Plan
Outcome
Intervention (in final text)
Objectives
Goals
Never invent:
behaviors
emotions
interventions
activities
responses
Only use what is supported by input.

OUTPUT RULE
Return ONLY the final generated note.
No commentary.
No explanation.
No formatting.


STANDARD-TERMS (REFERENCE ONLY)
General Disposition:
attentive, alert, calm, cheerful, well-groomed, coordinated, animated, spontaneous, consistent, goal-directed, orderly, deliberate, persistent, inquisitive, adaptable, transitions well, shows effort, helpful
Communication:
makes appropriate eye contact, understandable speech, fluent, engaging, articulate, cooperative, asks for help
Learning & Cognition:
stays on task, learns from doing, recognizes errors, actively involved in learning, applies him or herself
Following Directions:
follows one-step directions, follows multi-step directions, requires repetition, transitions with support
Support Needs:
accepts mistakes, needs visual cues, requires auditory cues, needs transition support

MOOD-WORDS (REFERENCE ONLY)
Positive:
calm, happy, content, cheerful, relaxed, pleased, grateful, optimistic, energetic, peaceful
Negative:
sad, angry, anxious, frustrated, irritated, depressed, confused, overwhelmed, tired
Neutral:
tired, sleepy, indifferent, surprised, quiet, restless
High Energy:
excited, hyper, energetic, animated
Low Energy:
drained, exhausted, lethargic, sleepy


   INPUTS
Response: {Response}
Identified Goals: {Identified goals}
Objective: {Objective}
Intervention: {Intervention}

ROLE
You are a DSP or QMHP documenting client response to an intervention.

MISSION
Generate a response note describing how the client reacted to interventions provided.
One response must be created for each Intervention mentioned.

RESPONSE RULES
Base strictly on Response input
Use Standard-Terms only when appropriate
Do not expand beyond provided interventions
Do not infer additional interventions
Do not generalize outcomes

STRUCTURE RULE
Must be at least 5 sentences
Must be clear and observational
Must remain grounded in provided intervention context

LENGTH RULE
Each response section:
Minimum 150 words
May exceed if necessary for clarity
Must not include filler or repetition

QUALITY CHECK
Before output verify:
each intervention addressed
no invented response
no outcome summarization
no clinical escalation beyond input
Use values defined below for the variables denoted in curly brackets
  - Response = ${
    noteDetails?.noteid?.name === "Intervention Progress Note" && interventionPlanToggle === "yes"
      ? selectedIntervention?.responseDescription?.trim() || ""
      : noteDetails?.Description?.trim() || ""
  }

 - Identified goals : ${selectedIntervention?.identifiedGoal || ""}
 - State : ${selectedStateAbbr || ""}
 - Facility Type : ${facilityDetials?.name || ""}
     `;

    let planPrompt = `
<<<<<<< HEAD
    SOURCE PRIORITY
Always follow this order when generating any output:
Staff input (Behavior / Response / Plan text)
Standard-Terms / Mood-Words JSON (only when appropriate)
If there is any conflict or ambiguity:
→ Always prioritize the Staff input.
Never override staff documentation with inferred or external information.

VOICE PRESERVATION
The generated note must sound like the same staff member who wrote the original input.
Preserve:
tone
vocabulary
sentence structure
level of detail
formality level
If the Staff input is casual, keep it casual.
If it is clinical, keep it clinical.
If it is brief, keep it brief.
Do not rewrite the staff member’s personality.
Only improve clarity where necessary.

NON-NEGOTIABLE RULES (ALL SECTIONS)
Never include:
headers in final output
signatures
staff names
dates or timestamps
shift information
hyphens
markdown formatting
explanations or reasoning
Never mention:
Care Plan
Support Plan
Outcome
Intervention (in final text)
Objectives
Goals
Never invent:
behaviors
emotions
interventions
activities
responses
Only use what is supported by input.

OUTPUT RULE
Return ONLY the final generated note.
No commentary.
No explanation.
No formatting.

    STANDARD-TERMS (REFERENCE ONLY)
General Disposition:
attentive, alert, calm, cheerful, well-groomed, coordinated, animated, spontaneous, consistent, goal-directed, orderly, deliberate, persistent, inquisitive, adaptable, transitions well, shows effort, helpful
Communication:
makes appropriate eye contact, understandable speech, fluent, engaging, articulate, cooperative, asks for help
Learning & Cognition:
stays on task, learns from doing, recognizes errors, actively involved in learning, applies him or herself
Following Directions:
follows one-step directions, follows multi-step directions, requires repetition, transitions with support
Support Needs:
accepts mistakes, needs visual cues, requires auditory cues, needs transition support

MOOD-WORDS (REFERENCE ONLY)
Positive:
calm, happy, content, cheerful, relaxed, pleased, grateful, optimistic, energetic, peaceful
Negative:
sad, angry, anxious, frustrated, irritated, depressed, confused, overwhelmed, tired
Neutral:
tired, sleepy, indifferent, surprised, quiet, restless
High Energy:
excited, hyper, energetic, animated
Low Energy:
drained, exhausted, lethargic, sleepy

   INPUTS
Plan: {Plan}
Objective: {Objective}
Intervention: {Intervention}

ROLE
You are a DSP or QMHP documenting the next-step plan for client care.

MISSION
Generate a forward-looking plan based only on provided Plan input.
Focus only on next steps.

PLAN RULES
Do not summarize past events
Do not restate behavior or response
Only describe next actions until next session
Include:
next steps
assignments or activities
follow-up actions
referrals (only if explicitly supported)
scheduling considerations

LENGTH RULE
Each plan entry:
50 to 70 words
Must stay within range strictly

QUALITY CHECK
Before output verify:
no retrospective content
no invented actions
within word range
aligned to Plan input only

=======

      SOURCE PRIORITY
Always follow this order when generating any output:

   - Plan  = ${
     noteDetails?.noteid?.name === "Intervention Progress Note" && interventionPlanToggle === "yes"
       ? selectedIntervention?.planDescription?.trim() || ""
       : noteDetails?.Description?.trim() || ""
   }

 - Identified goals : ${selectedIntervention?.identifiedGoal || ""}
 - State : ${selectedStateAbbr || ""}
 - Facility Type : ${facilityDetials?.name || ""}
     `;

    const finalPrompt =
      interventionPlanToggle === "yes" && value === "behavior" ? behaviorPrompt
      : value === "response" ? responsePrompt
      : value === "plan" ? planPrompt
      : value === "polishNotePrompt" ? polishNotePrompt
      : value === "rewriteNotePrompt" ? rewriteNotePrompt
      : value === "elaborateNotePrompt" ? elaborateNotePrompt
      : promptCommon;

    return finalPrompt;
  };

  // ── handleDualCompare: fires both providers simultaneously and shows ComparePanel ──
  const handleDualCompare = async (promptKey, context) => {
    if (!["behavior", "response", "plan", "custom-description"].includes(promptKey)) {
      const errors = validatePromptFields();
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        return;
      }
    }
    setFormErrors({});

    if (existingRecord?.active === false && existingRecord?.paid === false) {
      swal({
        title: "AI Note Assistant Credits Not Found",
        text: "You have not purchased any AI credits yet. Please visit the Settings page and navigate to the AI credits section to buy credits.",
        icon: "info",
        dangerMode: false,
      });
      return;
    }
    if (existingRecord?.planType === "onetime-purchase") {
      const tokensUsage = existingRecord?.adminTotalTokens;
      const totalTokens = Number(tokensUsage?.adminTotalTokens);
      const usedTokens = Number(tokensUsage?.adminUsedTokens);
      const originalTotal = totalTokens + usedTokens;
      const percentageUsed = originalTotal > 0 ? Math.round((usedTokens / originalTotal) * 100) : 0;
      if (percentageUsed >= 100) {
        setShowWarning(true);
        swal({ title: "AI Note Assistant Quota Reached", text: "You've reached your monthly AI Note Assistant quota. Please contact your admin if you need additional access.", icon: "error", dangerMode: true });
        return;
      }
      if (percentageUsed >= 90) {
        setShowWarning(true);
        swal({ title: "AI Note Assistant Quota Exceeded", text: "You've used 90% of your AI Note Assistant quota for this month. Continued use may require admin approval.", icon: "warning", dangerMode: true });
      }
    }

    setAiActionsOpen(false);
    setComparePanel((prev) => ({
      ...COMPARE_PANEL_RESET,
      open: true, action: promptKey, context,
      loading1: true, loading2: true,
      ollamaAvailable: false,
      regenerationCount: prev.open && prev.action === promptKey ? prev.regenerationCount + 1 : 0,
    }));

    const finalPrompt = buildFinalPrompt(promptKey);
    const adminId = profile?.user?.admin || profile?.user?.id;

    generateBothAiNotes(finalPrompt, adminId).then((data) => {
      const m1 = data?.option1_model ?? "openai-gpt-4o-mini";
      const m2 = data?.option2_model ?? "ollama-phi3:3.8b";
      setComparePanel((prev) => ({
        ...prev,
        option1: data?.openaiReply || "Unable to generate response from OpenAI.",
        option2: data?.ollamaReply || "Unable to generate response from Ollama.",
        option1Model: m1,
        option2Model: m2,
        option1WordCount: data?.option1_word_count ?? null,
        option2WordCount: data?.option2_word_count ?? null,
        option1LatencyMs: data?.option1_latency_ms ?? null,
        option2LatencyMs: data?.option2_latency_ms ?? null,
        ollamaAvailable: data?.ollamaAvailable ?? true,
        loading1: false,
        loading2: false,
      }));
      trackAiSuggestionShown({
        action: normalizeAction(promptKey),
        option_1_model: m1,
        option_2_model: m2,
        note_type: noteType?.name || "",
      });
      setShowWarning(false);
    }).catch(() => {
      setComparePanel((prev) => ({
        ...prev,
        option1: "Unable to generate response from OpenAI.",
        option2: "Unable to generate response from Ollama.",
        loading1: false,
        loading2: false,
      }));
    });
  };

  // ── handleQuickNotesInsert: appends selected library activities as text into whichever textarea Quick Notes was opened from ──
  // `items` ({name, type}[]) carries each activity's hidden Activity Type — not persisted yet
  // (no note field for it), but available here for a future AI/reporting/analytics integration.
  const handleQuickNotesInsert = (text, items) => {
    if (!quickNotesTarget || !text) return;
    const existing = (quickNotesTarget.getValue() || "").trim();
    quickNotesTarget.setValue(existing ? `${existing}\n${text}` : text);
    setQuickNotesTarget(null);
  };

  // ── handleUseCompareOption: applies the chosen option to the correct field ──
  const handleUseCompareOption = (text, context, meta) => {
    if (!text) return;
    if (context === "main") {
      form.setFieldValue("Description", text);
    } else if (context?.startsWith("description_")) {
      const idx = Number(context.split("_")[1]);
      setDescriptions((prev) => {
        const updated = [...prev];
        updated[idx] = { ...updated[idx], description: text };
        return updated;
      });
    } else if (context?.startsWith("essential_")) {
      const idx = Number(context.split("_")[1]);
      setEssentialSupport((prev) => {
        const updated = [...prev];
        updated[idx] = { ...updated[idx], description: text };
        return updated;
      });
    } else if (context === "behavior") {
      setGoals((prev) => {
        const updated = [...prev];
        updated[goalsAccordion] = { ...updated[goalsAccordion], behaviorDescription: text };
        return updated;
      });
    } else if (context === "response") {
      setGoals((prev) => {
        const updated = [...prev];
        updated[goalsAccordion] = { ...updated[goalsAccordion], responseDescription: text };
        return updated;
      });
    } else if (context === "plan") {
      setGoals((prev) => {
        const updated = [...prev];
        updated[goalsAccordion] = { ...updated[goalsAccordion], planDescription: text };
        return updated;
      });
    }

    console.log("[AI-DEBUG] handleUseCompareOption reached, context:", context);
    setComparePanel((prev) => {
      console.log("[AI-DEBUG] setComparePanel updater running, prev.action:", prev.action);
      const { displaySlot, slot1Model, slot2Model } = meta || {};
      const chosenModel = displaySlot === 1 ? slot1Model : slot2Model;
      aiTouchedFieldsRef.current[context] = {
        action: normalizeAction(prev.action),
        chosen_model: chosenModel ?? null,
        final_text: text,
      };
      console.log("[AI-DEBUG] aiTouchedFieldsRef after set:", aiTouchedFieldsRef.current);
      trackAiSuggestionResolved({
        action: normalizeAction(prev.action),
        outcome: "selected",
        option_chosen: displaySlot ?? null,
        chosen_model: chosenModel ?? null,
        regeneration_count: prev.regenerationCount,
        note_type: noteType?.name || "",
      });
      logAiSuggestionEvent({
        note_type: noteType?.name || "",
        action: normalizeAction(prev.action),
        option_1_model: slot1Model ?? prev.option1Model,
        option_2_model: slot2Model ?? prev.option2Model,
        option_1_word_count: prev.option1WordCount,
        option_2_word_count: prev.option2WordCount,
        option_1_latency_ms: prev.option1LatencyMs,
        option_2_latency_ms: prev.option2LatencyMs,
        selected_option: displaySlot ? String(displaySlot) : null,
        regeneration_count: prev.regenerationCount,
      });
      return { ...prev, open: false };
    });
  };

  // ── handleArrangeCompare: stores the actual display-slot model order in state ──
  const handleArrangeCompare = ({ slot1Model, slot2Model }) => {
    setComparePanel((prev) => ({ ...prev, slot1Model, slot2Model }));
  };

  // ── handleCancelCompare: fires dismissed telemetry and closes the panel ──
  const handleCancelCompare = () => {
    setComparePanel((prev) => {
      trackAiSuggestionResolved({
        action: normalizeAction(prev.action),
        outcome: "dismissed",
        option_chosen: null,
        chosen_model: null,
        regeneration_count: prev.regenerationCount,
        note_type: noteType?.name || "",
      });
      logAiSuggestionEvent({
        note_type: noteType?.name || "",
        action: normalizeAction(prev.action),
        option_1_model: prev.slot1Model ?? prev.option1Model,
        option_2_model: prev.slot2Model ?? prev.option2Model,
        option_1_word_count: prev.option1WordCount,
        option_2_word_count: prev.option2WordCount,
        option_1_latency_ms: prev.option1LatencyMs,
        option_2_latency_ms: prev.option2LatencyMs,
        selected_option: null,
        regeneration_count: prev.regenerationCount,
      });
      return { ...prev, open: false };
    });
  };

  const recordingTypeRef = useRef(recordingType);
  useEffect(() => {
    recordingTypeRef.current = recordingType;
  }, [recordingType]);

  const originalStaffNoteRef = useRef("");

  const { startListening, stopListening } = useSpeechToText((transcript) => {
    form.setFieldValue("Description", transcript);

    if (recordingTypeRef.current === "description") {
      const updatedDescriptions = [...descriptions];
      updatedDescriptions[openedAccordion] = {
        ...updatedDescriptions[openedAccordion],
        description: transcript,
      };
      setDescriptions(updatedDescriptions);
    }

    if (
      recordingTypeRef.current === "essential" &&
      essentialSupport?.length > 0
    ) {
      const updatedEssentialDes = [...essentialSupport];
      updatedEssentialDes[essentialAccordion] = {
        ...updatedEssentialDes[essentialAccordion],
        description: transcript,
      };
      setEssentialSupport(updatedEssentialDes);
    } else if (recordingTypeRef.current === "behavior" && goals?.length > 0) {
      const updatedGoals = [...goals];
      updatedGoals[goalsAccordion] = {
        ...updatedGoals[goalsAccordion],
        behaviorDescription: transcript,
      };
      setGoals(updatedGoals);
    } else if (recordingTypeRef.current === "response" && goals?.length > 0) {
      const updatedGoals = [...goals];
      updatedGoals[goalsAccordion] = {
        ...updatedGoals[goalsAccordion],
        responseDescription: transcript,
      };
      setGoals(updatedGoals);
    } else if (recordingTypeRef.current === "plan" && goals?.length > 0) {
      const updatedGoals = [...goals];
      updatedGoals[goalsAccordion] = {
        ...updatedGoals[goalsAccordion],
        planDescription: transcript,
      };
      setGoals(updatedGoals);
    }
  });

  const startTimer = () => {
    setRecordingTime(0);
    timerRef.current = setInterval(() => {
      setRecordingTime((prev) => prev + 1);
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = null;
  };

  const handleMicStart = (type) => {
    if (type === "behavior") {
      setMicLabel(type);
      setRecordingType(type);
    } else if (type === "response") {
      setMicLabel(type);
      setRecordingType(type);
    } else if (type === "plan") {
      setMicLabel(type);
      setRecordingType(type);
    } else {
      setIsListening(true);
      setRecordingType(type);
    }
    startTimer();
    startListening();
  };

  const handleRecordingCancel = (type) => {
    form.setFieldValue("Description", "");
    if (recordingTypeRef.current === "description") {
      const updatedDescriptions = [...descriptions];
      updatedDescriptions[openedAccordion] = {
        ...updatedDescriptions[openedAccordion],
        description: "",
      };
      setDescriptions(updatedDescriptions);
    }
    if (
      recordingTypeRef.current === "essential" &&
      essentialSupport?.length > 0
    ) {
      const updatedEssentialDes = [...essentialSupport];
      updatedEssentialDes[essentialAccordion] = {
        ...updatedEssentialDes[essentialAccordion],
        description: "",
      };
      setEssentialSupport(updatedEssentialDes);
    }
    if (type === "behavior") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        behaviorDescription: "",
      };
      setGoals(updatedGoalDes);
      setMicLabel(false);
    } else if (type === "response") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        responseDescription: "",
      };
      setGoals(updatedGoalDes);
      setMicLabel(false);
    } else if (type === "plan") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        planDescription: "",
      };
      setGoals(updatedGoalDes);
      setMicLabel(false);
    }
    stopListening();
    stopTimer();
    setRecordingTime(0);
    setIsListening(false);
  };

  const handleRecordingConfirm = (type) => {
    stopListening();
    stopTimer();
    if (type === "behavior") {
      setMicLabel(false);
    } else if (type === "response") {
      setMicLabel(false);
    } else if (type === "plan") {
      setMicLabel(false);
    } else {
      setIsListening(false);
    }
  };

  let isAiAccess =
    !profile?.user?.role && !profile?.user?.type
      ? true
      : facilityDetials &&
        (facilityDetials?.skaiAccess === true ||
          facilityDetials?.skaiAccess === undefined) &&
        staffDetials &&
        (staffDetials?.permissions?.aiAccess === true ||
          !staffDetials?.permissions);

  // Quick Notes needs to know which client/facility the note is for before a
  // DSP can pick activities for it.
  const quickNotesDisabled = !form.values["Client Name"] || !form.values["Facility Name"];

  const handleRedo = (type) => {
    form.setFieldValue("Description", "");
    if (recordingTypeRef.current === "description") {
      const updatedDescriptions = [...descriptions];
      updatedDescriptions[openedAccordion] = {
        ...updatedDescriptions[openedAccordion],
        description: "",
      };
      setDescriptions(updatedDescriptions);
    }
    if (
      recordingTypeRef.current === "essential" &&
      essentialSupport?.length > 0
    ) {
      const updatedEssentialDes = [...essentialSupport];
      updatedEssentialDes[essentialAccordion] = {
        ...updatedEssentialDes[essentialAccordion],
        description: "",
      };
      setEssentialSupport(updatedEssentialDes);
    }
    if (type === "behavior") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        behaviorDescription: "",
      };
      setGoals(updatedGoalDes);
    } else if (type === "response") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        responseDescription: "",
      };
      setGoals(updatedGoalDes);
    } else if (type === "plan") {
      const updatedGoalDes = [...goals];
      updatedGoalDes[goalsAccordion] = {
        ...updatedGoalDes[goalsAccordion],
        planDescription: "",
      };
      setGoals(updatedGoalDes);
    }

    stopListening();
    stopTimer();
    setRecordingTime(0);
    startTimer();
    startListening();
  };
  const isAdmin = profile?.user?.role === "admin" || !profile?.user?.type;

  // Staff Signature block — rendered above each Cancel/Save button
  const renderSignature = () => {
    if (!noteType) return null;
    if (!staffSignature?.signature && !staffSignature?.signatureImage && !staffSignature?.signatureText) return null;
    return (
      <Box style={{ padding: "16px", borderTop: "1px solid var(--app-border)", marginTop: 16 }}>
        <Text ff="Inter" fz={12} fw={600} c="var(--app-text-muted)" mb={8} style={{ textTransform: "uppercase", letterSpacing: "0.05em" }}>
          Staff Signature
        </Text>
        {/* Signatures are dark ink strokes — keep a white chip on every theme */}
        <Box style={{ padding: "12px 16px", backgroundColor: "#FFFFFF", borderRadius: 8, border: "1px solid var(--app-border)" }}>
          {staffSignature?.signature || staffSignature?.signatureImage ? (
            <img src={decrypt(staffSignature?.signature) || decrypt(staffSignature?.signatureImage)} alt="Staff Signature" style={{ maxHeight: 60, objectFit: "contain" }} />
          ) : staffSignature?.signatureText ? (
            <Text fz={28} fw={400} ff="Island Moments" color="#171717">{staffSignature?.signatureText}</Text>
          ) : null}
        </Box>
      </Box>
    );
  };

  const ReturnFormItem = (data, index, textArea = "") => {
    let { field: name, fieldType, placeholder, viewOnly } = data;
    if (
      textArea &&
      supportPlan !== "yes" &&
      essentialSupportToggle === "no" &&
      interventionPlanToggle === "no" &&
      data?.field === "Description" &&
      (noteType?.name === "Progress Note" ||
        noteType?.id === Essential_Support_Note)
    ) {
      return (
        <Box>
          <Box>
            <Text fz={14} fw={500} c="var(--app-text)" mb={8} ff="Inter">Description</Text>
            <Box
              sx={{
                border: "1px solid #e2e8f0",
                borderRadius: 12,
                background: "var(--app-surface)",
                overflow: "hidden",
                boxShadow: "0 1px 2px rgba(16,24,40,.05)",
                "&:focus-within": {
                  borderColor: "#7856ff",
                  boxShadow: "0 0 0 3px rgba(120,86,255,.16)",
                },
              }}
            >
              <Textarea
                key={index}
                maxRows={10}
                minRows={10}
                placeholder={placeholder || "Enter a description..."}
                autosize={view || (viewOnly ? true : false) ? true : false}
                styles={{
                  wrapper: { border: "none", boxShadow: "none", padding: 0, borderRadius: 0 },
                  input: { border: "none", borderRadius: 0, background: "transparent", padding: "14px 16px", color: "var(--app-text)", fontSize: 14, fontWeight: 400, fontFamily: "Inter", lineHeight: 1.55 },
                }}
                {...form.getInputProps(name)}
                readOnly={view || (viewOnly ? true : false)}
              />
              {!view && isAiAccess && (
                <>
                  <AiActionButtons
                    onMicClick={() => handleMicStart("essential")}
                    onActionClick={(key) => handleDualCompare(key, "main")}
                    onSparklesClick={() => setAiActionsOpen((prev) => !prev)}
                    onQuickNotesClick={() => setQuickNotesTarget({ key: "main", getValue: () => form.values[name], setValue: (v) => form.setFieldValue(name, v) })}
                    quickNotesDisabled={quickNotesDisabled}
                    micDisabled={view || (existingRecord?.active === false && existingRecord?.paid === false)}
                    actionsDisabled={view || form.values.Description === "" || !form.values.Description}
                    aiActionsOpen={aiActionsOpen}
                  />
                  {comparePanel.open && comparePanel.context === "main" && (
                    <ComparePanel
                      action={comparePanel.action}
                      option1={comparePanel.option1}
                      option2={comparePanel.option2}
                      loading1={comparePanel.loading1}
                      loading2={comparePanel.loading2}
                      option1Model={comparePanel.option1Model}
                      option2Model={comparePanel.option2Model}
                      ollamaAvailable={comparePanel.ollamaAvailable}
                      onArrange={handleArrangeCompare}
                      onUse={(text, meta) => handleUseCompareOption(text, "main", meta)}
                      onCancel={handleCancelCompare}
                      onRegenerate={() => handleDualCompare(comparePanel.action, "main")}
                    />
                  )}
                  <QuickNotesPicker
                    opened={quickNotesTarget?.key === "main"}
                    close={() => setQuickNotesTarget(null)}
                    onInsert={handleQuickNotesInsert}
                    hideCarePlan={!hasCarePlan}
                  />
                </>
              )}
            </Box>
          </Box>
          <RecordingControls
            isListening={isListening}
            recordingTime={recordingTime}
            onRedo={handleRedo}
            onCancel={handleRecordingCancel}
            onConfirm={handleRecordingConfirm}
            classes={classes}
          />
        </Box>
      );
    }

    let obj = {
      string: (
        <TextInput
          size="md"
          radius="md"
          id="reason"
          key={index}
          type="text"
          label={name}
          className={classes.datePicker}
          // className={classes.essentialDiscriptionArea}
          {...form.getInputProps(name)}
          disabled={view || (viewOnly ? true : false)}
          placeholder={placeholder || `Enter response`}
        />
      ),
      "text area": (
        <>
          {data?.field === "Description" ? (
            <>
              <Text fz={14} fw={500} c="var(--app-text)" mb={8} ff="Inter">{name}</Text>
              <Box
                sx={{
                  border: "1px solid #e2e8f0",
                  borderRadius: 12,
                  background: "var(--app-surface)",
                  overflow: "hidden",
                  boxShadow: "0 1px 2px rgba(16,24,40,.05)",
                  "&:focus-within": {
                    borderColor: "#7856ff",
                    boxShadow: "0 0 0 3px rgba(120,86,255,.16)",
                  },
                }}
              >
                <Textarea
                  id="enter-description"
                  key={index}
                  minRows={view || (viewOnly ? true : false) ? 7 : 7}
                  maxRows={view || (viewOnly ? true : false) ? 15 : 15}
                  autosize={view || (viewOnly ? true : false) ? true : false}
                  placeholder={placeholder || `Enter response`}
                  styles={{
                    wrapper: { border: "none", boxShadow: "none", padding: 0, borderRadius: 0 },
                    input: { border: "none", borderRadius: 0, background: "transparent", padding: "14px 16px", color: "var(--app-text)", fontSize: 14, fontWeight: 400, fontFamily: "Inter", lineHeight: 1.55 },
                  }}
                  {...form.getInputProps(name)}
                  readOnly={view || viewOnly ? true : false}
                />
                {!view && isAiAccess && (
                  <>
                    <AiActionButtons
                      onMicClick={() => handleMicStart("essential")}
                      onActionClick={(key) => handleDualCompare(key, "main")}
                      onSparklesClick={() => setAiActionsOpen((prev) => !prev)}
                      onQuickNotesClick={() => setQuickNotesTarget({ key: "main", getValue: () => form.values[name], setValue: (v) => form.setFieldValue(name, v) })}
                      quickNotesDisabled={quickNotesDisabled}
                      micDisabled={view || (existingRecord?.active === false && existingRecord?.paid === false)}
                      actionsDisabled={view || !form.values.Description?.trim()}
                      aiActionsOpen={aiActionsOpen}
                    />
                    {comparePanel.open && comparePanel.context === "main" && (
                      <ComparePanel
                        action={comparePanel.action}
                        option1={comparePanel.option1}
                        option2={comparePanel.option2}
                        loading1={comparePanel.loading1}
                        loading2={comparePanel.loading2}
                        option1Model={comparePanel.option1Model}
                        option2Model={comparePanel.option2Model}
                        ollamaAvailable={comparePanel.ollamaAvailable}
                        onArrange={handleArrangeCompare}
                        onUse={(text, meta) => handleUseCompareOption(text, "main", meta)}
                        onCancel={handleCancelCompare}
                        onRegenerate={() => handleDualCompare(comparePanel.action, "main")}
                      />
                    )}
                    <QuickNotesPicker
                      opened={quickNotesTarget?.key === "main"}
                      close={() => setQuickNotesTarget(null)}
                      onInsert={handleQuickNotesInsert}
                      hideCarePlan={!hasCarePlan}
                    />
                  </>
                )}
              </Box>
            </>
          ) : (
            <Textarea
              id={
                data?.field === "Medication"
                  ? "enter-medication"
                  : "enter-note"
              }
              key={index}
              label={name}
              minRows={view || (viewOnly ? true : false) ? 7 : 7}
              maxRows={view || (viewOnly ? true : false) ? 15 : 15}
              autosize={view || (viewOnly ? true : false) ? true : false}
              placeholder={placeholder || `Enter response`}
              className={`${classes.essentialDiscriptionArea} ${
                view || (viewOnly ? true : false) ? classes.disabledTextarea : ""
              }`}
              radius="md"
              {...form.getInputProps(name)}
              readOnly={view || viewOnly ? true : false}
            />
          )}

          {data?.field === "Description" ? (
            <>
              <RecordingControls
                isListening={isListening}
                recordingTime={recordingTime}
                onRedo={handleRedo}
                onCancel={handleRecordingCancel}
                onConfirm={handleRecordingConfirm}
                classes={classes}
              />
              {/* {isListening && (
            <Box className={classes.waveSection}>
              <Box className={classes.wave}>
                <WaveformVisualizer isActive={isListening} />
              </Box>

              <Box className={classes.waveButtons}>
                <Button
                  variant="light"
                  color="gray"
                  radius={"xl"}
                  size="xs"
                  onClick={handleRedo}
                >
                  <Flex align={"center"} gap={5}>
                    <RecordingRedoSvg />
                    <Text c={"var(--app-text)"}>Redo</Text>
                  </Flex>
                </Button>
                <Flex align={"center"} gap={5}>
                  <UnstyledButton
                    variant="outline"
                    color="gray"
                    onClick={handleRecordingCancel}
                  >
                    <RecordingCancelSvg />
                  </UnstyledButton>
                  <Text size="sm" mt="sm" color="dimmed" pb={15}>
                    {formatTime(recordingTime)}
                  </Text>
                  <UnstyledButton onClick={handleRecordingConfirm}>
                    <RecordingTickMarkSvg />
                  </UnstyledButton>
                </Flex>
              </Box>
            </Box>
          )} */}
            </>
          ) : null}
        </>
      ),

      number: (
        <Flex direction={"column"}>
          {isBilling_Services ? (
            <>
              <TextInput
                size="md"
                radius="md"
                key={index}
                label={name}
                type="number"
                className={classes.input}
                {...form.getInputProps(name)}
                disabled={view || (viewOnly ? true : false) || !serviceNumber}
                placeholder={placeholder || `Enter response`}
              />
              {isBilling_Services && (
                <Text fz={12} fs="italic" c={"#ccc"}>
                  Approved Units: {serviceNumber?.servicenumber}
                </Text>
              )}
            </>
          ) : (
            <TextInput
              size="md"
              radius="md"
              key={index}
              label={name}
              type="number"
              className={classes.input}
              {...form.getInputProps(name)}
              disabled={view || (viewOnly ? true : false)}
              placeholder={placeholder || `Enter response`}
            />
          )}
        </Flex>
      ),

      time: (
        <TimeInput
          size="md"
          radius="md"
          label={name}
          key={index}
          ref={ref}
          placeholder={`Select ${name}`}
          className={classes.datePicker}
          icon={
            <img
              style={{ width: "20px" }}
              src={"/assets/images/clock.png"}
              alt="Icon"
            />
          }
          {...form.getInputProps(name)}
          onChange={(e) => {
            const isSafari = /^((?!chrome|android).)*safari/i.test(
              navigator.userAgent
            );
            const datetime = new Date(e.target.value).toLocaleTimeString(
              "en-US",
              { hour12: false }
            );
            let time = e.target.value.split(":")?.slice(0, 2)?.join(":");
            isSafari
              ? form.setFieldValue(name, time)
              : form.setFieldValue(name, e.target.value);
          }}
          disabled={view || (viewOnly ? true : false)}
        />
      ),
      date: (
        <DateInput
          size="md"
          radius="md"
          key={index}
          label={name}
          id="date-click"
          icon={<DateSvg />}
          className={classes.datePicker}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          disabled={view || (viewOnly ? true : false)}
          maxDate={isBilling_Services ? today : null}
        />
      ),
      Clients: isGroupNoteCreating ? (
        <Box>
          <MultiSelect
            size="md"
            radius="md"
            searchable
            label={name}
            className={classes.gcMultiSelect}
            classNames={{
              value: classes.gcMsPill,
              defaultValueRemove: classes.gcMsPillRemove,
              item: classes.gcMsItem,
            }}
            placeholder={selectedFacility ? "Select clients..." : "Select a facility first"}
            rightSection={<IconChevronDown size={16} />}
            rightSectionPointerEvents="none"
            value={selectedGroupClients}
            onChange={setSelectedGroupClients}
            withAsterisk
            data={
              allPatients
                ?.filter(
                  (_p) =>
                    _p?.active === true &&
                    _p?.deleted === false &&
                    _p?.facilityId?.some((f) => f?.id === selectedFacility)
                )
                ?.map((opt) => ({ value: opt?.id, label: opt?.name })) || []
            }
            disabled={view || (viewOnly ? true : false) || !selectedFacility}
            maxDropdownHeight={240}
          />
          <Flex className={classes.gcHint}>
            <IconInfoCircle size={14} />
            All clients who participated in this group session. Unselect anyone who did not attend.
          </Flex>
        </Box>
      ) : (
        <Select
          size="md"
          radius="md"
          searchable
          label={name}
          className={classes.select}
          rightSection={icon}
          defaultValue={form?.getInputProps(name)}
          id={"client-name-note"}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          value={selectedPatient?.id}
          required={viewOnly || userId ? false : true}
          onChange={(v) => handlePatientChange(v, name)}
          data={allPatients
            ?.filter((_p) => _p?.active === true && _p?.deleted === false)
            ?.map((opt) => ({
              value: opt?.id,
              label: opt?.name,
            }))}
          disabled={view || edit || (viewOnly || userId ? true : false)}
        />
      ),
      Provider: (
        <Select
          size="md"
          radius={"md"}
          className={classes.select}
          searchable
          label={name}
          rightSection={icon}
          defaultValue={form?.getInputProps(name)}
          id={"client-name-note"}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          onChange={(v) => handlePatientChange(v, name)}
          value={selectedPatient?.providerId?.[0]?.id || ""}
          data={
            selectedPatient?.providerId?.length > 0
              ? selectedPatient?.providerId?.map((_p) => ({
                  value: _p?.id,
                  label: _p?.name,
                }))
              : []
          }
          disabled={true}
        />
      ),
      Facilities: (
        <Select
          size="md"
          radius="md"
          className={classes.select}
          searchable
          label={name}
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          onChange={(e) => handleFacilityChange(e, name)}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          required={viewOnly || userId ? false : true}
          data={getOptions(
            "Facilities",
            noteType?.custom,
            undefined,
            view ? true : false
          )?.map((opt) => {
            if (isGroupNoteCreating) return opt;
            if (Array.isArray(selectedPatient?.facilityId)) {
              if (
                selectedPatient?.facilityId?.find(
                  (fac) => fac?.id == opt?.value
                )
              ) {
                return opt;
              } else {
                return { ...opt, disabled: true };
              }
            } else {
              if (selectedPatient?.facilityId?.id == opt?.value) {
                return opt;
              } else {
                return { ...opt, disabled: true };
              }
            }
          })}
        />
      ),
      Staff: (
        <Box className={classes.staffContainer}>
          {/* <Text fw={500}>{name}:</Text> */}
          {view ? (
            <Select
              width={"100%"}
              size="md"
              className={classes.select}
              radius="md"
              rightSection={icon}
              label={name}
              rightSectionPointerEvents="none"
              data={getOptions("Staff All", noteType?.custom)}
              placeholder={`Select ${name}`}
              searchable
              defaultValue={form?.getInputProps(name)}
              {...form.getInputProps(name)}
              disabled={true}
            />
          ) : edit ? (
            <Box className={classes.staffOnEdit}>
              <Grid
                gutter={10}
                // cols={isMobileScreen ? 1 : 3}
                className={classes.mwd}
                sx={{
                  paddingBottom: 30,
                }}
              >
                {!isAdmin && (
                  <Grid.Col span={12}>
                    {/* for staff only */}
                    <Select
                      width={"100%"}
                      size="md"
                      className={classes.select}
                      radius="md"
                      label={name}
                      rightSection={icon}
                      rightSectionPointerEvents="none"
                      data={getOptions("Staff All", noteType?.custom)}
                      placeholder={`Select ${name}`}
                      searchable
                      defaultValue={form?.getInputProps(name)}
                      {...form.getInputProps(name)}
                      disabled={true}
                    />
                  </Grid.Col>
                )}

                {isAdmin && (
                  <>
                    {/* for both main Admin & role with Admin */}
                    {!isGroupNote && (
                      <Grid.Col span={isMobileScreen ? 12 : 6}>
                        <Select
                          width={"100%"}
                          size="md"
                          className={classes.select}
                          radius="md"
                          label={name}
                          rightSection={icon}
                          rightSectionPointerEvents="none"
                          data={getOptions("Staff All", noteType?.custom)}
                          placeholder={`Select ${name}`}
                          searchable
                          defaultValue={form?.getInputProps(name)}
                          {...form.getInputProps(name)}
                          disabled={true}
                        />
                      </Grid.Col>
                    )}

                    <Grid.Col span={isGroupNote || isMobileScreen ? 12 : 6}>
                      <Select
                        size="md"
                        radius="md"
                        label={name}
                        rightSection={icon}
                        className={classes.select}
                        rightSectionPointerEvents="none"
                        data={getOptions("Staff", noteType?.custom)}
                        placeholder={`Select New ${name}`}
                        searchable
                        defaultValue={form?.getInputProps(name)}
                        {...form.getInputProps(name)}
                        disabled={
                          view ||
                          (viewOnly
                            ? true
                            : !edit && profile?.user?.type === "staff"
                            ? true
                            : false)
                        }
                      />
                    </Grid.Col>
                  </>
                )}

                {/* <Grid.Col span={isMobileScreen ? 12 : 6}>
                    <Select
                      width={"100%"}
                      size="md"
                      className={classes.select}
                      radius="md"
                      label={name}
                      rightSection={icon}
                      rightSectionPointerEvents="none"
                      data={getOptions("Staff All", noteType?.custom)}
                      placeholder={`Select ${name}`}
                      searchable
                      defaultValue={form?.getInputProps(name)}
                      {...form.getInputProps(name)}
                      disabled={true}
                    />
                  </Grid.Col>
                  <Grid.Col span={isMobileScreen ? 12 : 6}>
                    <Select
                      size="md"
                      radius="md"
                      label={name}
                      rightSection={icon}
                      className={classes.select}
                      rightSectionPointerEvents="none"
                      data={getOptions("Staff", noteType?.custom)}
                      placeholder={`Select New ${name}`}
                      searchable
                      defaultValue={form?.getInputProps(name)}
                      {...form.getInputProps(name)}
                      disabled={
                        view ||
                        (viewOnly
                          ? true
                          : !edit &&
                            profile?.user?.type === "staff" &&
                            profile?.user?.role !== "admin"
                          ? true
                          : false)
                      }
                      // disabled={
                      //   view ||
                      //   (viewOnly
                      //     ? true
                      //     : !edit && profile?.user?.type === "staff"
                      //     ? true
                      //     : false)
                      // }
                    />
                  </Grid.Col> */}
              </Grid>
            </Box>
          ) : (
            <Select
              size="md"
              radius="md"
              label={name}
              className={classes.select}
              rightSection={icon}
              rightSectionPointerEvents="none"
              data={getOptions("Staff", noteType?.custom)}
              placeholder={`Select ${name}`}
              searchable
              defaultValue={form?.getInputProps(name)}
              {...form.getInputProps(name)}
              disabled={
                view ||
                (viewOnly
                  ? true
                  : !edit &&
                    profile?.user?.type === "staff" &&
                    profile?.user?.role !== "admin"
                  ? true
                  : false)
              }
              // disabled={
              //   view ||
              //   (viewOnly
              //     ? true
              //     : !edit && profile?.user?.type === "staff"
              //     ? true
              //     : false)
              // }
            />
          )}
        </Box>
      ),
      "Facility Types": (
        <Select
          size="xs"
          searchable
          label={name}
          variant="filled"
          rightSection={icon}
          className={classes.select}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("Facility Types", noteType?.custom)}
        />
      ),
      Other: (
        <Select
          size="md"
          radius="md"
          required={data?.field?.toLowerCase() == "shift" ? false : true}
          searchable
          className={classes.select}
          label={name}
          id="enter-shift"
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("Other", noteType?.custom, name)}
        />
      ),
      "Multiple Choice": (
        <Checkbox.Group
          label={name}
          id="enter-shift"
          required={data?.field?.toLowerCase() === "shift" ? false : true}
          {...form.getInputProps(name)}
        >
          {getOptions("multiple choices", noteType?.custom, name)?.map(
            (option) => (
              <Checkbox
                color="gray"
                key={option?.value}
                value={option?.value}
                label={option?.label}
                disabled={view || (viewOnly ? true : false)}
                mt={index === 0 ? "10px" : "10px"}
              />
            )
          )}
        </Checkbox.Group>
      ),
      "Single Choice": (
        <Radio.Group
          label={name}
          id="enter-shift"
          required={data?.field?.toLowerCase() === "shift" ? false : true}
          {...form.getInputProps(name)}
        >
          {getOptions("single choice", noteType?.custom, name)?.map(
            (option) => (
              <Radio
                disabled={view || (viewOnly ? true : false)}
                color="gray"
                key={option?.value}
                value={option?.value}
                label={option?.label}
                mt={index === 0 ? "10px" : "10px"}
              />
            )
          )}
        </Radio.Group>
      ),
      Dropdown: (
        <Select
          size="md"
          radius="md"
          required={data?.field?.toLowerCase() == "shift" ? false : true}
          searchable
          className={classes.select}
          label={name}
          id="enter-shift"
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("dropdown", noteType?.custom, name)}
        />
      ),
      "Medication Records": (
        <Group align="flex-end">
          <Select
            rightSection={icon}
            size="xs"
            searchable
            label={name}
            data={medicationOptions}
            className={classes.select}
            {...form.getInputProps(name)}
            placeholder={`Select ${name}`}
            disabled={view || (viewOnly ? true : false)}
          />
          <Popover
            shadow="md"
            width={300}
            position="bottom-end"
            style={{ marginBottom: "10px" }}
          >
            <Popover.Target>
              <IconInfoCircle
                color="gray"
                styles={{ marginTop: "30px !important" }}
              />
            </Popover.Target>
            <Popover.Dropdown sx={{ pointerEvents: "none" }}>
              <Textarea
                key={`${index}-test`}
                radius="md"
                autosize={true}
                icon={
                  <img
                    className={classes.descriptionIcon}
                    src="/assets/images/home2.png"
                    alt="home"
                  />
                }
                placeholder={
                  placeholder || `Select ${name} to see details here.`
                }
                className={`${classes.myfont} ${classes.descriptionText}`}
                style={{ height: "200px !important", marginTop: "10px" }}
                value={form.values[name]}
                disabled={true}
              />
            </Popover.Dropdown>
          </Popover>
        </Group>
      ),
      "Support Plan": (
        <Group align="flex-end">
          <Select
            size="xs"
            searchable
            label={name}
            data={supportOptions}
            className={classes.select}
            {...form.getInputProps(name)}
            placeholder={`Select ${name}`}
            disabled={view || (viewOnly ? true : false)}
          />
          <Popover
            width={300}
            shadow="md"
            position="bottom-end"
            style={{ marginBottom: "10px" }}
          >
            <Popover.Target>
              <IconInfoCircle
                color="gray"
                styles={{ marginTop: "30px !important" }}
              />
            </Popover.Target>
            <Popover.Dropdown sx={{ pointerEvents: "none" }}>
              <Textarea
                key={`${index}-test`}
                radius="md"
                autosize={true}
                icon={
                  <img
                    className={classes.descriptionIcon}
                    src="/assets/images/home2.png"
                    alt="home"
                  />
                }
                placeholder={
                  placeholder || `Select ${name} to see details here.`
                }
                className={`${classes.myfont} ${classes.descriptionText}`}
                style={{ height: "200px !important", marginTop: "10px" }}
                value={form.values[name]}
                disabled={true}
              />
            </Popover.Dropdown>
          </Popover>
        </Group>
      ),
      "level of need": (
        <Select
          size="md"
          radius="md"
          searchable
          className={classes.select}
          label={name}
          id="enter-shift"
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("level of need", noteType?.custom)}
        />
      ),
    };

    if (
      (essentialSupportToggle === "yes" || interventionPlanToggle === "yes") &&
      name === "Description" &&
      textArea
    )
      return null;
    else if (!textArea && fieldType?.name != "text area")
      return obj[fieldType?.name];
    else if (textArea && fieldType?.name === "text area")
      return obj[fieldType?.name];
    else return null;
    // return obj[fieldType?.name]
  };

  const showRadioButtons =
    (noteType?.name === "Incident Note" &&
      noteType?.name === "Medication Note") ||
    noteType?.name === "Progress Note" ||
    noteType?.custom?.find((_c) => _c?.field === "Support Plan");

  const handleToggleChange = (e, type) => {
    setAiActionsOpen(false);
    setComparePanel(COMPARE_PANEL_RESET);
    setEssentialSupportErrors([]);

    if (type === "interventionPlan") {
      setInterventionPlanToggle(e);
    } else {
      setEssentialSupportToggle(e);
      setAiAssistantCardOpened(false);
      setMessages([]);
      form.setFieldValue("Description", "");
    }
  };

  const validatePromptFields = () => {
    const errors = {};

    if (isGroupNoteCreating ? selectedGroupClients.length === 0 : !selectedPatient?.name) {
      errors.name = isGroupNoteCreating ? "Please select at least one client." : "Client name is required.";
    }

    // const hasNoteDescription = !!noteDetails?.Description;
    // const hasDescriptionsList = descriptions?.some(
    //   (item) => !!item?.description
    // );
    // const hasSupportDescription = !!essentialSupport?.description;

    // if (!hasNoteDescription && !hasDescriptionsList && !hasSupportDescription) {
    //   errors.description = "Description is required.";
    // }


    

    if (!edit && !facilityDetials?.name) {
      errors.facility = "Facility Name is required.";
    }

      if (edit && !facilityDetials) {
      errors.facility = "Facility Name is required.";
    }

    return errors;
  };
  const handleAiAssistantSubmit = (values) => {
    if (values !== "custom-description") {
      const errors = validatePromptFields();
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        return;
      }
    }
    setFormErrors({});
    // if (!messageValue) return;
    // setVisible(false);
    // sendMessageToOpenAI(messageValue);
    setMessageValue("");
    // if(tokensUsage)
    checkTokenUsageWarning(existingRecord, values);
  };

  useEffect(() => {
    form.setFieldValue("noteid", noteType);
  }, [noteType]);

  const noteTypeApproval = noteType?.adminApprovals?.find(
    (item) => item?.admin === profile?.user?.admin
  )
    ? noteType?.adminApprovals?.find(
        (item) => item?.admin === profile?.user?.admin
      )?.status
    : noteType?.approvalRequired;

  const staffSignature = allSignature?.find(
    ({ staff, admin }) =>
      (staff && staff?.id === form.values?.["Staff Name"]) ||
    (admin && admin?.id === form.values?.["Staff Name"])
  );

  // const isStaffWithoutApproval =
  // profile?.user?.type === "staff" && !newAdminApproval;

  return (
    <>
      {/* -----> Pending Modal <----- */}

      {noteType && (
        <CustomModal
          modalState={pendingModal}
          modalTopImg={pendingModalIcon}
          modalTitle={
            noteTypeApproval ? "Pending Approval" : "Note Successfully Saved"
          }
          modalTextOne={
            noteTypeApproval
              ? `The note has been submitted for admin approval.`
              : null
          }
          modalTextTwo={
            noteTypeApproval
              ? `Please check back to see if it was approved or`
              : null
          }
          modalTextThree={noteTypeApproval ? "denied." : null}
          closeModal={setPendingModal}
          colorOne={"yellow"}
          variantOne={"filled"}
          btnTextOne="OK"
          noteType={noteType}
          setNoteType={setNoteType}
        />
      )}

      {/* -----> Note Editid <----- */}

      <CustomModal
        modalState={editModal}
        modalTopImg={pendingModalIcon}
        modalTitle={"Note Edited"}
        modalText={"Note has been edited successfully."}
        closeModal={setEditModal}
        colorOne={"yellow"}
        variantOne={"filled"}
        btnTextOne="OK"
      />

      <Drawer
            shadow="md"
            size={isMobileScreen ? "100%" : 700}
            zIndex={1000}
            opened={opened}
            title={view ? "View" : edit ? "Edit" : "Add Note"}
            overlayProps={{ blur: 3 }}
            className={classes.mymodal}
            closeOnClickOutside={false}
            position="right"
            onClose={() => {
              // Save draft before resetting
              if (!edit && !view) {
                const ntId = NOTETYPE || noteType?.id;
                const cId = selectedPatient?.id || userId;
                const fId = selectedPatient?.facilityId?.id || form?.values?.["Facility Name"];
                if (ntId && cId && fId) {
                  saveNoteDraft({ noteTypeId: ntId, clientId: cId, facilityId: fId, formState: { fields: { ...form.values }, descriptions, essentialSupport, essentialSupportCount, essentialSupportType, essentialSupportNumber, essentialNumber, activities, frequencyOptions, outComeTitle, outcomeNumbers, goals, goalItems, goalOptions, goalNumber, objectivesByGoal, interventionsByGoal, supportPlan, essentialSupportToggle, interventionPlanToggle } }).catch(() => {});
                }
              }
              resetForm();
              setSelectedPatient(null);
              setNoteType(null);
              setOpenedAccordion("0");
              setEssentialAccordion("0");
              setFacilityDetials(null);
              setStaffDetials(null);
              // setView(false);
            }}
          >
            <form
              onSubmit={form?.onSubmit((values) => onSave(values))}
              className={classes.formStyling}
            >
              {/* Auto-save indicator — sticky centered */}
              {!edit && !view && draftStatus !== "idle" && !pendingDraft && (
                <Box style={{ position: "sticky", top: 0, zIndex: 10, textAlign: "center", padding: "10px 0", background: "linear-gradient(180deg, #f5f5f5 80%, transparent)" }}>
                  <Box style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 14px", borderRadius: 20,
                    backgroundColor: "var(--app-surface)", border: "1px solid var(--app-border)", boxShadow: "0px 1px 3px rgba(0,0,0,0.06)" }}>
                    <Box style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "var(--app-primary)" }} />
                    <Text ff="Inter" fz={11} fw={500} c="var(--app-text)">
                      {draftStatus === "saving" && "Saving..."}{draftStatus === "saved" && "Saved"}{draftStatus === "restored" && "Restored"}
                    </Text>
                  </Box>
                </Box>
              )}

              {/* Draft loading — shown while fetching/restoring when opened from Drafts tab */}
              {autoRestoreDraft && draftFetching && !edit && !view && (
                <Box style={{
                  position: "sticky", top: 0, zIndex: 10,
                  background: "var(--app-surface)", borderBottom: "1px solid var(--app-border)",
                  padding: "20px 16px", marginLeft: isMobileScreen ? -12 : -24, marginRight: isMobileScreen ? -12 : -24, marginTop: -8, marginBottom: 8,
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
                }}>
                  <Flex direction="column" align="center" gap={8}>
                    <Loader color="yellow" size="sm" />
                    <Text ff="Inter" fz={13} fw={500} c="var(--app-text-muted)">Loading your draft...</Text>
                  </Flex>
                </Box>
              )}

              {/* Draft recovery banner — only shown when NOT in auto-restore mode */}
              {pendingDraft && !autoRestoreDraft && !edit && !view && (
                <Box style={{
                  position: "sticky", top: 0, zIndex: 10,
                  background: "var(--app-surface)", borderBottom: "1px solid var(--app-border)",
                  padding: "20px 16px", marginLeft: isMobileScreen ? -12 : -24, marginRight: isMobileScreen ? -12 : -24, marginTop: -8, marginBottom: 8,
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
                }}>
                  <Flex direction="column" align="center" gap={4}>
                    <Box style={{ width: 40, height: 40, borderRadius: "50%", backgroundColor: "var(--app-tint-amber)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 4 }}>
                      <IconPencil size={20} color="var(--app-primary)" stroke={2} />
                    </Box>
                    <Text ff="Inter" fz={15} fw={700} c="var(--app-text)">Unsaved Draft Found</Text>
                    <Text ff="Inter" fz={12} fw={400} c="var(--app-text-muted)" mb={8}>Pick up where you left off or start fresh</Text>
                    <Flex gap={10}>
                      <Button radius={8} ff="Inter" fz={14} fw={600}
                        leftIcon={<IconPencil size={15} />}
                        styles={{ root: { backgroundColor: "var(--app-primary)", color: "var(--app-on-primary)", border: "1px solid var(--app-primary)", padding: "8px 24px", height: "auto", boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)", "&:hover": { backgroundColor: "#F5A623" } } }}
                        onClick={restoreDraft}>
                        Continue editing
                      </Button>
                      <Button radius={8} ff="Inter" fz={14} fw={600}
                        leftIcon={<IconTrash size={15} />}
                        styles={{ root: { backgroundColor: "var(--app-bg)", color: "var(--app-text)", border: "1px solid var(--app-bg)", padding: "8px 24px", height: "auto", boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)", "&:hover": { backgroundColor: "var(--app-surface-2)" } } }}
                        onClick={() => setPendingDraft(null)}>
                        Discard
                      </Button>
                    </Flex>
                  </Flex>
                </Box>
              )}

              <NoteTypeComp
                edit={edit}
                view={view}
                noteType={noteType}
                setNoteType={handleNoteTypeChange}
                // setSelectedNote={setSelectedNote}
                className={classes.noteType}
                setEssentialSupportToggle={setEssentialSupportToggle}
                setMessages={setMessages}
                setAiAssistantCardOpened={setAiAssistantCardOpened}
                handleRecordingCancel={handleRecordingCancel}
                setShowAiButtons={setAiActionsOpen}
              />
              {noteType && (
                <Box>
                  <Text
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 600,
                      margin: "16px 0px",
                      color: "var(--app-text)",
                    }}
                  >
                    <span>{`${view ? "View" : edit ? "Edit" : "Add"} ${noteType?.name}`}</span>
                    {isGroupNoteCreating && (
                      <Box component="span" className={classes.gcBadge}>
                        <IconUsers size={13} strokeWidth={2} />
                        Multi-client
                      </Box>
                    )}
                  </Text>
                  <Box className={classes.detailsForm}>
                    <Grid mt={5}>
                      {isGroupNoteCreating ? (
                        <>
                          {/* Staff Name – col 6 */}
                          {noteType?.custom?.filter((v) => v.field === "Staff Name").map((v, i) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6} key={`gn-staff-${i}`}>
                              {ReturnFormItem(v, i)}
                            </Grid.Col>
                          ))}
                          {/* Facility Name – col 6 */}
                          {noteType?.custom?.filter((v) => v.field === "Facility Name").map((v, i) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6} key={`gn-facility-${i}`}>
                              {ReturnFormItem(v, i)}
                            </Grid.Col>
                          ))}
                          {/* Client Name – full width (renders MultiSelect because isGroupNoteCreating) */}
                          {noteType?.custom?.filter((v) => v.field === "Client Name").map((v, i) => (
                            <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12} key={`gn-client-${i}`}>
                              {ReturnFormItem(v, i)}
                            </Grid.Col>
                          ))}
                          {/* Date – col 6 */}
                          {noteType?.custom?.filter((v) => v.fieldType?.name?.toLowerCase() === "date").map((v, i) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6} key={`gn-date-${i}`}>
                              {ReturnFormItem(v, i)}
                            </Grid.Col>
                          ))}
                          {/* Time – col 6 */}
                          {noteType?.custom?.filter((v) => v.fieldType?.name === "time").map((v, i) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6} key={`gn-time-${i}`}>
                              {ReturnFormItem(v, i)}
                            </Grid.Col>
                          ))}
                          {/* Shift – col 6 */}
                          {noteType?.custom?.filter((v) => v.field === "Shift").map((v, i) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6} key={`gn-shift-${i}`}>
                              {ReturnFormItem(v, i)}
                            </Grid.Col>
                          ))}
                          {/* Any remaining half-width fields (e.g. Duration) */}
                          {noteType?.custom
                            ?.filter((v) =>
                              !["Staff Name", "Facility Name", "Client Name", "Shift"].includes(v.field) &&
                              !["date", "time", "text area"].includes(v.fieldType?.name?.toLowerCase())
                            )
                            .map((v, i) => (
                              <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6} key={`gn-extra-${i}`}>
                                {ReturnFormItem(v, i)}
                              </Grid.Col>
                            ))}
                          {/* Description – full width */}
                          {noteType?.custom?.map((v, i) =>
                            ReturnFormItem(v, i, "text area") && (
                              <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12} key={`gn-desc-${i}`}>
                                {ReturnFormItem(v, i, "text area")}
                              </Grid.Col>
                            )
                          )}
                        </>
                      ) : (
                        <>
                          {/* -----> Level of need <----- */}
                      {noteType?.custom?.filter(
                        (value) => value?.field === "Level of Need"
                      ) &&
                        noteType?.custom
                          ?.filter((value) => value.field === "Level of Need")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}
                      {/* -----> Staff Name <----- */}
                      {noteType?.custom?.filter(
                        (value) => value?.field === "Staff Name"
                      ) &&
                        noteType?.custom
                          ?.filter((value) => value.field === "Staff Name")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* -----> Client Name <----- */}

                      {noteType?.custom?.filter(
                        (value) => value?.field === "Client Name"
                      ) &&
                        noteType?.custom
                          ?.filter((value) => value.field === "Client Name")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* -----> Billing <----- */}

                      {isBilling_Services && (
                        <>
                          {/* -----> Provider <----- */}

                          <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                            {noteType?.custom
                              ?.filter((value) => value.field === "Provider")
                              .map((value, index) =>
                                ReturnFormItem(value, index)
                              )}
                          </Grid.Col>

                          {/* -----> Service (Unit Type: Days) <----- */}

                          <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Select
                              size="md"
                              searchable
                              label={"Service (Unit Type: Days)"}
                              radius={"md"}
                              rightSection={icon}
                              // defaultValue={userId}
                              id={"client-name-note"}
                              className={`${classes.select} ${classes.selectBG}`}
                              {...form.getInputProps("Service Type")}
                              placeholder={`Select Service (Unit Type: Days)`}
                              rightSectionPointerEvents="none"
                              required={view || userId ? false : true}
                              onChange={(v) => {
                                handlePatientChange(v, "Service Type");
                              }}
                              data={
                                selectedPatient?.form1?.services?.length > 0
                                  ? selectedPatient?.form1?.services?.map(
                                      (val) => ({
                                        value: val?.servicenumber,
                                        label: val?.servicetitle,
                                      })
                                    )
                                  : []
                              }
                              disabled={view}
                            />
                          </Grid.Col>

                          {/* -----> Unit/Day/Hours <----- */}

                          <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                            {noteType?.custom
                              ?.filter(
                                (value) => value.field === "Unit/Day/Hours"
                              )
                              .map((value, index) =>
                                ReturnFormItem(value, index)
                              )}
                          </Grid.Col>

                          {/* -----> Service Date <----- */}

                          {/* <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                            {noteType?.custom
                              ?.filter(
                                (value) => value.field === "Service Date"
                              )
                              .map((value, index) =>
                                ReturnFormItem(value, index)
                              )}
                          </Grid.Col> */}
                        </>
                      )}

                      {currentNote !== Billing_Services_Note &&
                        noteType?.custom
                          ?.filter((value) => value.field === "Facility Name")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* -----> Date <----- */}
                      {noteType?.custom?.filter(
                        (value) => value.field === "Date"
                      ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value.fieldType?.name?.toLowerCase() === "date"
                          )
                          // ?.filter((value) => value.field === "Date")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}
                      {/* -----> Time <----- */}
                      {noteType?.custom?.filter(
                        // (value) => value.field === "Time"
                        (value) => value.fieldType?.name === "time"
                      ) &&
                        noteType?.custom
                          // ?.filter((value) => value.field === "Time")
                          ?.filter((value) => value.fieldType?.name === "time")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}
                      {/* -----> Shift <----- */}
                      {noteType?.general === true &&
                        noteType?.custom?.filter(
                          (value) => value.field === "Shift"
                        ) &&
                        noteType?.custom
                          ?.filter((value) => value.field === "Shift")
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {isEssentialSupport && (
                        <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Box className={classes.radioGroupParent}>
                            <Text>Use Essential Support</Text>

                            <Tooltip
                              label="Select Facility Name First"
                              placement="bottom"
                              withArrow
                              trigger="hover"
                              disabled={selectedFacility}
                            >
                              <Radio.Group
                                size="xs"
                                value={essentialSupportToggle}
                                name="useSupportPlan"
                                onChange={(value) => {
                                  handleToggleChange(value, "essentialSupport");
                                }}
                                className="radioGroupStyling"
                              >
                                <Group>
                                  <Radio
                                    value="yes"
                                    label="Yes"
                                    id="check-yes"
                                    color="gray"
                                    disabled={view}
                                    variant="outline"
                                  />
                                  <Radio
                                    value="no"
                                    label="No"
                                    color="gray"
                                    disabled={view}
                                    variant="outline"
                                  />
                                </Group>
                              </Radio.Group>
                            </Tooltip>
                          </Box>
                        </Grid.Col>
                      )}

                      {isIntervention_Progress_Note && (
                        <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Box className={classes.radioGroupParent}>
                            <Text>Use Intervention plan</Text>

                            <Tooltip
                              label="Select Facility Name First"
                              placement="bottom"
                              withArrow
                              trigger="hover"
                              disabled={selectedFacility}
                            >
                              <Radio.Group
                                size="xs"
                                value={interventionPlanToggle}
                                name="useInterventionPlan"
                                onChange={(value) => {
                                  handleToggleChange(value, "interventionPlan");
                                }}
                                className="radioGroupStyling"
                              >
                                <Group>
                                  <Radio
                                    value="yes"
                                    label="Yes"
                                    id="check-yes"
                                    color="gray"
                                    disabled={view}
                                    variant="outline"
                                  />
                                  <Radio
                                    value="no"
                                    label="No"
                                    color="gray"
                                    disabled={view}
                                    variant="outline"
                                  />
                                </Group>
                              </Radio.Group>
                            </Tooltip>
                          </Box>
                        </Grid.Col>
                      )}

                      {showRadioButtons && (
                        <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Box className={classes.radioGroupParent}>
                            <Text>Use Support Plan</Text>
                            <Radio.Group
                              size="xs"
                              value={supportPlan}
                              name="useSupportPlan"
                              onChange={handleSupportPlanChange}
                              variant="outline"
                              className="radioGroupStyling"
                            >
                              <Group>
                                <Radio
                                  value="yes"
                                  label="Yes"
                                  id="check-yes"
                                  color="gray"
                                  disabled={view}
                                  variant="outline"
                                />
                                <Radio
                                  value="no"
                                  label="No"
                                  color="gray"
                                  disabled={view}
                                  variant="outline"
                                />
                              </Group>
                            </Radio.Group>
                          </Box>
                        </Grid.Col>
                      )}

                      {/* Custom Field Time */}
                      {/* {noteType?.custom?.filter(
                        (value) =>
                          value?.field_type === "Custom Field" &&
                          value.fieldType?.name === "time"
                      ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value?.field_type === "Custom Field" &&
                              value.fieldType?.name === "time"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))} */}

                      {/* Custom Field Dropdown */}
                      {noteType?.general === false &&
                        noteType?.custom?.filter(
                          (value) => value.fieldType?.name === "Dropdown"
                        ) &&
                        noteType?.custom
                          ?.filter(
                            (value) => value.fieldType?.name === "Dropdown"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* Custom Field Number */}
                      {(noteType?.general === false || isGroupNote) &&
                        noteType?.custom?.filter(
                          (value) =>
                            value?.field_type === "Custom Field" &&
                            value.fieldType?.name === "number"
                        ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value?.field_type === "Custom Field" &&
                              value.fieldType?.name === "number"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* Custom Field Other */}
                      {noteType?.general === false &&
                        noteType?.custom?.filter(
                          (value) =>
                            value?.field_type === "Custom Field" &&
                            value.fieldType?.name?.toLowerCase() === "other"
                        ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value?.field_type === "Custom Field" &&
                              value.fieldType?.name?.toLowerCase() === "other"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* Custom Field Multiple Choice */}
                      {noteType?.custom?.filter(
                        (value) => value.fieldType?.name === "Multiple Choice"
                      ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value.fieldType?.name === "Multiple Choice"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* Custom Field Single Choice */}
                      {noteType?.custom?.filter(
                        (value) => value.fieldType?.name === "Single Choice"
                      ) &&
                        noteType?.custom
                          ?.filter(
                            (value) => value.fieldType?.name === "Single Choice"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* Custom Field String */}
                      {noteType?.general === false &&
                        noteType?.custom?.filter(
                          (value) =>
                            value?.field_type === "Custom Field" &&
                            value.fieldType?.name === "string"
                        ) &&
                        noteType?.custom
                          ?.filter(
                            (value) =>
                              value?.field_type === "Custom Field" &&
                              value.fieldType?.name === "string"
                          )
                          .map((value, index) => (
                            <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                              {ReturnFormItem(value, index)}
                            </Grid.Col>
                          ))}

                      {/* -----> Use Essential Support */}

                      {/* -----> Description <----- */}

                      {supportPlan !== "yes" &&
                        noteType?.name === "Progress Note" &&
                        noteType?.custom?.map(
                          (value, index) =>
                            ReturnFormItem(value, index, "text area") && (
                              <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                {ReturnFormItem(value, index, "text area")}
                              </Grid.Col>
                            )
                        )}
                      {noteType?.name !== "Progress Note" &&
                        noteType?.custom?.map(
                          (value, index) =>
                            ReturnFormItem(value, index, "text area") && (
                              <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                {ReturnFormItem(value, index, "text area")}
                              </Grid.Col>
                            )
                        )}
                        </>
                      )}
                    </Grid>
                  </Box>

                  {view
                    ? null
                    : supportPlan === "yes"
                    ? null
                    : essentialSupportToggle === "yes"
                    ? null
                    : interventionPlanToggle === "yes"
                    ? null
                    : (isEssentialSupport || !isEssentialSupport) && (
                        <>
                          {renderSignature()}
                          <GroupedButtons
                            parentClass={classes.groupedButtonsParent}
                            funcOne={() => {
                              resetForm();
                              cancelForm();
                            }}
                            type="submit"
                            cancelBtnClass={classes.cancelNoteBtn}
                            saveBtnClass={classes.saveNoteBtn}
                            textOne={"Cancel"}
                            textTwo={"Save"}
                          />
                        </>
                      )}

                  {/* support plan map start */}
                  {supportPlan === "yes" &&
                    (noteType?.name === "Progress Note" ||
                      noteType?.custom?.find(
                        (_c) => _c?.field === "Support Plan"
                      )) && (
                      <Box
                        className={[classes.supportPlanAccordion, classes.my]}
                      >
                        {supportPlan === "yes" && (
                          <Box>
                            <Accordion
                              value={openedAccordion}
                              onChange={setOpenedAccordion}
                              chevron={""}
                            >
                              {descriptions?.map((medication, index) => {
                                const labels =
                                  planTypeLabels[medication?.planId];
                                return (
                                  <Accordion.Item
                                    className={[
                                      classes.accordionItem,
                                      classes.addNoteAccordionItem,
                                    ]}
                                    value={`${index}`}
                                  >
                                    <Accordion.Control>
                                      <Flex
                                        align="center"
                                        justify="space-between"
                                        w="100%"
                                        onClick={handleRecordingConfirm}
                                      >
                                        <Text>{`Outcome ${
                                          medication?.details?.outcomeNumber
                                            ? medication?.details?.outcomeNumber
                                            : ""
                                        }`}</Text>
                                        <Flex align="center" gap="8px">
                                          <IconChevronDown
                                            color="gray"
                                            style={{
                                              transition:
                                                "transform 300ms ease-in-out",
                                              transform:
                                                openedAccordion === `${index}`
                                                  ? "rotate(180deg)"
                                                  : "rotate(0deg)",
                                            }}
                                          />
                                          {!view &&
                                            openedAccordion !== `${index}` && (
                                              <Tooltip
                                                label="Delete"
                                                withArrow
                                                position="bottom"
                                              >
                                                <ActionIcon
                                                  color="red"
                                                  variant="transparent"
                                                  onClick={() =>
                                                    removeMedication(
                                                      medication?.id
                                                    )
                                                  }
                                                >
                                                  <RiDeleteBin7Line />
                                                </ActionIcon>
                                              </Tooltip>
                                            )}
                                        </Flex>
                                      </Flex>
                                    </Accordion.Control>
                                    <Accordion.Panel>
                                      <Box
                                        mb={16}
                                        pt={5}
                                        pb={5}
                                        className={classes.deleteBtnParent}
                                      >
                                        <ButtonComp
                                          type=""
                                          text={"Delete"}
                                          icon={
                                            <RiDeleteBin7Line
                                              className={classes.deleteIcon}
                                            />
                                          }
                                          onClick={() =>
                                            removeMedication(medication?.id)
                                          }
                                          btnClass={classes.accordionDeleteBtn}
                                          loading={""}
                                        />
                                      </Box>
                                      <div key={medication?.id}>
                                        {/* view fields */}
                                        {view == true ? (
                                          <Grid
                                            gutter={10}
                                            cols={isMobileScreen ? 1 : 2}
                                            className={classes.mwd}
                                            sx={{
                                              paddingBottom: 30,
                                            }}
                                          >
                                            {/* <Grid.Col
                                              span={isMobileScreen ? 12 : 3}
                                            >
                                              <Box
                                                className={
                                                  classes.outcomeContainer
                                                }
                                              >
                                                <Text
                                                  className={
                                                    classes.outcomeText
                                                  }
                                                >
                                                  {`${
                                                    labels?.addNewButtonLabel ||
                                                    ""
                                                  } Number`}
                                                  <Text c={"red"}>*</Text>
                                                </Text>
                                                <Text
                                                  c={"#909296"}
                                                  ml={10}
                                                  ff={"inter"}
                                                >
                                                  {
                                                    medication?.details
                                                      ?.outcomeNumber
                                                  }
                                                </Text>
                                              </Box>
                                            </Grid.Col> */}
                                            <Grid.Col
                                              span={isMobileScreen ? 12 : 6}
                                            >
                                              <Box
                                                className={
                                                  classes.outcomeContainer
                                                }
                                              >
                                                <Text
                                                  className={
                                                    classes.outcomeText
                                                  }
                                                >
                                                  {`${
                                                    labels?.addNewButtonLabel ||
                                                    ""
                                                  } Title`}
                                                </Text>
                                                <Text
                                                  c={"#909296"}
                                                  ff={"inter"}
                                                  className={
                                                    classes.outcomeTitleView
                                                  }
                                                >
                                                  {" "}
                                                  {
                                                    medication?.details
                                                      ?.outcomeTitle
                                                  }
                                                </Text>
                                              </Box>
                                            </Grid.Col>
                                            <Grid.Col
                                              span={isMobileScreen ? 12 : 6}
                                              mt={6}
                                            >
                                              <Text
                                                className={classes.outcomeText}
                                              >
                                                {`${
                                                  labels?.addNewButtonLabel ||
                                                  ""
                                                } Category`}
                                              </Text>
                                              <Text
                                                c={"#909296"}
                                                ff={"inter"}
                                                className={
                                                  classes.outcomeTitleView
                                                }
                                              >
                                                {" "}
                                                {medication?.outComeCategory}
                                              </Text>
                                              {/* <TextInput
                                                className={classes.input}
                                                label={`${
                                                  labels?.addNewButtonLabel ||
                                                  ""
                                                } Category`}
                                                size="sm"
                                                placeholder="Enter outcome category"
                                                value={
                                                  medication?.outComeCategory
                                                }
                                                disabled
                                              /> */}
                                            </Grid.Col>
                                          </Grid>
                                        ) : (
                                          // Edit fields
                                          <Grid
                                            gutter={10}
                                            cols={isMobileScreen ? 1 : 3}
                                            className={classes.mwd}
                                          >
                                            <Grid.Col xs={12} sm={12} md={6}>
                                              <Select
                                                required
                                                size="sm"
                                                radius={"md"}
                                                className={classes.select}
                                                data={outComeTitle.filter(
                                                  (option) =>
                                                    !descriptions.some(
                                                      (desc) =>
                                                        desc?.id !==
                                                          medication?.id &&
                                                        desc?.outcomeTitle ===
                                                          option?.value
                                                    )
                                                )}
                                                label={
                                                  labels?.outcomeTitleLabel ||
                                                  ""
                                                }
                                                placeholder={`Select ${
                                                  labels?.outcomeTitleLabel ||
                                                  ""
                                                }`}
                                                value={medication?.outcomeTitle}
                                                onChange={(value) => {
                                                  handleMedicationChange(
                                                    medication?.id,
                                                    "outcomeTitle",
                                                    value,
                                                    index
                                                  );
                                                }}
                                                disabled={view}
                                                rightSectionPointerEvents="none"
                                                rightSection={icon}
                                              />
                                              {errors[index] && (
                                                <Text color="red" fz={14}>
                                                  {errors[index]}
                                                </Text>
                                              )}
                                            </Grid.Col>
                                            <Grid.Col xs={12} sm={12} md={6}>
                                              <TextInput
                                                className={classes.input}
                                                radius={"md"}
                                                label={
                                                  labels?.outcomeCategoryLabel ||
                                                  ""
                                                }
                                                size="sm"
                                                placeholder={
                                                  labels?.outcomeCategoryLabel ||
                                                  ""
                                                }
                                                value={
                                                  medication?.outComeCategory
                                                }
                                                disabled
                                              />
                                            </Grid.Col>
                                            {/* -----> Outcome Number <----- */}
                                            <Grid.Col xs={12} sm={12} md={12}>
                                              <Select
                                                id="outcome-number"
                                                size="sm"
                                                radius={"md"}
                                                required
                                                data={outcomeNumbers?.filter(
                                                  (option) =>
                                                    !descriptions?.some(
                                                      (desc) =>
                                                        desc?.id !==
                                                          medication?.id &&
                                                        desc?.outcomeNumber ===
                                                          option.value
                                                    )
                                                )}
                                                label={
                                                  labels?.outcomeNumberLabel ||
                                                  ""
                                                }
                                                // className={classes.selectBG}
                                                placeholder={`Select ${
                                                  labels?.outcomeNumberLabel ||
                                                  ""
                                                }`}
                                                value={
                                                  medication?.outcomeNumber
                                                }
                                                onChange={(value) => {
                                                  handleMedicationChange(
                                                    medication?.id,
                                                    "outcomeNumber",
                                                    value,
                                                    index
                                                  );
                                                }}
                                                disabled={view}
                                                // variant="filled"
                                                rightSectionPointerEvents="none"
                                                rightSection={icon}
                                              />
                                              {errors[index] && (
                                                <Text color="red" fz={14}>
                                                  {errors[index]}
                                                </Text>
                                              )}
                                            </Grid.Col>
                                            {/* <Grid.Col
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              lg={12}
                                              xl={12}
                                            >
                                              <OutcomeNumber
                                                disabled={true}
                                                num={
                                                  medication?.details
                                                    ?.outcomeNumber
                                                }
                                              />
                                            </Grid.Col> */}
                                          </Grid>
                                        )}
                                        <ViewInfo
                                          data={medication}
                                          labels={labels}
                                        />

                                        {/* -----> Was the goal met? <---- */}
                                        <Select
                                          mt={16}
                                          id="about-goal"
                                          size="sm"
                                          radius={"md"}
                                          className={classes.select}
                                          data={[
                                            "Yes",
                                            "No",
                                            "Goal in progress",
                                            "Not Applicable",
                                          ]}
                                          label="Was this goal met?"
                                          placeholder="Select a response"
                                          value={medication?.metGoal}
                                          onChange={(value) => {
                                            handleMedicationChange(
                                              medication?.id,
                                              "metGoal",
                                              value,
                                              index
                                            );
                                          }}
                                          disabled={view}
                                          rightSectionPointerEvents="none"
                                          rightSection={icon}
                                        />
                                        <Box mt={16}>
                                          <Text fz={14} fw={500} c="var(--app-text)" mb={8} ff="Inter">Description</Text>
                                          <Box
                                            sx={{
                                              border: "1px solid #e2e8f0",
                                              borderRadius: 12,
                                              background: "var(--app-surface)",
                                              overflow: "hidden",
                                              boxShadow: "0 1px 2px rgba(16,24,40,.05)",
                                              "&:focus-within": {
                                                borderColor: "#7856ff",
                                                boxShadow: "0 0 0 3px rgba(120,86,255,.16)",
                                              },
                                            }}
                                          >
                                            <Textarea
                                              id="add-note"
                                              size="sm"
                                              maxRows={5}
                                              minRows={10}
                                              placeholder="Enter Note"
                                              styles={{
                                                wrapper: { border: "none", boxShadow: "none", padding: 0, borderRadius: 0 },
                                                input: { border: "none", borderRadius: 0, background: "transparent", padding: "14px 16px", color: "var(--app-text)", fontSize: 14, fontWeight: 400, fontFamily: "Inter", lineHeight: 1.55 },
                                              }}
                                              value={
                                                medication?.description?.length >
                                                0
                                                  ? medication?.description
                                                  : ""
                                              }
                                              onChange={(e) => {
                                                handleMedicationChange(
                                                  medication?.id,
                                                  "description",
                                                  e?.target?.value,
                                                  index
                                                );

                                                let tempNotesArr = outcomeNotes;
                                                tempNotesArr.splice(
                                                  index,
                                                  1,
                                                  e?.target?.value
                                                );
                                                setOutcomeNotes([
                                                  ...tempNotesArr,
                                                ]);
                                              }}
                                              readOnly={view}
                                              autosize={view}
                                            />
                                            {!view && isAiAccess && (
                                              <>
                                                <AiActionButtons
                                                  onMicClick={() => handleMicStart("description")}
                                                  onActionClick={(key) => handleDualCompare(key, `description_${index}`)}
                                                  onSparklesClick={() => setAiActionsOpen((prev) => !prev)}
                                                  onQuickNotesClick={() => setQuickNotesTarget({ key: `description_${index}`, getValue: () => medication?.description, setValue: (v) => handleMedicationChange(medication?.id, "description", v, index) })}
                                                  quickNotesDisabled={quickNotesDisabled}
                                                  micDisabled={view || (existingRecord?.active === false && existingRecord?.paid === false)}
                                                  actionsDisabled={view || !medication?.description?.trim()}
                                                  aiActionsOpen={aiActionsOpen}
                                                />
                                                {comparePanel.open && comparePanel.context === `description_${index}` && (
                                                  <ComparePanel
                                                    action={comparePanel.action}
                                                    option1={comparePanel.option1}
                                                    option2={comparePanel.option2}
                                                    loading1={comparePanel.loading1}
                                                    loading2={comparePanel.loading2}
                                                    option1Model={comparePanel.option1Model}
                                                    option2Model={comparePanel.option2Model}
                                                    ollamaAvailable={comparePanel.ollamaAvailable}
                                                    onArrange={handleArrangeCompare}
                                                    onUse={(text, meta) => handleUseCompareOption(text, `description_${index}`, meta)}
                                                    onCancel={handleCancelCompare}
                                                    onRegenerate={() => handleDualCompare(comparePanel.action, `description_${index}`)}
                                                  />
                                                )}
                                                <QuickNotesPicker
                                                  opened={quickNotesTarget?.key === `description_${index}`}
                                                  close={() => setQuickNotesTarget(null)}
                                                  onInsert={handleQuickNotesInsert}
                                                  hideCarePlan={!hasCarePlan}
                                                />
                                              </>
                                            )}
                                          </Box>
                                        </Box>
                                        <RecordingControls
                                          isListening={isListening}
                                          recordingTime={recordingTime}
                                          onRedo={handleRedo}
                                          onCancel={handleRecordingCancel}
                                          onConfirm={handleRecordingConfirm}
                                          classes={classes}
                                        />
                                        {!view && (
                                          <p
                                            style={{
                                              color: "red",
                                              margin: 0,
                                              padding: 0,
                                            }}
                                          >
                                            {medication?.error}
                                          </p>
                                        )}
                                      </div>
                                    </Accordion.Panel>
                                    <Box
                                      sx={{
                                        border: "1px solid #E4E4E7",
                                        backgroundColor: "var(--app-surface)",
                                      }}
                                    />
                                  </Accordion.Item>
                                );
                              })}
                              {!view && (
                                <>
                                  {renderSignature()}
                                  <GroupedButtons
                                    parentClass={
                                      classes.supportPlanGroupedButtons
                                    }
                                    funcOne={addDescription}
                                    type={"submit"}
                                    cancelBtnClass={classes.cancelNoteBtn}
                                    saveBtnClass={classes.saveNoteBtn}
                                    textOne={"Add New Outcome"}
                                    textTwo={"Save"}
                                    outcomeNumbers={
                                      outcomeNumbers?.length ===
                                      descriptions?.length
                                    }
                                  />
                                </>
                              )}
                            </Accordion>
                          </Box>
                        )}
                      </Box>
                    )}

                  {/* essential plan map start */}
                  {essentialSupportToggle === "yes" && (
                    <Box>
                      <Accordion
                        value={essentialAccordion}
                        onChange={(value) => {
                          if (view === true || edit === true) {
                            let data = essentialSupport?.[value];
                            handleEssentialTypeChangeForNoteView(
                              data?.essentialSupportType,
                              data?.howOftenEssentialSupport
                            );
                          }
                          setEssentialAccordion(value);
                        }}
                        mt={16}
                        variant="separated"
                        chevron={<IconChevronDown size={34} color="var(--app-text)" />}
                        chevronPosition="right"
                        chevronSize={20}
                        className={classes.essentialAccordion}
                        styles={{
                          chevron: {
                            transition: "transform 200ms ease",
                            "&[data-active]": {
                              transform: "rotate(180deg)",
                            },
                          },
                        }}
                      >
                        {Array.isArray(essentialSupport) &&
                          essentialSupport?.map((support, index) => (
                            <Accordion.Item
                              key={support?.id}
                              value={String(index)}
                              className={classes.essentialAccordionItem}
                            >
                              <Accordion.Control>
                                <Box
                                  className={classes.accordionControl}
                                  onClick={handleRecordingConfirm}
                                >
                                  <Text
                                    color="var(--app-text)"
                                    fz={16}
                                    fw={500}
                                    ff="Inter"
                                  >
                                    Essential Support {""}
                                    {support?.essentialNumber
                                      ? support.essentialNumber
                                      : ""}
                                    {/* {index + 1} */}
                                  </Text>
                                </Box>
                              </Accordion.Control>

                              <Accordion.Panel>
                                <Grid
                                  gutter={0}
                                  sx={{
                                    paddingBottom: 26,
                                  }}
                                  className={classes.mwd}
                                >
                                  {!view && (
                                    <Grid.Col span={12}>
                                      <Box
                                        mb={26}
                                        className={classes.outcomeDeleteBTN}
                                      >
                                        <Text
                                          onClick={() =>
                                            removeEssentialSupport(support?.id)
                                          }
                                        >
                                          <AiOutlineDelete size={20} />
                                          Delete
                                        </Text>
                                      </Box>
                                    </Grid.Col>
                                  )}
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={5}
                                    lg={5}
                                    xl={5}
                                  >
                                    <Select
                                      id="essential-support-type"
                                      size="sm"
                                      required
                                      data={essentialSupportTypeState}
                                      // data={
                                      //   selectedSupportType
                                      //     ? essentialSupportTypeState.filter(
                                      //         (item) =>
                                      //           item.value ===
                                      //             support?.essentialSupportType ||
                                      //           item.value !==
                                      //             selectedSupportType
                                      //       )
                                      //     : essentialSupportTypeState
                                      // }
                                      label={"Essential Support Type"}
                                      className={classes.select}
                                      placeholder={"Select Type"}
                                      readOnly={view}
                                      value={
                                        support?.essentialSupportType || ""
                                      }
                                      // disabled={true}
                                      onChange={(value) => {
                                        handleEssentialTypeChange(
                                          support?.id,
                                          "essentialSupportType",
                                          value,
                                          index
                                        );
                                      }}
                                      // error={
                                      //   essentialSupportErrors[index] &&
                                      //   !support?.essentialSupportType &&
                                      //   "Support Type is required"
                                      // }
                                      variant="filled"
                                      // mx={{ base: 0, sm: 17 }}
                                      my={{ base: 26, sm: 0 }}
                                      withAsterisk={false}
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                    />
                                  </Grid.Col>
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={5}
                                    lg={5}
                                    xl={5}
                                  >
                                    <Select
                                      id="essential-support-frequency"
                                      size="sm"
                                      required
                                      data={frequencyOptions || []}
                                      label={"Frequency"}
                                      className={classes.select}
                                      placeholder={"Select Frequency"}
                                      value={
                                        support?.howOftenEssentialSupport || ""
                                      } // ✅ set value
                                      onChange={(value) => {
                                        // setSelectedFrequency(value); // ✅ store user's selection
                                        handleEssentialFrequencyChange(
                                          support?.id,
                                          "howOftenEssentialSupport",
                                          value,
                                          index
                                        );
                                      }}
                                      readOnly={view}
                                      variant="filled"
                                      mx={{ base: 0, sm: 10 }}
                                      my={{ base: 26, sm: 0 }}
                                      withAsterisk={false}
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                    />
                                  </Grid.Col>
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={2}
                                    lg={2}
                                    xl={2}
                                  >
                                    <Select
                                      id="essential-support-outcome-number"
                                      size="sm"
                                      required
                                      data={essentialNumber || []}
                                      label={"Outcome #"}
                                      className={classes.select}
                                      placeholder={"#"}
                                      readOnly={view}
                                      value={support?.essentialNumber || ""} // ✅ set value
                                      onChange={(value) => {
                                        handleEssentialNumberChange(
                                          support?.id,
                                          "essentialNumber",
                                          value,
                                          index
                                        );
                                      }}
                                      variant="filled"
                                      // mx={{ base: 0, sm: 10 }}
                                      // my={{ base: 26, sm: 0 }}
                                      withAsterisk={false}
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                    />
                                    {/* <TextInput
                                      id="essential-support-type"
                                      size="sm"
                                      disabled
                                      label={"Outcome #"}
                                      value={
                                        essentialNumber
                                      }
                                      className={classes.input}
                                      placeholder={"#"}
                                      variant="filled"
                                      withAsterisk={false}
                                    /> */}
                                  </Grid.Col>
                                </Grid>
                                <Grid mb={10}>
                                  <Grid.Col>
                                    <Select
                                      id="essential-support-type"
                                      size="sm"
                                      required
                                      // data={essentialSupportNumber}
                                      // data={activities?.map((activity) => ({
                                      //   label: activity.supportStatement, // Use the support statement as the label
                                      //   value: activity.id, // Use the activity number as the value
                                      // }))}
                                      data={activities
                                        ?.filter(
                                          (activity) =>
                                            // Only show activities not selected in other supports (except this one)
                                            !essentialSupport.some(
                                              (s, i) =>
                                                i !== index &&
                                                s?.essentialActivityNumber ===
                                                  activity.id
                                            )
                                        )
                                        .map((activity) => ({
                                          label: activity?.supportStatement,
                                          value: activity?.id,
                                        }))}
                                      label={"Essential Support Activities"}
                                      className={classes.select}
                                      placeholder={"Select Activities"}
                                      value={
                                        support?.essentialActivityNumber || ""
                                      }
                                      onChange={(value) => {
                                        handleEssentialChange(
                                          support?.id,
                                          "essentialActivityNumber",
                                          value,
                                          index
                                        );
                                      }}
                                      disabled={view}
                                      error={
                                        essentialSupportErrors[index] &&
                                        !support?.essentialActivityNumber &&
                                        "Support Activity is required"
                                      }
                                      withAsterisk={false}
                                      variant="filled"
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                      nothingFound={"Activities already added"}
                                    />
                                  </Grid.Col>
                                </Grid>
                                <EssentialViewInfo
                                  data={support}
                                  className={classes.essentialViewInfoAccordion}
                                />
                                <Text fz={14} fw={500} c="var(--app-text)" mb={8} ff="Inter">Description</Text>
                                <Box
                                  sx={{
                                    border: "1px solid #e2e8f0",
                                    borderRadius: 12,
                                    background: "var(--app-surface)",
                                    overflow: "hidden",
                                    boxShadow: "0 1px 2px rgba(16,24,40,.05)",
                                    "&:focus-within": {
                                      borderColor: "#7856ff",
                                      boxShadow: "0 0 0 3px rgba(120,86,255,.16)",
                                    },
                                  }}
                                >
                                  <Textarea
                                    id="add-note"
                                    size="sm"
                                    maxRows={5}
                                    minRows={10}
                                    placeholder="Enter Note"
                                    styles={{
                                      wrapper: { border: "none", boxShadow: "none", padding: 0, borderRadius: 0 },
                                      input: { border: "none", borderRadius: 0, background: "transparent", padding: "14px 16px", color: "var(--app-text)", fontSize: 14, fontWeight: 400, fontFamily: "Inter", lineHeight: 1.55 },
                                    }}
                                    value={
                                      support?.description?.length > 0
                                        ? support?.description
                                        : ""
                                    }
                                    onChange={(e) => {
                                      handleEssentialSupportDesc(
                                        support?.id,
                                        "description",
                                        e?.target?.value,
                                        index
                                      );
                                      let tempNotesArr = essentialNotes;
                                      tempNotesArr.splice(
                                        index,
                                        1,
                                        e?.target?.value
                                      );
                                      setEssentialNotes([...tempNotesArr]);
                                    }}
                                    readOnly={view}
                                    autosize={view}
                                  />
                                  {!view && isAiAccess && (
                                    <>
                                      <AiActionButtons
                                        onMicClick={() => handleMicStart("essential")}
                                        onActionClick={(key) => handleDualCompare(key, `essential_${index}`)}
                                        onSparklesClick={() => setAiActionsOpen((prev) => !prev)}
                                        onQuickNotesClick={() => setQuickNotesTarget({ key: `essential_${index}`, getValue: () => support?.description, setValue: (v) => handleEssentialSupportDesc(support?.id, "description", v, index) })}
                                        quickNotesDisabled={quickNotesDisabled}
                                        micDisabled={view || (existingRecord?.active === false && existingRecord?.paid === false)}
                                        actionsDisabled={view || !support?.description?.trim()}
                                        aiActionsOpen={aiActionsOpen}
                                      />
                                      {comparePanel.open && comparePanel.context === `essential_${index}` && (
                                        <ComparePanel
                                          action={comparePanel.action}
                                          option1={comparePanel.option1}
                                          option2={comparePanel.option2}
                                          loading1={comparePanel.loading1}
                                          loading2={comparePanel.loading2}
                                          option1Model={comparePanel.option1Model}
                                          option2Model={comparePanel.option2Model}
                                          ollamaAvailable={comparePanel.ollamaAvailable}
                                          onArrange={handleArrangeCompare}
                                          onUse={(text, meta) => handleUseCompareOption(text, `essential_${index}`, meta)}
                                          onCancel={handleCancelCompare}
                                          onRegenerate={() => handleDualCompare(comparePanel.action, `essential_${index}`)}
                                        />
                                      )}
                                      <QuickNotesPicker
                                        opened={quickNotesTarget?.key === `essential_${index}`}
                                        close={() => setQuickNotesTarget(null)}
                                        onInsert={handleQuickNotesInsert}
                                        hideCarePlan={!hasCarePlan}
                                      />
                                    </>
                                  )}
                                </Box>
                                <RecordingControls
                                  isListening={isListening}
                                  recordingTime={recordingTime}
                                  onRedo={handleRedo}
                                  onCancel={handleRecordingCancel}
                                  onConfirm={handleRecordingConfirm}
                                  classes={classes}
                                />
                              </Accordion.Panel>
                            </Accordion.Item>
                          ))}
                      </Accordion>
                    </Box>
                  )}

                  {!view && essentialSupportToggle === "yes" && (
                    <>
                      {renderSignature()}
                      <GroupedButtons
                        parentClass={classes.groupedButtonsParent}
                        funcOne={addEssentialSupport}
                        type={"submit"}
                        cancelBtnClass={classes.cancelNoteBtn}
                        saveBtnClass={classes.saveNoteBtn}
                        textOne={"Add Essential Support"}
                        textTwo={"Save"}
                      />
                    </>
                  )}

                  {/* intervention plan map start */}
                  {interventionPlanToggle === "yes" && (
                    <Box>
                      <Accordion
                        value={goalsAccordion}
                        onChange={(value) => {
                          // if (view === true || edit === true) {
                          //   let data = essentialSupport?.[value];
                          //   handleEssentialTypeChangeForNoteView(
                          //     data?.essentialSupportType,
                          //     data?.howOftenEssentialSupport
                          //   );
                          // }
                          setGoalsAccordion(value);
                        }}
                        mt={16}
                        variant="separated"
                        chevron={<IconChevronDown size={34} color="var(--app-text)" />}
                        chevronPosition="right"
                        chevronSize={20}
                        className={classes.essentialAccordion}
                        styles={{
                          chevron: {
                            transition: "transform 200ms ease",
                            "&[data-active]": {
                              transform: "rotate(180deg)",
                            },
                          },
                        }}
                      >
                        {Array.isArray(goals) &&
                          goals?.map((goalItem, index) => (
                            <Accordion.Item
                              key={goalItem?.id}
                              value={String(index)}
                              className={classes.essentialAccordionItem}
                            >
                              <Accordion.Control>
                                <Box
                                  className={classes.accordionControl}
                                  onClick={handleRecordingConfirm}
                                >
                                  <Text
                                    color="var(--app-text)"
                                    fz={16}
                                    fw={500}
                                    ff="Inter"
                                  >
                                    Goal {""}
                                    {goalItem?.goalNumber
                                      ? goalItem.goalNumber
                                      : index + 1}
                                    {/* {index + 1} */}
                                  </Text>
                                </Box>
                              </Accordion.Control>

                              <Accordion.Panel>
                                <Grid
                                  gutter={26}
                                  sx={{
                                    paddingBottom: 26,
                                  }}
                                  className={classes.mwd}
                                >
                                  {!view && (
                                    <Grid.Col span={12}>
                                      <Box
                                        mb={26}
                                        className={classes.outcomeDeleteBTN}
                                      >
                                        <Text
                                          onClick={() =>
                                            removeGoal(goalItem?.id)
                                          }
                                        >
                                          <AiOutlineDelete size={20} />
                                          Delete
                                        </Text>
                                      </Box>
                                    </Grid.Col>
                                  )}
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={5}
                                    lg={5}
                                    xl={5}
                                  >
                                    <TimeInput
                                      label="Start Time"
                                      className={classes.datePicker}
                                      icon={
                                        <img
                                          style={{ width: "20px" }}
                                          src={"/assets/images/clock.png"}
                                          alt="Icon"
                                        />
                                      }
                                      format="12"
                                      value={goalItem?.startTimeGoal || ""}
                                      onChange={(e) => {
                                        const isSafari =
                                          /^((?!chrome|android).)*safari/i.test(
                                            navigator.userAgent
                                          );
                                        let time = e.target.value
                                          .split(":")
                                          ?.slice(0, 2)
                                          ?.join(":");
                                        isSafari
                                          ? handleEssentialSupportDesc(
                                              goalItem.id,
                                              "startTimeGoal",
                                              time,
                                              index
                                            )
                                          : handleEssentialSupportDesc(
                                              goalItem.id,
                                              "startTimeGoal",
                                              time,
                                              index
                                            );
                                      }}
                                      disabled={view}
                                    />
                                  </Grid.Col>
                                  <Grid.Col span={2}>
                                    <Flex
                                      align="center"
                                      justify="center"
                                      h="100%"
                                      pt={28}
                                    >
                                      <Text fz={25} color="var(--app-text)" fw={400}>
                                        -
                                      </Text>
                                    </Flex>
                                  </Grid.Col>
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={5}
                                    lg={5}
                                    xl={5}
                                  >
                                    <TimeInput
                                      label="End Time"
                                      format="12"
                                      className={classes.datePicker}
                                      icon={
                                        <img
                                          style={{ width: "20px" }}
                                          src={"/assets/images/clock.png"}
                                          alt="Icon"
                                        />
                                      }
                                      value={goalItem?.endTimeGoal || ""}
                                      onChange={(e) => {
                                        const isSafari =
                                          /^((?!chrome|android).)*safari/i.test(
                                            navigator.userAgent
                                          );
                                        let time = e.target.value
                                          .split(":")
                                          ?.slice(0, 2)
                                          ?.join(":");
                                        isSafari
                                          ? handleEssentialSupportDesc(
                                              goalItem.id,
                                              "endTimeGoal",
                                              time,
                                              index
                                            )
                                          : handleEssentialSupportDesc(
                                              goalItem.id,
                                              "endTimeGoal",
                                              time,
                                              index
                                            );
                                      }}
                                      disabled={view}
                                    />
                                  </Grid.Col>
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={10}
                                    lg={10}
                                    xl={10}
                                  >
                                    <Select
                                      id="essential-support-type"
                                      size="sm"
                                      required
                                      data={goalOptions.filter(
                                        (g) =>
                                          !goals.some(
                                            (gi) =>
                                              gi.identifiedGoal === g.value &&
                                              gi.id !== goalItem.id
                                          )
                                      )}
                                      label={"Identified Goals"}
                                      className={classes.select}
                                      placeholder={"Select Identified Goals"}
                                      readOnly={view}
                                      value={goalItem?.identifiedGoal || ""}
                                      // disabled={true}
                                      onChange={(value) => {
                                        handleEssentialTypeChange(
                                          goalItem?.id,
                                          "identifiedGoal",
                                          value,
                                          index
                                        );
                                      }}
                                      // error={
                                      //   essentialSupportErrors[index] &&
                                      //   !goalItem?.identifiedGoal &&
                                      //   "Support Type is required"
                                      // }
                                      variant="filled"
                                      // mx={{ base: 0, sm: 17 }}
                                      my={{ base: 26, sm: 0 }}
                                      withAsterisk={false}
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                    />
                                  </Grid.Col>
                                  <Grid.Col
                                    xs={12}
                                    sm={12}
                                    md={2}
                                    lg={2}
                                    xl={2}
                                  >
                                    <Select
                                      id="essential-goalItem-outcome-number"
                                      size="sm"
                                      required
                                      data={goalNumber || []}
                                      label={"Goal #"}
                                      className={classes.select}
                                      placeholder={"#"}
                                      readOnly={view}
                                      value={goalItem?.goalNumber || ""} // ✅ set value
                                      onChange={(value) => {
                                        handleEssentialNumberChange(
                                          goalItem?.id,
                                          "goalNumber",
                                          value,
                                          index
                                        );
                                      }}
                                      variant="filled"
                                      withAsterisk={false}
                                      rightSectionPointerEvents="none"
                                      rightSection={icon}
                                    />
                                  </Grid.Col>
                                </Grid>

                                {goalItems[index]?.map((_gi, gIndex) => (
                                  <Grid key={_gi.id} mb={10}>
                                    <Grid.Col
                                      xs={12}
                                      sm={12}
                                      md={!view ? 11 : 12}
                                      lg={!view ? 11 : 12}
                                      xl={!view ? 11 : 12}
                                    >
                                      <Box
                                        className={classes.interventionGoalItem}
                                      >
                                        {view ? (
                                          <Box className={classes.goalItemsBox}>
                                            <Text
                                              size="sm"
                                              fw={500}
                                              ff={"Inter"}
                                            >
                                              Objective
                                            </Text>
                                            <Text size="sm" ff={"Inter"}>
                                              {_gi?.objectives || ""}
                                            </Text>
                                          </Box>
                                        ) : (
                                          <Select
                                            id={`essential-goalItem-type-${_gi.id}`}
                                            size="sm"
                                            required
                                            data={objectivesByGoal?.filter(
                                              (o) =>
                                                !goalItems[index].some(
                                                  (g) =>
                                                    g?.objectives ===
                                                      o?.value &&
                                                    g.id !== _gi.id
                                                )
                                            )}
                                            // data={objectivesByGoal}
                                            label="Objective"
                                            className={classes.select}
                                            placeholder="Select Objective"
                                            readOnly={view}
                                            value={_gi?.objectives || ""}
                                            onChange={(value) =>
                                              handleGoalActivityChange(
                                                _gi.id,
                                                "objectives",
                                                value,
                                                gIndex,
                                                index
                                              )
                                            }
                                            mb={10}
                                            withAsterisk={false}
                                            rightSectionPointerEvents="none"
                                            rightSection={icon}
                                          />
                                        )}

                                        {view ? (
                                          <Box className={classes.goalItemsBox}>
                                            <Text
                                              size="sm"
                                              fw={500}
                                              ff={"Inter"}
                                            >
                                              Intervention Instruction
                                            </Text>
                                            <Text size="sm" ff={"Inter"}>
                                              {_gi?.Intervention_Instruction ||
                                                ""}
                                            </Text>
                                          </Box>
                                        ) : (
                                          <Select
                                            id={`essential-goalItem-frequency-${goalItem.id}`}
                                            size="sm"
                                            required
                                            data={interventionsByGoal.filter(
                                              (i) =>
                                                !goalItems[index].some(
                                                  (g) =>
                                                    g.Intervention_Instruction ===
                                                      i.value && g.id !== _gi.id
                                                )
                                            )}
                                            // data={interventionsByGoal}
                                            label="Intervention"
                                            className={classes.select}
                                            placeholder="Select Intervention"
                                            value={
                                              _gi?.Intervention_Instruction ||
                                              ""
                                            }
                                            onChange={(value) =>
                                              handleGoalActivityChange(
                                                _gi.id,
                                                "Intervention_Instruction",
                                                value,
                                                gIndex,
                                                index
                                              )
                                            }
                                            readOnly={view}
                                            withAsterisk={false}
                                            rightSectionPointerEvents="none"
                                            rightSection={icon}
                                          />
                                        )}
                                      </Box>
                                    </Grid.Col>

                                    {!view && (
                                      <Grid.Col xs={12} sm={12} md={1} gap={10}>
                                        <Flex
                                          direction="column"
                                          gap={10}
                                          justify="center"
                                          align="center"
                                          h="100%"
                                        >
                                          <Button
                                            onClick={() =>
                                              handleAddGoalItem(index)
                                            }
                                            className={
                                              classes.interventionAddGoalItem
                                            }
                                            disabled={view || isAddDisabled}
                                            sx={{
                                              opacity:
                                                view || isAddDisabled ? 0.5 : 1,
                                              pointerEvents:
                                                view || isAddDisabled
                                                  ? "none"
                                                  : "auto",
                                              cursor:
                                                view || isAddDisabled
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                          >
                                            <TbPlus
                                              size={15}
                                              color="var(--app-text)"
                                            />
                                          </Button>
                                          <Button
                                            onClick={() =>
                                              handleRemoveGoalItem(
                                                _gi.id,
                                                index
                                              )
                                            }
                                            className={
                                              classes.interventionAddGoalItem
                                            }
                                            disabled={
                                              goalItems[index]?.length === 1
                                            } // keep at least 1 row
                                            sx={{
                                              opacity:
                                                goalItems[index]?.length === 1
                                                  ? 0.5
                                                  : 1,
                                              pointerEvents:
                                                goalItems[index]?.length === 1
                                                  ? "none"
                                                  : "auto",
                                              cursor:
                                                goalItems[index]?.length === 1
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                          >
                                            <TbTrash
                                              size={15}
                                              color="var(--app-text)"
                                            />
                                          </Button>
                                        </Flex>
                                      </Grid.Col>
                                    )}
                                  </Grid>
                                ))}

                                {/* Behavior Description */}
                                <Text fz={14} fw={500} c="var(--app-text)" mb={8} ff="Inter">Behavior</Text>
                                <Box
                                  sx={{
                                    border: "1px solid #e2e8f0",
                                    borderRadius: 12,
                                    background: "var(--app-surface)",
                                    overflow: "hidden",
                                    boxShadow: "0 1px 2px rgba(16,24,40,.05)",
                                    "&:focus-within": {
                                      borderColor: "#7856ff",
                                      boxShadow: "0 0 0 3px rgba(120,86,255,.16)",
                                    },
                                  }}
                                >
                                  <Textarea
                                    id="add-note"
                                    size="sm"
                                    maxRows={5}
                                    minRows={10}
                                    placeholder="Enter behavior"
                                    styles={{
                                      wrapper: { border: "none", boxShadow: "none", padding: 0, borderRadius: 0 },
                                      input: { border: "none", borderRadius: 0, background: "transparent", padding: "14px 16px", color: "var(--app-text)", fontSize: 14, fontWeight: 400, fontFamily: "Inter", lineHeight: 1.55 },
                                    }}
                                    value={
                                      goalItem?.behaviorDescription?.length > 0
                                        ? goalItem?.behaviorDescription
                                        : ""
                                    }
                                    onChange={(e) => {
                                      handleEssentialSupportDesc(
                                        goalItem?.id,
                                        "behaviorDescription",
                                        e?.target?.value,
                                        index
                                      );
                                      let tempNotesArr = essentialNotes;
                                      tempNotesArr.splice(
                                        index,
                                        1,
                                        e?.target?.value
                                      );
                                      setEssentialNotes([...tempNotesArr]);
                                    }}
                                    readOnly={view}
                                    autosize={view}
                                  />
                                  {!view && isAiAccess && (
                                    <>
                                      <AiActionButtons
                                        onMicClick={() => handleMicStart("behavior")}
                                        onActionClick={(key) => handleDualCompare(key, "behavior")}
                                        onSparklesClick={() => handleDualCompare("behavior", "behavior")}
                                        onQuickNotesClick={() => setQuickNotesTarget({ key: "behavior", getValue: () => goalItem?.behaviorDescription, setValue: (v) => handleEssentialSupportDesc(goalItem?.id, "behaviorDescription", v, index) })}
                                        quickNotesDisabled={quickNotesDisabled}
                                        micDisabled={view || micLabel === "plan" || micLabel === "response" || (existingRecord?.active === false && existingRecord?.paid === false)}
                                        actionsDisabled={view || !goalItem?.behaviorDescription?.trim()}
                                        aiActionsOpen={false}
                                        sparklesActive={comparePanel.open && comparePanel.context === "behavior"}
                                      />
                                      {comparePanel.open && comparePanel.context === "behavior" && (
                                        <ComparePanel
                                          action={comparePanel.action}
                                          option1={comparePanel.option1}
                                          option2={comparePanel.option2}
                                          loading1={comparePanel.loading1}
                                          loading2={comparePanel.loading2}
                                          option1Model={comparePanel.option1Model}
                                          option2Model={comparePanel.option2Model}
                                          ollamaAvailable={comparePanel.ollamaAvailable}
                                          onArrange={handleArrangeCompare}
                                          onUse={(text, meta) => handleUseCompareOption(text, "behavior", meta)}
                                          onCancel={handleCancelCompare}
                                          onRegenerate={() => handleDualCompare(comparePanel.action, "behavior")}
                                        />
                                      )}
                                      <QuickNotesPicker
                                        opened={quickNotesTarget?.key === "behavior"}
                                        close={() => setQuickNotesTarget(null)}
                                        onInsert={handleQuickNotesInsert}
                                        hideCarePlan={!hasCarePlan}
                                      />
                                    </>
                                  )}
                                </Box>
                                <RecordingControls
                                  isListening={
                                    micLabel === "behavior" ? true : false
                                  }
                                  recordingTime={recordingTime}
                                  onRedo={() => handleRedo("behavior")}
                                  onCancel={() =>
                                    handleRecordingCancel("behavior")
                                  }
                                  onConfirm={() =>
                                    handleRecordingConfirm("behavior")
                                  }
                                  classes={classes}
                                />
                                {/* Response Description */}
                                <Text fz={14} fw={500} c="var(--app-text)" mb={8} mt={10} ff="Inter">Response</Text>
                                <Box
                                  sx={{
                                    border: "1px solid #e2e8f0",
                                    borderRadius: 12,
                                    background: "var(--app-surface)",
                                    overflow: "hidden",
                                    boxShadow: "0 1px 2px rgba(16,24,40,.05)",
                                    "&:focus-within": {
                                      borderColor: "#7856ff",
                                      boxShadow: "0 0 0 3px rgba(120,86,255,.16)",
                                    },
                                  }}
                                >
                                  <Textarea
                                    id="add-note"
                                    size="sm"
                                    maxRows={5}
                                    minRows={10}
                                    placeholder="Enter Response"
                                    styles={{
                                      wrapper: { border: "none", boxShadow: "none", padding: 0, borderRadius: 0 },
                                      input: { border: "none", borderRadius: 0, background: "transparent", padding: "14px 16px", color: "var(--app-text)", fontSize: 14, fontWeight: 400, fontFamily: "Inter", lineHeight: 1.55 },
                                    }}
                                    value={
                                      goalItem?.responseDescription?.length > 0
                                        ? goalItem?.responseDescription
                                        : ""
                                    }
                                    onChange={(e) => {
                                      handleEssentialSupportDesc(
                                        goalItem?.id,
                                        "responseDescription",
                                        e?.target?.value,
                                        index
                                      );
                                    }}
                                    readOnly={view}
                                    autosize={view}
                                  />
                                  {!view && isAiAccess && (
                                    <>
                                      <AiActionButtons
                                        onMicClick={() => handleMicStart("response")}
                                        onActionClick={(key) => handleDualCompare(key, "response")}
                                        onSparklesClick={() => handleDualCompare("response", "response")}
                                        onQuickNotesClick={() => setQuickNotesTarget({ key: "response", getValue: () => goalItem?.responseDescription, setValue: (v) => handleEssentialSupportDesc(goalItem?.id, "responseDescription", v, index) })}
                                        quickNotesDisabled={quickNotesDisabled}
                                        micDisabled={view || micLabel === "behavior" || micLabel === "plan" || (existingRecord?.active === false && existingRecord?.paid === false)}
                                        actionsDisabled={view || !goalItem?.responseDescription?.trim()}
                                        aiActionsOpen={false}
                                        sparklesActive={comparePanel.open && comparePanel.context === "response"}
                                      />
                                      {comparePanel.open && comparePanel.context === "response" && (
                                        <ComparePanel
                                          action={comparePanel.action}
                                          option1={comparePanel.option1}
                                          option2={comparePanel.option2}
                                          loading1={comparePanel.loading1}
                                          loading2={comparePanel.loading2}
                                          option1Model={comparePanel.option1Model}
                                          option2Model={comparePanel.option2Model}
                                          ollamaAvailable={comparePanel.ollamaAvailable}
                                          onArrange={handleArrangeCompare}
                                          onUse={(text, meta) => handleUseCompareOption(text, "response", meta)}
                                          onCancel={handleCancelCompare}
                                          onRegenerate={() => handleDualCompare(comparePanel.action, "response")}
                                        />
                                      )}
                                      <QuickNotesPicker
                                        opened={quickNotesTarget?.key === "response"}
                                        close={() => setQuickNotesTarget(null)}
                                        onInsert={handleQuickNotesInsert}
                                        hideCarePlan={!hasCarePlan}
                                      />
                                    </>
                                  )}
                                </Box>
                                <RecordingControls
                                  isListening={
                                    micLabel === "response" ? true : false
                                  }
                                  recordingTime={recordingTime}
                                  onRedo={() => handleRedo("response")}
                                  onCancel={() =>
                                    handleRecordingCancel("response")
                                  }
                                  onConfirm={() =>
                                    handleRecordingConfirm("response")
                                  }
                                  classes={classes}
                                />

                                {/* Plan description */}
                                <Text fz={14} fw={500} c="var(--app-text)" mb={8} mt={10} ff="Inter">Plan</Text>
                                <Box
                                  sx={{
                                    border: "1px solid #e2e8f0",
                                    borderRadius: 12,
                                    background: "var(--app-surface)",
                                    overflow: "hidden",
                                    boxShadow: "0 1px 2px rgba(16,24,40,.05)",
                                    "&:focus-within": {
                                      borderColor: "#7856ff",
                                      boxShadow: "0 0 0 3px rgba(120,86,255,.16)",
                                    },
                                  }}
                                >
                                  <Textarea
                                    id="add-note"
                                    size="sm"
                                    mt={0}
                                    maxRows={5}
                                    minRows={10}
                                    placeholder="Enter Plan"
                                    styles={{
                                      wrapper: { border: "none", boxShadow: "none", padding: 0, borderRadius: 0 },
                                      input: { border: "none", borderRadius: 0, background: "transparent", padding: "14px 16px", color: "var(--app-text)", fontSize: 14, fontWeight: 400, fontFamily: "Inter", lineHeight: 1.55 },
                                    }}
                                    value={
                                      goalItem?.planDescription?.length > 0
                                        ? goalItem?.planDescription
                                        : ""
                                    }
                                    onChange={(e) => {
                                      handleEssentialSupportDesc(
                                        goalItem?.id,
                                        "planDescription",
                                        e?.target?.value,
                                        index
                                      );
                                    }}
                                    readOnly={view}
                                    autosize={view}
                                  />
                                  {!view && isAiAccess && (
                                    <>
                                      <AiActionButtons
                                        onMicClick={() => handleMicStart("plan")}
                                        onActionClick={(key) => handleDualCompare(key, "plan")}
                                        onSparklesClick={() => handleDualCompare("plan", "plan")}
                                        onQuickNotesClick={() => setQuickNotesTarget({ key: "plan", getValue: () => goalItem?.planDescription, setValue: (v) => handleEssentialSupportDesc(goalItem?.id, "planDescription", v, index) })}
                                        quickNotesDisabled={quickNotesDisabled}
                                        micDisabled={view || micLabel === "behavior" || micLabel === "response" || (existingRecord?.active === false && existingRecord?.paid === false)}
                                        actionsDisabled={view || !goalItem?.planDescription?.trim()}
                                        aiActionsOpen={false}
                                        sparklesActive={comparePanel.open && comparePanel.context === "plan"}
                                      />
                                      {comparePanel.open && comparePanel.context === "plan" && (
                                        <ComparePanel
                                          action={comparePanel.action}
                                          option1={comparePanel.option1}
                                          option2={comparePanel.option2}
                                          loading1={comparePanel.loading1}
                                          loading2={comparePanel.loading2}
                                          option1Model={comparePanel.option1Model}
                                          option2Model={comparePanel.option2Model}
                                          ollamaAvailable={comparePanel.ollamaAvailable}
                                          onArrange={handleArrangeCompare}
                                          onUse={(text, meta) => handleUseCompareOption(text, "plan", meta)}
                                          onCancel={handleCancelCompare}
                                          onRegenerate={() => handleDualCompare(comparePanel.action, "plan")}
                                        />
                                      )}
                                      <QuickNotesPicker
                                        opened={quickNotesTarget?.key === "plan"}
                                        close={() => setQuickNotesTarget(null)}
                                        onInsert={handleQuickNotesInsert}
                                        hideCarePlan={!hasCarePlan}
                                      />
                                    </>
                                  )}
                                </Box>
                                <RecordingControls
                                  isListening={
                                    micLabel === "plan" ? true : false
                                  }
                                  recordingTime={recordingTime}
                                  onRedo={() => handleRedo("plan")}
                                  onCancel={() => handleRecordingCancel("plan")}
                                  onConfirm={() =>
                                    handleRecordingConfirm("plan")
                                  }
                                  classes={classes}
                                />
                                <Select
                                  mt={16}
                                  id="about-goal"
                                  size="sm"
                                  radius={"md"}
                                  className={classes.select}
                                  data={[
                                    "Yes",
                                    "No",
                                    "Goal in progress",
                                    "Not Applicable",
                                  ]}
                                  label="Was this goal met?"
                                  placeholder="Select a response"
                                  value={goalItem?.metGoalIntervention}
                                  onChange={(value) => {
                                    handleEssentialSupportDesc(
                                      goalItem?.id,
                                      "metGoalIntervention",
                                      value,
                                      index
                                    );
                                  }}
                                  disabled={view}
                                  rightSectionPointerEvents="none"
                                  rightSection={icon}
                                />
                              </Accordion.Panel>
                            </Accordion.Item>
                          ))}
                      </Accordion>
                    </Box>
                  )}

                  {!view && interventionPlanToggle === "yes" && (
                    <>
                      {renderSignature()}
                      <GroupedButtons
                        parentClass={classes.groupedButtonsParent}
                        funcOne={addNewGoal}
                        type={"submit"}
                        cancelBtnClass={classes.cancelNoteBtn}
                        saveBtnClass={classes.saveNoteBtn}
                        textOne={"Add New Goal"}
                        textTwo={"Save"}
                      />
                    </>
                  )}

                  {profile?.user?.type === "staff" &&
                    data?.data?.approvalStatus === "pending" && (
                      <Box className={classes.rejectedNote}>
                        <Box className={classes.rejectionIconBox}>
                          <NotePendingSvg />
                          <Text ff={"Inter"} fz={14} fw={500} color="var(--app-text)">
                            Pending Approval
                          </Text>
                        </Box>
                      </Box>
                    )}
                </Box>
              )}

            </form>
      </Drawer>
    </>
  );
};

export default NoteDrawer;
